'use strict';

var BlimpExtListingUtilities = new Class({
	Extends: BlimpExt,
	options: {
		pg_width_by_thumbs: 5,
		data: null
	},

	post_process_build: function post_process_build() {
		this.parent();
		if (!this.first_load) {
			this.set_default_view();
		} else {
			if (this._link.hasClass('gallery_link')) {
				this.status_view = 'pg';
			} else if (this._link.hasClass('floorplan_link')) {
				this.status_view = 'fp';
			} else {
				this.status_view = 'mp';
			}

			if (this.status_view == 'mp') {
				this._monitor = this._element.getElement('.map_container');
				this.initialize_map();
			} else {
				this._monitor = this._element.getElement('.photogallery_container');
				this.create_gallery();
			}

			this.add_links();
		}

		this.first_load = false;
	},

	add_links: function add_links() {
		var _link_container = this._element.getElement('.link_container');

		if (!_link_container || !_link_container.hasClass('_for_listing')) return;

		this._contact_btn = _link_container.getElement('.contact_btn a');

		if (!this._link.getParent('.lst') || !this._link.getParent('.lst').getElement('.map_view') && !this._contact_btn && (this.data.photos.length == 0 || this.data.floorplan.length == 0)) {
			_link_container.dispose();
		} else {
			if (this._link.getParent('.lst').getElement('.map_view')) {
				this._mp_link = new Element('a', {
					'href': '#',
					'text': 'View Map',
					'class': 'map_view raquo ' + (this.status_view == 'mp' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.map_view').getAttribute('data-rpc-map')
				}).inject(_link_container, 'top');
			}

			if (this._link.getParent('.lst').getElement('.floorplan_link') || this.data.floorplan && this.data.floorplan.length > 0) {
				this._fp_link = new Element('a', {
					'href': '#',
					'text': 'View Floorplan',
					'class': 'floorplan raquo ' + (this.status_view == 'fp' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.floorplan_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}

			if (this._link.getParent('.lst').getElement('.gallery_link') || this.data.photos && this.data.photos.length > 0) {
				this._pg_link = new Element('a', {
					'href': '#',
					'text': 'View Photo Gallery',
					'class': 'photogallery raquo ' + (this.status_view == 'pg' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.gallery_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}
		}

		// to have some space so the contact btn wont overlapped with the gallery widget if theres no listed by and managed by
		if (this._pg_link && this._fp_link && this._mp_link && _link_container.getElement('.contact_btn') && !this._element.getElement('.listed_by') && !this._element.getElement('.managed_by')) {

			var _header = this._element.getElement('h3');

			if (_header) _header.setStyle('padding-bottom', 30);
		}

		this.add_links_functionality();
	},

	add_links_functionality: function add_links_functionality() {
		var _fp, _pg, _mp;

		if (this._fp_link) {
			this._fp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (this.status_view == 'mp') {
					_mp = this._monitor.getElement('.map');
				}

				if (_mp) _mp.dispose();

				if (!_fp) {
					var data = null;

					if (this.data.floorplan) {
						data = {
							photos: this.data.floorplan,
							content: this.data.content
						};
					}

					this.initialize_gallery(this._monitor, data);
					_fp = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_fp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._fp_link.addClass('_active');
				this.status_view = 'fp';
			}.bind(this));
		}

		if (this._pg_link) {
			this._pg_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (this.status_view == 'mp') {
					_mp = this._monitor.getElement('.map');
				}

				if (_mp) _mp.dispose();

				if (!_pg) {
					var data = this.data.photos ? this.data : null;

					this.initialize_gallery(this._monitor, data);
					_pg = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_pg);
				}

				if (this._fp_link) this._fp_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._pg_link.addClass('_active');
				this.status_view = 'pg';
			}.bind(this));
		}

		if (this._mp_link) {
			this._mp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (!_mp) {
					this.initialize_map();
					_mp = this._monitor.getElement('.map');
				} else {
					this._monitor.adopt(_mp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._fp_link) this._fp_link.removeClass('_active');

				this._mp_link.addClass('_active');
				this.status_view = 'mp';
			}.bind(this));
		}

		if (this._contact_btn && this._link.getParent('.ava_apts')) {
			new Blimp.Form(this._contact_btn, { draggable: true, allow_others: true });
		}
	},

	set_default_view: function set_default_view() {
		if (this._element.getElement('.w_popup').hasClass('floorplan') && this.status_view != 'fp') {
			if (this._fp_link) this._fp_link.fireEvent('click');
		} else if (this._element.getElement('.w_popup').hasClass('photogallery') && this.status_view != 'pg') {
			if (this._pg_link) this._pg_link.fireEvent('click');
		} else if (this.status_view != 'mp') {
			if (this._mp_link) this._mp_link.fireEvent('click');
		}
	},

	create_gallery: function create_gallery() {
		if (!this.photogallery) {
			var fp_data;
			this.data = this.data || this.options.data;

			if (this._element.getElement('.w_popup').hasClass('floorplan') && this.data.floorplan) {
				fp_data = {
					photos: this.data.floorplan && this.data.floorplan.length > 0 ? this.data.floorplan : this.data.photos,
					content: this.data.content
				};
			}

			var _phg = this._element.getElement('.w_photogallery');

			var data = fp_data || this.data;

			this.initialize_gallery(_phg, data);

			//this.photogallery.popup = this;
		}
	},

	initialize_gallery: function initialize_gallery(_element, data) {
		var self = this;

		if (data) {
			new PagePhotogallery(_element, {
				data: data,
				thumbs_amount: this.options.width_by_thumbs,
				no_fullscreen_opt: true
			});
		} else {
			var rpc;

			if (this.status_view == 'fp') {
				rpc = this._fp_link.getAttribute('data-rpc');
			} else {
				rpc = this._pg_link.getAttribute('data-rpc');
			}

			self.remote = new Remote({
				rpc: rpc,
				method: 'get',
				onSuccess: function onSuccess() {
					var data = this.get_data();

					self.data.content = data.content;
					self.data.photos = data.photos;
					self.data.floorplan = data.floorplan;

					if (self.status_view == 'fp') {
						data = {
							photos: data.floorplan,
							content: data.content
						};
					}

					new PagePhotogallery(_element, {
						data: data,
						thumbs_amount: self.options.width_by_thumbs,
						no_fullscreen_opt: true
					});
				}
			});
		}
	},

	initialize_map: function initialize_map() {
		var self = this;
		var rpc = this._mp_link ? this._mp_link.getAttribute('data-rpc') : this._link.getAttribute('data-rpc-map');
		var _map = new Element('div', {
			'class': 'map'
		}).inject(this._monitor);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function onSuccess() {
				var data = this.get_data();

				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	}
});
'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

var GeneralMap = new Class({
	Extends: SimpleMap,

	options: {
		data: null,
		has_main_building: false,
		previous_state: null,
		page_context: null,
		view: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element;

		this.state = new State();

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var self = this;
		this.isFirstLoading = true;
		this.data = this.options.data;

		this.addEvent('mapReady', function () {
			self.process_data(self.options.previous_state);
			if (self.options.has_main_building) {
				self.add_main_building();
			}
		});
		this.parent();
	},

	refresh_data: function refresh_data(data) {
		this.data = data;
		this.isFirstLoading = false;
		this.options.previous_state = null;
		this.clear_markers();
		if (this.map.current_marker) {
			this.has_opened_bubble = false;
			this.map.current_marker.marker.bubble.close();
		}
		this.process_data();
	},

	process_data: function process_data(previousState) {
		var self = this;
		var data = this.data;

		Object.each(data.listings, function (list) {
			Object.each(list.data, function (place, i) {
				if (data.base_location && i == data.base_location.id) return;

				if (!self.in_new_york(place.lat, place.lng)) return;

				var icon = Res_i + '/w/hoods/bed-markers/' + (place.total > 5 ? '5' : place.total) + '_beds_12.png';

				var currentBuildingId = 'building-' + i;

				// set if you want to open the tooltip for this marker
				var initOpen = previousState && previousState.building_id === currentBuildingId ? true : false;

				var sm_marker = self.add_marker({
					id: currentBuildingId,
					init_open: initOpen,
					lat: place.lat,
					lng: place.lng,
					icon: icon,
					bubble: {
						content: self.get_bubble_content(place.name, place.address, place.type, place.data),
						add_class: '_big',
						offset: {
							x: 16,
							y: -45
						},
						side: 'right'
					},
					hover_icon: Res_i + '/w/hoods/bed-markers/' + (place.total > 5 ? '5' : place.total) + '_beds_11.png',
					label: {
						content: ' ',
						add_class: 'marker-label marker-id-' + i
					},
					base_point: 'center',
					center_on_click: self.options.center_on_click,
					onBubbleReady: function onBubbleReady(_el) {
						if (place.bubble_is_ready) return;

						var _ul = _el.getElement('ul');

						_el.addEvents({
							'mouseenter': function mouseenter() {
								self.in_bubble = true;
							},

							'mouseleave': function mouseleave() {
								self.in_bubble = false;
							}
						});

						if (_ul && _ul.getSize().y > _el.getSize().y) {
							_ul.setStyles({
								'overflow-y': 'scroll',
								'max-height': 210
							});
						}

						var _lis = _el.getElements('li');

						_lis.each(function (_e) {
							_e.blimp = new BlimpExtV2(_e, {
								draggable: true,
								show_veil: true,
								fullscreen: true,
								withThumbnails: true,
								cache: true,
								display: 'map',

								onFetch: function onFetch() {
									// Save state : send event to mapmultipleview, because we need the criteria etc
									self.fireEvent('saveState', { building_id: currentBuildingId });

									sm_marker.marker.clicked = true;
									self.fireEvent('request');

									_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
								},

								onPostRpc: function onPostRpc() {
									this.add_extra(true);

									self.fireEvent('dataLoad');

									Core.compile_html(this._element);
								},

								onHide: function onHide() {
									// delete state
									self.state.remove(self.page_id);

									if (this.email_blimp) {
										this.email_blimp.hide();
									}

									if (this.save_blimp) {
										this.save_blimp.hide();
									}
								}
							});
						});

						if (_ul) {
							_ul.addEvent('click:relay("li a")', function (e, i) {
								if (e && e.stop) e.stop();

								self.fireEvent('request', [e, i]);
							});
						}

						place.bubble_is_ready = true;
					},
					callbacks: {
						onClick: function onClick() {
							if (self.map.current_marker && self.map.current_marker != sm_marker) {
								self.has_opened_bubble = false;
								google.maps.event.trigger(sm_marker.marker, "mouseover");
							}

							// need a delay for the mouseover to be fired.
							(function () {
								self.has_opened_bubble = true;
							}).delay(200);

							self.map.current_marker = sm_marker;
						},
						onStopMouseover: function onStopMouseover() {
							if (self.has_opened_bubble) {
								return true;
							}

							return false;
						},
						onBubbleClose: function onBubbleClose() {
							self.has_opened_bubble = false;
						}
					}
				});
			});
		});
		//we want to fit markers only after first loading
		if (this.isFirstLoading) {
			this.fit_markers();
		}
		this.fireEvent('dataReady');
	},

	add_main_building: function add_main_building() {
		var self = this;
		var data = this.options.data;

		if (!this.in_new_york(data.ini.lat, data.ini.lng)) return;

		var icon = data.ini.markers_path + 'base.png';

		this.add_marker({
			lat: data.ini.lat,
			lng: data.ini.lng,
			icon: icon,
			bubble: {
				content: self.get_bubble_content(data.base_location.name, data.base_location.address, data.base_location.type),
				add_class: '_big _main_building',
				offset: {
					x: 16,
					y: -45
				},
				side: 'right'
			},
			base_point: 'center',
			center_on_click: self.options.center_on_click
		});

		self.set_center(data.ini.lat, data.ini.lng);
	},

	get_bubble_content: function get_bubble_content(name, address, type, data) {
		var self = this;
		var listings_amount = 0;
		var lis = '';

		this.bubble_images = [];

		if (data) {
			var notFoundImageCnt = 0;
			Object.each(data, function (el) {
				var url = self.options.page_context ? el.url_v2 + '&pageContext=' + self.options.page_context : el.url_v2;
				if (typeof self.options.view != "undefined" && self.options.view) {
					url += "&view=" + self.options.view;
				}
				var notFoundImageUrl = Missing_img_horisontal;
				if (!el.image) {
					var dsIdIndex = notFoundImageCnt % 8;
					var dsId = window.NotFoundImageDsIds[dsIdIndex];
					notFoundImageUrl = window.thumbor_server_cdn;
					notFoundImageUrl += '/assets/fit-in/120x93/' + dsId;
					notFoundImageCnt++;
				}
				lis += '<li data-class="w_blimp_listing" class="clearfix" data-rpc="' + url + '">' + '<span class="image left">' + '<img src="' + el.image + '" onerror="this.src=\'' + notFoundImageUrl + '\';"/>' + '</span>' + '<span class="description">' + (el.unit && el.unit != '' ? '<span class="name ' + (el.in_contract ? '' : 'mt_10') + '">Apt. ' + el.unit + '</span>' : '') + el.display_bedrooms + (el.display_bathrooms ? ', ' + el.display_bathrooms : '') + '<span class="price">' + el.price + '</span>' + (el.in_contract ? '<span class="flag_incontract">In contract</span>' : '') + '</span>' + '</li>';

				listings_amount++;

				self.bubble_images.push(el.image);
			});

			return '<h3>' + (name && name != '' ? '<span>' + name + '</span>' : '') + (name && name != '' ? address + (type && type != '' ? '<br/>' : '') : '<span>' + address + '</span>') + (type && type != '' ? '<span class="type' + (type.toLowerCase() == 'rental' ? ' _dark' : '') + '">' + type + '</span>' : '') + '</h3>' + '<ul>' + lis + '</ul>';
		} else {
			return '<div class="clearfix"><span class="image left">' + '<img src="' + this.options.data.base_location.photo + '" onerror="this.src=\'' + Missing_img_horisontal + '\';"/>' + '</span>' + '<h3>' + (name && name != '' ? '<span>' + name + '</span>' : '') + (name && name != '' ? address + (type && type != '' ? '<br/>' : '') : '<span>' + address + '</span>') + (type && type != '' ? '<span class="type' + (type.toLowerCase() == 'rental' ? ' _dark' : '') + '">' + type + '</span>' : '') + '</h3></div>';
		}
	},

	reset_center: function reset_center() {
		google.maps.event.trigger(this.map, 'resize');
		this.fit_markers();
	}
});
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsAreaMap = new Class({
	Extends: SimpleMap,
	Implements: [Options, Events],

	defer_build: function defer_build() {
		this.parent();
		this.get_data();
	},

	get_data: function get_data() {
		var self = this;
		var opts = this.options;

		if (opts.data && opts.data != '') {
			self.data = opts.data;
			self.process_rpc();
		} else if (self._element.getAttribute('data-rpc')) {
			var url = self._element.getAttribute('data-rpc');

			new Remote({
				rpc: url,
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.draw_map();
				}
			});
		} else {
			return;
		}
	},

	process_rpc: function process_rpc() {
		var opts = this.options,
		    data = this.data,
		    self = this;

		if (data.data.hood.length > 0 || data.data.building.length > 0) {
			if (data.data.building.length > 0) {
				this.add_marker({
					lat: data.data.building[0].lat,
					lng: data.data.building[0].lng,
					icon: Res_i + '/w/hoods/bld-markers/' + (data.data.building.length > 100 ? '100+' : data.data.building.length) + '.png',
					bubble: {
						content: data.data.building[0].name + '<span class="legend">Click on marker for more info</span>'
					},
					callbacks: {
						onClick: function onClick() {
							opts.open_blimp(data.data.building[0].url_popup);
						}
					}
				});
			}

			if (data.data.hood.length > 0) {
				data.data.hood.each(function (place) {
					self.add_marker({
						lat: place[0].lat,
						lng: place[0].lng,
						icon: Res_i + '/w/hoods/hood-markers/' + (place.length > 100 ? '100+' : place.length) + '.png',
						bubble: {
							content: place[0].name + '<span class="legend">Click on marker for more info</span>'
						},
						callbacks: {
							onClick: function onClick() {
								opts.open_blimp(place[0].url_popup);
							}
						}
					});
				});
			}

			this.fit_markers();

			(function () {
				this.fireEvent('ready');
			}).bind(this).delay(2000);
		} else {
			this.fireEvent('noData');
		}
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsHeatMap = new Class({
	Extends: HoodsMap,
	Implements: [Options, Events],

	draw_map: function draw_map() {
		this.parent();

		this.add_heatmap_layer();
	},

	add_heatmap_layer: function add_heatmap_layer() {
		var data = this.data;
		var heatmapData = [];

		data.data.each(function (el) {
			var obj = { location: new google.maps.LatLng(el.lat, el.lng), weight: el.weight };
			heatmapData.push(obj);
		});

		var heatmap = this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData,
			radius: data.radius ? data.radius : 20
		});

		// this.change_gradient();
		// this.change_opacity();
		heatmap.setMap(this.map);
	},

	change_gradient: function change_gradient() {
		var gradient = ['rgba(228, 139, 225, 0)', //bkg color
		'rgba(228, 139, 225, 1)', //least intensive color
		'rgba(255, 255, 0, 1)', 'rgba(255, 255, 255, 1)' // most intensive color
		];

		this.heatmap.setOptions({
			gradient: this.heatmap.get('gradient') ? null : gradient
		});
	},

	change_opacity: function change_opacity() {
		this.heatmap.setOptions({ opacity: this.heatmap.get('opacity') ? null : 1.0 });
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var MIBC = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#ff6a00', '#c03e62', '#a7b568', '#00aeef', '#494a66', '#aca000', '#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00', '#a4b700', '#008ad9', '#b901fd', '#484a67', '#fa9a02', '#e20101', '#00c09e', '#139d05', '#010fca', '#672466', '#fe7a7a', '#a87b01'],
		unselected_item_color: '#d0d0d0',
		move_on_mousewheel: true
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');
		this._warning = this._element.getElement('.warning');
		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._type_select = this._element.getElement('.w_styled_select._type select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this._beds_options = this._element.getElements('.w_styled_select._beds .option');
		this._pricetype_options = this._element.getElements('.w_styled_select._price_types .option');
		this._currency_options = this._element.getElements('.w_styled_select._currencies .option');
		this._regions = this._element.getElements('.regions li');

		if (Cookie.read('from_mbc') == 'true') {
			this.fireEvent('apply_previous_filter');
			Cookie.write('from_mbc', false);
		}

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.type_id = this._type_select.getElement(':selected').get('value');
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.curr_id = this._currency_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');

		self.y_axis_title = self._pricetype_select.getElement(':selected').get('data-text');
		self.x_axis_title = this._element.getElement('.x_axis_title').get('text');

		this.data_changed = true;

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		this._type_select.addEvent('change', function () {
			self.type_id = self._type_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self.y_axis_title = self._pricetype_select.getElement(':selected').get('data-text');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		var currency = this._currency_select.getElement(':selected').get('text');
		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

		this._currency_select.addEvent('change', function () {
			self.curr_id = self._currency_select.getElement(':selected').get('value');

			self.data_changed = true;

			var currency = self._currency_select.getElement(':selected').get('text');
			self.currency = currency.substring(0, currency.lastIndexOf(' '));
			self.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		var back_button = this._element.getElement('.back_to_regions');

		if (back_button) {
			back_button.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				var url = self._element.getAttribute('data-url') + '?area=region' + '&type=' + self.type_id + '&show=' + self.pricetype_id + '&currency=' + self.curr_id + '&bedrooms=' + self.beds_id;

				window.location = url;
			});
		}

		this._regions = this._element.getElements('.regions li');

		this.regions = {};

		this._regions.each(function (_el, i) {
			_el.index = _el.get('data-id');
			self.regions[_el.index] = _el.get('text').trim();

			var color = self.options.colors[i];
			self.colors.push(color);
			_el.color = color;

			if (_el.hasClass('_selected')) {
				_el.setStyle('background-color', color);
			} else {
				_el.setStyle('background-color', self.options.unselected_item_color);
			}

			_el.setStyle('border-color', color);

			var config;

			try {
				config = JSONMOO.decode(_el.getElement('.hoods').get('html'), false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;
			}

			_el.addEvents({
				'click': function click() {
					_el.toggleClass('_selected');

					if (_el.getStyle('background-color').toLowerCase() == self.colors[i].toLowerCase()) {
						_el.setStyles({
							'background-color': self.options.unselected_item_color
						});
					} else {
						_el.setStyles({
							'background-color': _el.color
						});
					}

					self.fireEvent('filter');
				}
			});
		});

		this.fireEvent('filter');
	},

	get_data: function get_data() {
		var self = this;
		var region = '';

		this._veil.show();

		this.area = 'region'; //this._element.getElement('.w_graph_legends').getAttribute('data-area');

		if (!this.data || !this.data[this.type_id] || !this.data[this.type_id][this.pricetype_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id][this.beds_id]) {

			this._regions.each(function (_el) {
				if (_el.hasClass('_selected')) {
					var obj;
					try {
						obj = JSONMOO.decode('{"' + _el.index + '": "waiting"}', false);
					} catch (e) {}

					self.store_data(obj, self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		} else {
			this._regions.each(function (_el) {
				if (_el.hasClass('_selected') && !self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index]) {
					self.store_data(JSON.parse('{"' + _el.index + '": "waiting"}'), self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		}

		if (region == '') {
			this.display_chart();
			this.fireEvent('set_cookie');
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?area=' + this.area + '&type=' + this.type_id + '&show=' + this.pricetype_id + '&currency=' + this.curr_id + '&bedrooms=' + this.beds_id + region;

			var aptype = this.type_id,
			    pricetype = this.pricetype_id,
			    region = this.curr_id,
			    beds = this.beds_id;

			this.remote = new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), aptype, pricetype, region, beds);

					self.display_chart();

					self.fireEvent('set_active_regions');
					self.fireEvent('set_cookie');
				}
			});
		}
	},

	store_data: function store_data(data, aptype, pricetype, currency, beds) {
		var self = this;

		if (!this.data[aptype]) this.data[aptype] = {};
		if (!this.data[aptype][pricetype]) this.data[aptype][pricetype] = {};
		if (!this.data[aptype][pricetype][currency]) this.data[aptype][pricetype][currency] = {};
		if (!this.data[aptype][pricetype][currency][beds]) this.data[aptype][pricetype][currency][beds] = {};

		Object.each(data, function (el, i) {
			self.data[aptype][pricetype][currency][beds][i] = el;
		});
	},

	sort_series: function sort_series(array, order) {
		this.array_to_sort = array;
		this.quick_sort(0, this.array_to_sort.length - 1, 'desc');
		return this.array_to_sort;
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.array_to_sort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.array_to_sort[left].price + '' >= center.price + '') {
						left++;
					}

					while (left <= right && this.array_to_sort[right].price + '' < center.price + '') {
						right--;
					}
				} else {
					while (left <= right && this.array_to_sort[left].price >= center.price) {
						left++;
					}

					while (left <= right && this.array_to_sort[right].price < center.price) {
						right--;
					}
				}

				if (left < right) {
					temp = this.array_to_sort[right];
					this.array_to_sort[right] = this.array_to_sort[left];
					this.array_to_sort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.array_to_sort[right];
			this.array_to_sort[right] = this.array_to_sort[first];
			this.array_to_sort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		var min, max;

		this._regions.each(function (_el, i) {
			if (!self.data[self.type_id]) self.data[self.type_id] = {};
			if (!self.data[self.type_id][self.pricetype_id]) self.data[self.type_id][self.pricetype_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id]) self.data[self.type_id][self.pricetype_id][self.curr_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id]) self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id] = {};

			var data = self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index];

			if (_el.hasClass('_selected') && data && data != 'waiting' && data != []) {
				data.each(function (el) {
					el.color = self.colors[i];
					series.push(el);

					if (!min || min > el.price) {
						min = el.price;
					}

					if (!max || max < el.price) {
						max = el.price;
					}
				});
			}
		});

		this.display_warning(series.length == 0);

		if (series.length == 0) {
			this._veil.hide();
			return;
		}

		self._graph_cont.set('html', '<div class="columns' + (Core.is_ie8() ? ' _old_ie' : '') + '"></div>');

		if (Core.is_ie8()) {
			self._element.addClass('_old_ie');
		}

		series = this.series = this.sort_series(series, 'desc');

		var _columns = self._graph_cont.getElement('.columns');

		var log_min = self.log2(min);
		var log_max = self.log2(max);

		log_min = this.is_integer(log_min) ? log_min - 0.1 : log_min;
		log_max = this.is_integer(log_max) ? log_max + 0.1 : log_max;

		var log_width = Math.ceil(log_max * 10) - Math.floor(log_min * 10) + 10;
		// var log_width = Math.ceil(log_max*10) - Math.floor(log_min*10);
		var max_height = _columns.getSize().x;
		var coef = max_height / log_width;

		while (max_height - coef * (self.log2(series[0].price) - Math.floor(log_min)) * 10 > max_height / 8) {
			log_width--;
			coef = max_height / log_width;
		}

		var real_width;

		(function () {
			series.each(function (el, i) {
				_columns.adopt(new Element('div', { 'class': 'column_name', 'text': el.name }));
				var _column = new Element('div', { 'class': 'column_body', 'data-class': 'w_blimp_bld', 'style': 'background-color: ' + el.color, 'data-rpc': el.url });
				if (i == series.length - 1) {
					_column.setStyle('margin-bottom', 0);
				}

				_column.addEvent('click', function () {
					self._veil.show();
				});

				var blimp = new BlimpExt(_column, {
					draggable: true,
					show_veil: true,
					onPostRpc: function onPostRpc() {
						new BldBlimp(this);

						self.fireEvent('columnClick');
					}
				});

				blimp.addEvent('show', function () {
					self._veil.hide();
					Cookie.write('from_mbc', true);
				});

				blimp.addEvent('hide', function () {
					Cookie.write('from_mbc', false);
				});

				self.set_tooltip(el, _column);
				_columns.adopt(_column);

				var width = 0;

				if (el.price > 0) {
					width = coef * (self.log2(el.price) - Math.floor(log_min)) * 10;
				}

				_column.setStyle('width', width);
			});

			var easytips = this.easytips = new EasyTips(this._graph_cont.getElements('.column_body'), { 'parent': this._graph_cont });

			easytips.addEvent('show', function () {
				var _img = this._container.getElement('img');
				_img.set('src', _img.getAttribute('data-src'));
			});

			this.create_grid(coef, max, log_min);

			this._veil.hide();
			this.data_changed = false;
			this.add_hscroll(_columns, this._graph_cont);
		}).bind(this).delay(50); //delay is needed for big data charts
	},
	set_tooltip: function set_tooltip(el, _column) {
		var self = this;
		var price;
		if (self.curr_id == 'XAU' || self.curr_id == 'RUB') {
			price = Core.add_commas(el.price) + ' ' + self.currency_symbol;
		} else {
			price = self.currency_symbol + Core.add_commas(el.price);
		}

		var _tooltip_content = new Element('.tooltip').inject(_column);
		var _bulb = new Element('div', {
			'class': 'w_columnchart_bulb _buildings clearfix',
			'html': '<img data-src="' + el.image + '" onerror="this.src=\'' + el.missing_img + '\';">' + '<div class="info"></div>'
		}).inject(_tooltip_content);

		var content = _bulb.getElement('.info');

		var _bulb_name = new Element('a.name').inject(content);
		_bulb_name.set('text', el.name || el.address);
		_bulb_name.addEvent('click', function (e) {
			e.stopPropagation();
			window.location = el.building_url;
		});

		var _bulb_address = new Element('a.address').inject(content);
		_bulb_address.set('text', el.address);
		_bulb_address.addEvent('click', function (e) {
			e.stopPropagation();
			window.location = el.building_url;
		});

		var _bulb_price = new Element('span.price').inject(content);
		_bulb_price.set('html', price + ' / ft<sup>2</sup>');

		var _bulb_sales = new Element('span.sales').inject(content);
		_bulb_sales.set('text', ' Based on ' + el.transactions_ppsqft + (el.transactions_ppsqft.toInt() > 1 ? ' sales' : ' sale') + ' in past 12 months');

		if (el.sale && el.sale.available > 0) {
			var _bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
			var apts = el.sale.available > 1 ? 'Apts' : 'Apt';
			_bulb_available_for_sale.set('html', apts + ' for Sale: ' + el.sale.available);
			_bulb_available_for_sale.addEvent('click', function (e) {
				e.stopPropagation();
				Cookie.write('crBovJumpTo', 'sale');
				window.location = el.building_url;
			});
		}

		if (el.rent && el.rent.available > 0) {
			var _bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
			var apts = el.rent.available > 1 ? 'Apts' : 'Apt';
			_bulb_available_for_rent.set('html', apts + ' for Rent: ' + el.rent.available);
			_bulb_available_for_rent.addEvent('click', function (e) {
				e.stopPropagation();
				Cookie.write('crBovJumpTo', 'rent');
				window.location = el.building_url;
			});
		}
		_bulb.set('data-class', 'w_blimp_bld');
		_bulb.set('href', el.url);

		new BlimpExt(_bulb, {
			draggable: true,
			show_veil: true,
			onPostRpc: function onPostRpc() {
				new BldBlimp(this);
			}
		});
	},
	create_grid: function create_grid(coef, max, log_min) {
		var self = this;

		var _scale = this._element.getElement('.w_graph_scale').set('html', '<div class="y_axis_title' + (Core.is_ie8() ? ' _old_ie' : '') + '">' + self.y_axis_title + ' in ' + self.currency + (self.curr_id == 'XAU' ? '' : 's') + '</div>');

		if (Core.is_ie8()) {
			this._element.getElement('.x_axis_title').set('html', self.y_axis_title);
			this._element.getElement('.y_axis_title').set('html', self.x_axis_title);
			return;
		}

		var grid_lines_amount = (max / Math.pow(10, String.from(max.round()).length - 1)).round();
		var grid_lines_step = grid_lines_amount * Math.pow(10, String.from(max.round()).length - 1) / grid_lines_amount;

		if (grid_lines_amount == 1) {
			grid_lines_amount = 2;
			grid_lines_step /= 2;
		}

		if (self.curr_id == 'XAU') {
			grid_lines_step = grid_lines_step.round(2);
		} else {
			grid_lines_step = grid_lines_step.round();
		}

		var scale_height = _scale.getSize().y - 10;

		for (var i = grid_lines_amount; i >= 0; i--) {
			var label_text;
			var label_value = i > 0 ? grid_lines_step * i : grid_lines_step / 2;

			if (self.curr_id == 'XAU') {
				label_text = label_value + (self.is_integer(label_value) ? '.0 ' : ' ') + self.currency_symbol.toLowerCase();
			} else if (self.curr_id == 'RUB') {
				label_text = Core.add_commas(label_value) + ' ' + self.currency_symbol.toLowerCase();
			} else {
				label_text = self.currency_symbol + Core.add_commas(label_value);
			}

			var _grid_line = new Element('div', { 'class': 'grid_element', 'html': '<span class="label">' + label_text + '</span>', 'data-value': label_value });
			_grid_line.inject(_scale);

			var bottom = coef * (self.log2(label_value) - Math.floor(log_min)) * 10 - 1;

			if (bottom > 10 && bottom < scale_height) {
				_grid_line.setStyle('bottom', bottom);
			} else {
				_grid_line.dispose();
			}
		}

		if (_scale.getElements('.grid_element').length == 1) {
			var _another_grid_line = _scale.getElement('.grid_element').clone();

			var label_value = _another_grid_line.get('data-value') / 4 * 3;

			if (self.curr_id == 'XAU') {
				label_text = label_value + (self.is_integer(label_value) ? '.0 ' : ' ') + self.currency_symbol.toLowerCase();
			} else if (self.curr_id == 'RUB') {
				label_text = Core.add_commas(label_value) + ' ' + self.currency_symbol.toLowerCase();
			} else {
				label_text = self.currency_symbol + Core.add_commas(label_value);
			}

			_another_grid_line.getElement('.label').set('text', label_text);

			var bottom = coef * (self.log2(label_value) - Math.floor(log_min)) * 10 - 1;

			if (bottom > 10 && bottom < scale_height) {
				_another_grid_line.inject(_scale);
				_another_grid_line.setStyle('bottom', bottom);
			}
		}
	},

	log2: function log2(val) {
		return Math.log(val) / Math.log(2);
	},

	is_integer: function is_integer(num) {
		return num.round() == num || num.round(1) - num.round() == 0;
	},

	add_hscroll: function add_hscroll(_child, _parent) {
		if (Core.is_ie8()) return;

		var _name = _child.getElement('.column_name');
		var _body = _child.getElement('.column_body');

		var element_width = _name.getSize().x + _name.getStyle('margin-top').toInt() + _name.getStyle('margin-bottom').toInt() + _body.getSize().x + _body.getStyle('margin-top').toInt() + _body.getStyle('margin-bottom').toInt();

		var child_width = element_width * this.series.length - _body.getStyle('margin-bottom').toInt();

		if (child_width <= _parent.getSize().x && !_hscroll) {

			if (this._hscroll) {
				this._hscroll.dispose();
			}

			var _hscroll = this._hscroll = new Element('div', { 'class': 'hscroller' });
			_hscroll.inject(this._graph_cont, 'after');

			return;
		}

		var self = this;
		var opts = this.options;

		var animate = new Fx.Scroll(_parent, {
			link: 'cancel',
			duration: 700,
			transition: Fx.Transitions.Quad.easeOut,
			wheelStops: false
		});

		if (this._hscroll) {
			this._hscroll.removeEvents();
			this._hscroll.dispose();
		}

		var _hscroll = this._hscroll = new Element('div', { 'class': 'hscroller', 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._graph_cont, 'after');

		var indragger = false;

		var init_pos = 0;

		var _dragger = _hscroll.getElement('.dragger'),
		    disp_col = Math.ceil((_parent.getSize().x + _body.getStyle('margin-bottom').toInt()) / element_width),
		    size_coefficient = Math.ceil(this.series.length - disp_col);

		var dragger_left = 0;

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = _hscroll.getSize().x - dr_size;

		_hscroll.addEvents({
			'click': function click(e) {
				if (!indragger) {
					var to = animate.to ? animate.to[0] : 0;

					if (e.page.x - _hscroll.getCoordinates().left > _dragger.getStyle('left').toInt()) {
						animate.start(to + element_width * (disp_col - 1), 0);
					} else {
						animate.start(to - element_width * (disp_col - 1), 0);
					}

					if (animate.to[0] >= child_width - _parent.getSize().x) {
						_dragger.setStyle('left', max_left);
						return;
					}

					var percent_left = animate.to[0] * 100 / child_width;
					var left = (_hscroll.getSize().x - dr_size) * percent_left / 100;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);
				}
			},

			'mouseenter': function mouseenter() {
				if (self.dragging != true) _parent.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) _parent.removeClass('dragging');
			}
		});

		_dragger.addEvents({
			'mousedown': function mousedown(e) {
				self.dragging = true;
				dragger_left = _dragger.getStyle('left').toInt();
				init_pos = e.page.x;
				return false;
			},

			'mouseenter': function mouseenter() {
				indragger = true;
			},
			'mouseleave': function mouseleave() {
				indragger = false;
			}
		});

		document.addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var hposition = left * ((child_width - 400) / max_left);
					animate.set(hposition, 0);

					if (!animate.to) animate.to = [0, 0];

					animate.to[0] = hposition;
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				// _parent.removeClass('dragging');
			}
		});

		if (opts.move_on_mousewheel) {
			this._graph_cont.addEvent('mousewheel', function (e) {
				if (e && e.stop) e.stop();

				if (e.wheel > 0) {
					var ev = { page: { x: 1, y: 0 } };
					_hscroll.fireEvent('click', [ev]);
				} else if (e.wheel < 0) {
					var ev = { page: { x: _hscroll.getSize().x - 1 + _hscroll.getPosition().x, y: 0 } };
					_hscroll.fireEvent('click', [ev]);
				}

				self.easytips._container.hide();
			});
		}
	},

	display_warning: function display_warning(show) {
		if (show) {
			var msg = 'No data available for ' + this._beds_select.getElement(':selected').get('text') + ' apartments in the selected ' + (this.area == 'region' ? 'regions' : 'neighborhoods');

			this._warning.set('text', msg);
			this._warning.show();
			this._graph_cont.hide();
			this._element.getElement('.w_graph_scale').hide();
			this._element.getElement('.x_axis_title').hide();
			this._element.getElement('.w_graph_disclaimer').hide();
		} else {
			this._warning.hide();
			this._graph_cont.show();
			this._element.getElement('.w_graph_scale').show();
			this._element.getElement('.x_axis_title').show();
			this._element.getElement('.w_graph_disclaimer').show();
		}
	}
});
'use strict';

var MIBCExt = new Class({
	Extends: MIBC,

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		this._graph_cont = this._element.getElement('.w_graph_cont');
		this._veil = this.options._veil;
		this.data = this.options.data;
		this.currency_symbol = '$';

		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this.y_axis_title = this._pricetype_select.getElement(':selected').get('data-text');
		this.x_axis_title = this._element.getElement('.x_axis_title').get('text');

		var currency = this._currency_select.getElement(':selected').get('text');
		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);
		this.curr_id = this._currency_select.getElement(':selected').get('value');

		this.display_chart();
	},

	display_chart: function display_chart() {

		var self = this;
		var series = [];

		var min, max;

		var data = self.data;

		Object.each(data, function (elm, i) {

			elm.each(function (el) {

				el.color = '#00AEEF'; //self.colors[i];
				series.push(el);

				if (!min || min > el.price) {
					min = el.price;
				}

				if (!max || max < el.price) {
					max = el.price;
				}
			});
		});

		//this.display_warning(series.length==0);

		if (series.length == 0) {
			//this._veil.hide();
			return;
		}

		self._graph_cont.set('html', '<div class="columns' + (Core.is_ie8() ? ' _old_ie' : '') + '"></div>');

		if (Core.is_ie8()) {
			self._element.addClass('_old_ie');
		}

		series = this.series = this.sort_series(series, 'desc');

		var _columns = self._graph_cont.getElement('.columns');

		var log_min = self.log2(min);
		var log_max = self.log2(max);

		log_min = this.is_integer(log_min) ? log_min - 0.1 : log_min;
		log_max = this.is_integer(log_max) ? log_max + 0.1 : log_max;

		var log_width = Math.ceil(log_max * 10) - Math.floor(log_min * 10) + 10;
		// var log_width = Math.ceil(log_max*10) - Math.floor(log_min*10);
		var max_height = _columns.getSize().x;
		var coef = max_height / log_width;

		while (max_height - coef * (self.log2(series[0].price) - Math.floor(log_min)) * 10 > max_height / 8) {
			log_width--;
			coef = max_height / log_width;
		}

		var real_width;

		(function () {
			series.each(function (el, i) {
				_columns.adopt(new Element('div', { 'class': 'column_name', 'text': el.name }));
				var _column = new Element('div', { 'class': 'column_body', 'data-class': 'w_blimp_bld', 'style': 'background-color: ' + el.color, 'href': el.url });

				if (i == series.length - 1) {
					_column.setStyle('margin-bottom', 0);
				}

				_column.addEvent('click', function () {
					self._veil.show();
				});

				var blimp = new BlimpExt(_column, {
					draggable: true,
					show_veil: true,
					onPostRpc: function onPostRpc() {
						new BldBlimp(this);
					}
				});

				blimp.addEvent('show', function () {
					self._veil.hide();
				});

				self.set_tooltip(el, _column);

				_columns.adopt(_column);
				var width = 0;
				if (el.price > 0) {
					width = coef * (self.log2(el.price) - Math.floor(log_min)) * 10;
				}
				_column.setStyle('width', width);
			});

			var easytips = this.easytips = new EasyTips(this._graph_cont.getElements('.column_body'), { 'parent': this._graph_cont });

			easytips.addEvent('show', function () {
				var _img = this._container.getElement('img');
				_img.set('src', _img.getAttribute('data-src'));
			});

			this.create_grid(coef, max, log_min);

			this._veil.hide();
			this.data_changed = false;

			if (this._element.getElement('.hscroller')) {
				this._element.getElement('.hscroller').dispose();
			}

			this.add_hscroll(_columns, this._graph_cont);
		}).bind(this).delay(50); //delay is needed for big data charts
	}
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var NhStats = new Class({
	Implements: [Options, Events],

	options: {
		type: 2,
		graph_colors: ['#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00'],
		map_zoom: 13,
		map_markers_path: null
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.build();
	},

	build: function build() {
		var self = this;

		this.beds_status = [true, true, true, true, true];

		this.cache = [];

		this.rangeslider = new Rangeslider(this._element.getElement('.w_rangeslider'), {
			title: 'Date Range:',
			onComplete: function onComplete(min, max, min_formatted, max_formatted) {
				self.date_min_formatted = min_formatted || min;
				self.date_max_formatted = max_formatted || max;

				if (this._min_label) {
					self.date_min_formatted = this._min_label.get('text');
				}

				if (this._max_label) {
					self.date_max_formatted = this._max_label.get('text');
				}

				self.date_min = min || this._min_input.get('value');
				self.date_max = max || this._max_input.get('value');

				self.date_max = moment(self.date_max).endOf('month').format('YYYY-MM-DD');

				self.display_period();

				self.filter_data();
				self.apply_data();

				/*---*/
				// to set the bed to be the same as the one in city stats if the user click the series line.
				if (self._element.get('data-bed-id') && self._message.getStyle('display') != 'block') {
					var bed_id = self._element.get('data-bed-id');
					var _bed = document.getElement('.nh_beds');

					if (!_bed) return;

					var _beds = _bed.getElements('li._selected');

					_beds.each(function (_b) {
						if (bed_id.toInt() != 0 && _b.hasClass('_active')) {
							if (!_b.hasClass('beds_' + bed_id)) {
								_b.fireEvent('click');
							}
						}
					});

					self._element.set('data-bed-id', '');
				}

				// var url = window.location.href;

				// if(url.contains('bedrooms=')){
				// 	var start = url.indexOf('bedrooms=');
				// 	var param = url.substring(start);
				// 	var bed_id = param.substr(param.indexOf('=')+1);
				// 	var _bed = document.getElement('.nh_beds');
				// 	var _beds = _bed.getElements('li._selected');

				// 	_beds.each(function(_b){
				// 		if(bed_id.toInt() != 0 && _b.hasClass('_active')){
				// 			if(!_b.hasClass('beds_'+ bed_id)){
				// 				_b.fireEvent('click');
				// 			}
				// 		}
				// 	})
				// }

				/*---*/
			}
		});

		this.mindate_to_compare = this.rangeslider._min_label ? this.rangeslider._min_label.get('text') : this.rangeslider._min_input.get('value');
		this.maxdate_to_compare = this.rangeslider._max_label ? this.rangeslider._max_label.get('text') : this.rangeslider._max_input.get('value');

		if (this._element.getElement('.w_rangeslider_labels')) {
			this.date_min_formatted = this._element.getElement('.w_rangeslider_labels .min').get('text');
			this.date_max_formatted = this._element.getElement('.w_rangeslider_labels .max').get('text');
		} else {
			this.date_min_formatted = this.rangeslider._min_input.get('text');
			this.date_max_formatted = this.rangeslider._max_input.get('text');
		}

		this.type = _typeof(this.options.type) == 'object' ? this.options.type.value : this.options.type;

		this._graph_cont = document.getElement('.w_neighborhoods .graph .graph_container');
		this._chart_cont = document.getElement('.w_neighborhoods .chart .graph_container');
		this._listview_cont = document.getElement('.w_neighborhoods .listview');
		this._areamap_cont = document.getElement('.w_neighborhoods .areamap');
		this._heatmap_cont = document.getElement('.w_neighborhoods .heatmap');

		var _conts = [this._areamap_cont, this._listview_cont, this._chart_cont.getParent('.chart'), this._graph_cont.getParent('.graph'), this._heatmap_cont];

		this._veil = document.getElement('.w_neighborhoods .data_display_veil');
		this._message = document.getElement('.w_neighborhoods .data_display .error');
		this._warning = document.getElement('.w_neighborhoods .data_display .warning').hide();

		this.init_message = this._message.get('text');

		this._header = document.getElement('.ns_header h2');
		this._cats = this._element.getElements('.nh_categories a');

		this._region_styled_select = self._element.getElement('.w_styled_select._regions');
		this._region_select = this._element.getElement('.w_styled_select._regions select');

		this._precise = this._element.getElement('.nh_precise');
		this._beds_cont = this._element.getElement('.nh_beds');
		this._beds_select = self._element.getElement('.w_multiselect._beds');
		this._beds = this._beds_cont.getElements('li');

		this._currency_styled_select = self._element.getElement('.w_styled_select.currency');
		this._currency_select = this._element.getElement('.w_styled_select.currency select');
		this.currency = this._currency_select.getElement(':selected').get('value');
		this._currency_select.addEvent('change', function () {
			self.currency = self._currency_select.getElement(':selected').get('value');
			self.get_data();
		});
		this.currency_symbol = '$';

		if (this._beds_select) {
			this.add_beds_select();
		} else {
			this.add_beds_functionality();
		}

		this._summary = document.getElement('.w_neighborhoods .summary');

		this.cats = this._cats;

		if (this._region_styled_select) {
			this._region_select_options = this._region_select.getElements('option');
			this._cats = this._region_styled_select.getElements('li');
		}

		this._cats.each(function (_el, i) {
			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (self._clicked_cat === _el && e) return;

				if (self._clicked_cat) {
					self._clicked_cat.removeClass('_selected');
					self._clicked_cat.removeClass('_loading');
				}

				self._clicked_cat = _el;
				self.region_id = self._region_select_options ? self._region_select_options[i].get('value') : _el.get('data-region');

				if (!this._region_styled_select) {
					_el.addClass('_selected');

					var nh = self._clicked_cat.get('text').trim();

					self._precise.getElement('h3').set('text', nh + (nh.length > 15 ? ' nbrhds' : ' neighborhoods'));

					self.current_nh = _el._precise_select ? _el._precise_select.getElement('.monitor').get('text') : 'this neighborhood';
				}

				if (_el.ss) {
					_el.ss.fireEvent('change');
				}

				self.set_new_precise_select(_el);

				self.set_header(self.current_nh);
			}.bind(this));
		}.bind(this));

		//this.set_active_region();

		this._menu_togglers = document.getElements('.w_neighborhoods .nh_tools a');
		this._current_menu_toggler = this._menu_togglers[0];

		this._menu_togglers.each(function (_el, i) {
			_el.data_changed = i != 0;
			_el.beds_status = [true, true, true, true, true];
			_el._cont = _conts[i];

			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (_el !== self._current_menu_toggler) {
					self.toggle_menu(_el);
				}
			});
		});
	},

	display_period: function display_period() {
		var date_min = this.date_min_formatted || this.date_min;
		var date_max = this.date_max_formatted || this.date_max;

		var period = '(' + date_min + ' - ' + date_max + ')';

		if (date_min == date_max) {
			period = '( ' + date_max + ' )';
		}

		if (date_max == this.maxdate_to_compare) {
			var diff = Date.parse(this.date_min).diff(Date.parse('28th'), 'month');

			if (diff <= 12) {
				period = '(past ' + diff + ' month' + (diff == 1 ? ')' : 's)');
			}

			if (diff == 0) {
				period = '( ' + date_max + ' )';
			}
		}

		this._summary.getElement('._period').set('text', period);
	},

	get_data: function get_data() {
		var self = this;

		if (this._current_nh.data && this._current_nh.data[this.type] && this._current_nh.data[this.type][this.currency] && this._current_nh.data[this.type][this.currency] != 'waiting' && this._current_nh.data[this.type][this.currency] != 'error') {
			this.rangeslider.fireEvent('complete');

			return;
		}

		// if User click a hood series from CityStats : Apartment prices by Region Chart,
		// Apply the same criteria to get the correct data of the selected hood from the previous page
		var crNhStatsCriteria = Cookie.read('crNhStatsCriteria');
		if (crNhStatsCriteria) {
			crNhStatsCriteria = JSONMOO.decode(crNhStatsCriteria);

			this.current_nh_id = crNhStatsCriteria.hood;
			this.region_id = crNhStatsCriteria.region;
			this.type = crNhStatsCriteria.type;
			this.currency = crNhStatsCriteria.currency;
		}

		var hood_string = '';

		if (this.current_nh_id == 0) {} else {
			hood_string = '&hood=' + this.current_nh_id;
		}

		var rpc = self._clicked_cat.getAttribute('data-rpc');

		if (this._region_styled_select) {
			rpc = this._region_styled_select.get('data-rpc') + '&region=' + this.region_id;
		}

		rpc += '&type=' + this.type + hood_string + '&currency=' + self.currency;

		this.latest_rpc = rpc;

		self._current_nh.data = self._current_nh.data || {};

		var type = self.type;

		self._current_nh.data[type] = self._current_nh.data[type] || {};

		if (self._current_nh.data[type][self.currency] == 'waiting') return;

		self._current_nh.data[type][self.currency] = 'waiting';

		this._veil.show();
		this.rangeslider.disable();

		var nh = self._current_nh;
		var cc = self._clicked_cat;

		if (this.remote) {
			this.remote.cancel();
			// delete the waiting status in case of cancel
			if (self.previous_current_nh && self.previous_current_nh.data) {
				delete self.previous_current_nh.data[type][self.currency];
			}
		}

		this.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				nh.data[type][self.currency] = this.get_data();
				cc.removeClass('_loading');

				if (self.latest_rpc == this.options.rpc) {
					self.rangeslider.fireEvent('complete');
				}
			}
		});

		this._summary.addClass('_loading');
		this.remote._clicked_cat = this._clicked_cat;
		this.remote._clicked_cat.addClass('_loading');
	},

	filter_data: function filter_data() {
		var self = this;
		this.sorted_data = this._current_nh.data[this.type][this.currency].sales;

		Object.each(this.sorted_data, function (el, i) {
			var display_by_beds = false;

			el.each(function (e) {
				var date = e.sale_date_unformatted;

				if (date > self.date_max || date < self.date_min) {
					e.display = false;
				} else {
					e.display = true;
					display_by_beds = true;
				}
			});

			if (display_by_beds) {
				self._beds[i - 10].addClass('_active');

				if (self.beds_status[i - 10]) {
					self._beds[i - 10].addClass('_selected');
				}
			} else {
				self._beds[i - 10].removeClass('_active').removeClass('_selected');
			}
		});
	},

	apply_data: function apply_data() {
		var current_display = this._current_menu_toggler.getAttribute('data-element');

		this.currency_symbol = Core.get_html_text(this._current_nh.data[this.type][this.currency].currency_symbol);

		if (current_display == 'graph') {
			this.display_graph();
		} else if (current_display == 'chart') {
			this.display_chart();
		} else if (current_display == 'listview') {
			this.display_listview();
		} else if (current_display == 'areamap') {
			this.display_areamap();
		} else if (current_display == 'heatmap') {
			this.display_heatmap();
		}

		this.rangeslider.enable();

		this.set_summary();
	},

	add_beds_select: function add_beds_select() {
		var self = this;

		this._element.getElement('.w_styled_select._beds').hide();

		this._beds_select.show();

		this.beds_multiselect = new Multiselect(this._beds_select, {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false,
			onClick: function onClick(e, _el) {
				var id = _el.get('data-id');
				var dbb = _el.hasClass('_selected');
				self.beds_status[id - 10] = dbb;

				self.sorted_data[id].each(function (el) {
					el.display_by_beds = dbb;
				});

				var current_display = self._current_menu_toggler.getAttribute('data-element');

				if (current_display == 'graph') {
					self.update_highchart_series(id, dbb, 'graph');
				} else if (current_display == 'chart') {
					self.update_highchart_series(id, dbb, 'chart');
				} else if (current_display == 'listview') {
					self.display_listview();
				} else if (current_display == 'areamap') {
					self.display_areamap();
				} else if (current_display == 'heatmap') {
					self.display_heatmap();
				}

				self.set_summary();
			}
		});

		this.beds_multiselect.update_monitor();
	},

	add_beds_functionality: function add_beds_functionality() {
		var self = this;

		this._beds.each(function (_el, i) {
			_el.addEvents({
				'click': function click() {
					if (_el.hasClass('_active')) {
						_el.toggleClass('_selected');
						var dbb = _el.hasClass('_selected');
						self.beds_status[i] = dbb;

						self.sorted_data[i + 10].each(function (el) {
							el.display_by_beds = dbb;
						});

						var current_display = self._current_menu_toggler.getAttribute('data-element');

						if (current_display == 'graph') {
							self.update_highchart_series(i + 10, dbb, 'graph');
						} else if (current_display == 'chart') {
							self.update_highchart_series(i + 10, dbb, 'chart');
						} else if (current_display == 'listview') {
							self.display_listview();
						} else if (current_display == 'areamap') {
							self.display_areamap();
						} else if (current_display == 'heatmap') {
							self.display_heatmap();
						}

						self.set_summary();

						_el.fireEvent('mouseleave');
					}
				},

				'mouseenter': function mouseenter() {
					_el.addClass('_hovered');
				},

				'mouseleave': function mouseleave() {
					_el.removeClass('_hovered');
				}
			});
		});
	},

	toggle_menu: function toggle_menu(_el) {
		var self = this;
		this._menu_togglers.each(function (_e) {
			if (_e !== _el) {
				_e.removeClass('_active');
				_e._cont.hide();
			}
		});

		this.beds_status.each(function (el, i) {
			self._current_menu_toggler.beds_status[i] = el;
		});

		_el.addClass('_active');
		_el._cont.show();

		_el.data_changed = false;
		this._current_menu_toggler = _el;

		this.apply_data();
	},

	mark_menu_togglers: function mark_menu_togglers() {
		this._menu_togglers.each(function (_el) {
			if (!_el.hasClass('_active')) {
				_el.data_changed = true;
			} else {
				_el.data_changed = false;
			}
		});
	},

	set_summary: function set_summary() {
		var self = this;
		var total_sales = 0;
		var avg_ppsqft = 0;
		var avg_price = 0;
		var median_price = 0;
		var median_prices_array = [];

		var most_expensive, least_expensive;

		var cs = this.currency_symbol;

		if (this.sorted_data) {
			this.beds_status.each(function (el, i) {
				if (el && self.sorted_data[i + 10] && self.sorted_data[i + 10]) {
					self.sorted_data[i + 10].each(function (e) {
						if (e.display) {
							var price = (e.sale_price || 0).toFloat();

							total_sales++;
							avg_ppsqft += (e.ppsqft || 0).toFloat();
							avg_price += price;
							median_prices_array.push(price);

							if (!most_expensive || price > most_expensive.sale_price.toFloat()) {
								most_expensive = e;
							}

							if (!least_expensive || price < least_expensive.sale_price.toFloat()) {
								least_expensive = e;
							}
						}
					});
				}
			});

			if (total_sales > 0) {
				avg_ppsqft /= total_sales;
				avg_price /= total_sales;

				if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
					if (avg_ppsqft > 0) avg_ppsqft = Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
					if (avg_price > 0) avg_price = Core.add_commas(avg_price.round(0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				} else {
					if (avg_ppsqft > 0) avg_ppsqft = cs + Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0));
					if (avg_price > 0) avg_price = cs + Core.add_commas(avg_price.round(0));
				}

				if (median_prices_array.length > 0) {
					median_prices_array = median_prices_array.sort(function (a, b) {
						return a - b;
					});

					if (median_prices_array.length % 2 == 0) {
						median_price = ((median_prices_array[median_prices_array.length / 2] + median_prices_array[median_prices_array.length / 2 - 1]) / 2).round(0);
					} else {
						median_price = median_prices_array[(median_prices_array.length / 2).floor()].round(0);
					}

					if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
						median_price = Core.add_commas(median_price) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
					} else {
						median_price = cs + Core.add_commas(median_price);
					}
				}

				if (total_sales > 500) {
					self._warning.show();
				} else {
					self._warning.hide();
				}
			}
		}

		this._summary.getElement('#total_sales').set('html', total_sales);

		var _avg_price_ft = this._summary.getElement('#avg_price_ft');
		_avg_price_ft.set('html', avg_ppsqft);

		if (_avg_price_ft.get('text').length > 8) {
			_avg_price_ft.addClass('_small');
		} else {
			_avg_price_ft.removeClass('_small');
			_avg_price_ft.removeClass('_supersmall');
		}

		if (_avg_price_ft.get('text').length > 11) {
			_avg_price_ft.addClass('_supersmall');
		}

		var _avg_price = this._summary.getElement('#avg_price');
		_avg_price.set('html', avg_price);

		if (_avg_price.get('text').length > 8) {
			_avg_price.addClass('_small');
		} else {
			_avg_price.removeClass('_small');
			_avg_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_avg_price.addClass('_supersmall');
		}

		var _med_price = this._summary.getElement('#med_price');
		_med_price.set('html', median_price);

		if (_med_price.get('text').length > 8) {
			_med_price.addClass('_small');
		} else {
			_med_price.removeClass('_small');
			_med_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_med_price.addClass('_supersmall');
		}

		this._summary.removeClass('_loading');

		if (most_expensive) {
			var me = '<strong>Most Expensive</strong><br>' + '<a href="' + most_expensive.url_sold + '">' + (most_expensive.name || most_expensive.display_name || most_expensive.street_address) + ', #' + most_expensive.unit + '</a><br/>' + most_expensive.bedroom.split('room').join('') + ' | ' + most_expensive.sale_price_format + '<br>' + most_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + most_expensive.sale_date + '</span>';

			this._most_expensive = this._summary.getElement('#most_exp');
			this._most_expensive.set('html', me);

			this._summary.getElement('#most_exp').show();
		} else {
			this._summary.getElement('#most_exp').hide();
		}

		if (least_expensive) {
			var le = '<strong>Least Expensive</strong><br>' + '<a href="' + least_expensive.url_sold + '">' + (least_expensive.name || least_expensive.display_name || least_expensive.street_address) + ', #' + least_expensive.unit + '</a><br/>' + least_expensive.bedroom.split('room').join('') + ' | ' + least_expensive.sale_price_format + '<br>' + least_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + least_expensive.sale_date + '</span>';

			this._least_expensive = this._summary.getElement('#least_exp');
			this._least_expensive.set('html', le);

			this._summary.getElement('#least_exp').show();
		} else {
			this._summary.getElement('#least_exp').hide();
		}
	},

	set_new_precise_select: function set_new_precise_select(_el) {
		var self = this;
		var _ss = this._precise.getElement('.w_styled_select');

		if (_ss) _ss.dispose();

		if (!_el._precise_select) {
			var config;

			try {
				var data = (_el.getNext('.hoods') || _el.getElement('.hoods')).get('html');
				config = JSONMOO.decode(data, false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;

				var _select = _el._hood_select = new Element('select');

				Object.each(_el.hoods, function (el, i) {
					new Element('option', { 'text': el, 'data-hood': i }).inject(_select);
				});

				_el._precise_select = new Element('div', { 'class': 'w_styled_select' }).adopt(_select);

				this._precise.adopt(_el._precise_select);

				_el.ss = this.styledselect = new StyledSelect(_el._precise_select);

				this.fireEvent('nhSet', [_el._precise_select]);

				if (this.current_nh_id) {
					var _ul = this._region_styled_select ? this._region_styled_select.getElement('ul') : this._element.getElement('.nh_categories ul');
					_ul.setAttribute('data-hood-selected', self.current_nh_id);
				}

				this.set_active_hood(_el._precise_select);

				_el.ss.addEvent('change', function () {
					self.current_nh = this.text;

					self.set_header(this.text);

					var _selected_option = this._select.getElement(':selected');

					if (!_selected_option) {
						_select.getElements('option').each(function (_option) {
							if (_option.get('text') == self.current_nh) {
								_selected_option = _option;
							}
						});
					}

					self.previous_current_nh = self._current_nh;
					self.current_nh_id = _selected_option.getAttribute('data-hood');
					self._current_nh = this._selected;

					self.get_data();

					if (self.graph && self._current_nh.data[self.type][self.currency] != 'waiting' && self._current_nh.data[self.type][self.currency] != 'error') {
						self.mark_menu_togglers();
					}
				});

				_el.ss.fireEvent('change');
			} else {
				this._precise.hide();
			}
		} else {
			this._precise.adopt(_el._precise_select);
		}
	},

	set_active_region: function set_active_region() {
		var self = this;

		this._cats_ul = self._element.getElement('.nh_categories ul') || this._region_styled_select.getElement('ul');
		var active_region = this._cats_ul.get('data-region-selected');
		if (active_region) {

			this._cats.each(function (_cat, i) {

				if (this._region_styled_select) {
					if (this._region_select_options[i].get('value') == active_region) {
						_cat.fireEvent('click');
					}
				} else {
					if (_cat.get('data-region') == active_region) {
						_cat.fireEvent('click');
					}
				}
			}.bind(this));
		} else {
			this._cats[0].fireEvent('click');
		}
	},

	set_active_hood: function set_active_hood(_precise_select) {
		var self = this;
		this._cats_ul = self._element.getElement('.nh_categories ul') || this._region_styled_select.getElement('ul');

		var active_hood = this._cats_ul.get('data-hood-selected');
		var _options = _precise_select.getElements('option');

		if (active_hood) {
			_options.each(function (_option, i) {
				if (_option.get('data-hood') == active_hood) {
					var _opts = _precise_select.getElements('.option');
					_opts[i].fireEvent('click');
				}
			}.bind(this));
		}
	},

	set_header: function set_header(text) {
		if (!this._header) return;
		this._header.set('html', text + ' Sales Summary');
	},

	display_chart: function display_chart() {
		var self = this;
		this.display_message(false);

		var series = [];
		var color = 0;

		var data = {
			10: this.sorted_data[10],
			11: this.sorted_data[11],
			12: this.sorted_data[12],
			13: this.sorted_data[13],
			14: this.sorted_data[14]
		};

		Object.each(data, function (el, i) {
			if (!el || el.length == 0) return;

			var data_series = [];

			Object.each(el, function (e) {
				if (!e.display) return;

				var date = new Date(e.sale_date_unformatted).getTime();

				data_series.push([date, e.ppsqft, e.tooltip, e.url_sold]);
			});

			self.sort(data_series);

			if (data_series.length > 0) {
				series.push({
					name: i,
					color: self.options.graph_colors[color],
					data: data_series
				});
			}

			color++;
		});

		this.cache = series;

		if (this.chart) {
			this.reset_highchart(series, 'chart');
		} else {
			this.move_rangeselector();
			this.get_rangedate();

			this.create_chart(series);

			this.set_rangeselector();

			this.filter_data(); //causes infinite recursion
		}

		this._veil.hide();
	},

	create_chart: function create_chart(series) {
		var self = this;

		if (series.length > 0) {
			this.chart = new Highcharts.StockChart({
				chart: {
					renderTo: self._chart_cont,
					type: 'spline',
					backgroundColor: '#ebebeb',
					marginTop: 25
				},

				series: series,

				title: {
					useHTML: true,
					text: null,
					x: 25,
					margin: 0,
					align: 'left',
					style: {
						color: '#ccc',
						font: '11px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif',
						fontWeight: 'bold'
					}
				},

				subtitle: {
					text: null
				},

				rangeSelector: {
					enabled: false
				},

				credits: {
					enabled: false
				},

				xAxis: {
					type: 'datetime',
					title: {
						text: null
					},
					minRange: 3600000 * 24 * 14, //two weeks
					labels: {
						style: {
							color: '#666'
						}
					}
				},

				yAxis: {
					plotLines: [{
						value: 0,
						width: 2,
						color: '#666'
					}],

					title: {
						text: null,
						x: -5,
						style: {
							color: '#666'
						}
					},

					labels: {
						align: 'left',
						style: {
							color: '#666'
						},
						x: 0,
						formatter: function formatter() {
							return self.currency_symbol + Core.add_commas(this.value);
						}
					},
					gridLineWidth: 1,
					gridLineDashStyle: 'dash',
					gridLineColor: '#666',
					endOnTick: false,
					showLastLabel: true,
					minPadding: 0,
					opposite: false
				},

				navigator: {
					enabled: false
				},

				plotOptions: {
					series: {
						animation: true,
						cursor: 'pointer',
						point: {
							events: {
								click: function click(e) {
									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][3];

									if (url) {
										window.location = url;
									}

									self.fireEvent('seriesClick');
								}
							}
						},
						states: {
							hover: {
								lineWidthPlus: 0
							}
						}
					},

					line: {
						dataGrouping: {
							// smoothed: true,
							groupPixelWidth: 5,
							approximation: 'open',
							dateTimeLabelFormats: {
								day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
								week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
							}
						},
						lineWidth: 3,

						states: {
							hover: {
								lineWidthPlus: 0
							}
						},

						marker: {
							enabled: false,
							states: {
								hover: {
									enabled: true
								}
							}
						}
					}
				},

				tooltip: {
					useHTML: true,
					valueDecimals: 0,
					shared: false,
					crosshairs: false,
					borderWidth: 2,
					style: {
						width: '300px'
					},
					formatter: function formatter() {
						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][2];

						if (this.point.dataGroup && this.point.dataGroup.length > 1) {
							content += '<br><br><i class="note">Note: This is an Average Closing Price.</i>';
						}

						return content;
					}
				},

				scrollbar: {
					enabled: false
					// barBackgroundColor: '#bbb',
					// barBorderColor: '#fff',
					// rifleColor: '#fff',
					// buttonBackgroundColor: '#bbb',
					// buttonArrowColor: '#666',
					// buttonBorderColor: '#fff',
					// trackBackgroundColor: '#bbb'
				}
			});
		} else {
			this.display_message(true);
		}

		this._veil.hide();
	},

	display_graph: function display_graph() {
		var self = this;
		this.display_message(false);

		var series = [];
		var color = 0;

		var data = {
			10: this.sorted_data[10],
			11: this.sorted_data[11],
			12: this.sorted_data[12],
			13: this.sorted_data[13],
			14: this.sorted_data[14]
		};

		Object.each(data, function (el, i) {
			if (el && el.length > 0) {
				var data_series = [];

				Object.each(el, function (e) {
					if (e.display) {
						data_series.push([e.x, e.y, e.tooltip, e.url_sold]);
					}
				});

				if (data_series.length > 0) {
					series.push({
						name: i,
						color: self.options.graph_colors[color],
						data: data_series,
						marker: {
							symbol: 'circle',
							radius: 8
						}
					});
				}
			}

			color++;
		});

		this.cache = series;

		if (this.graph) {
			this.reset_highchart(series, 'graph');
		} else {
			this.create_graph(series);
			this.filter_data(); //causes infinite recursion
		}

		this._veil.hide();
	},

	create_graph: function create_graph(series) {
		var self = this;

		if (series.length > 0) {
			this.graph = new Highcharts.Chart({
				chart: {
					animation: false,
					renderTo: self._graph_cont,
					type: 'scatter',
					zoomType: 'xy',
					plotBackgroundColor: '#ebebeb',
					backgroundColor: '#ebebeb',
					// marginTop: 20,
					marginBottom: 42,
					marginLeft: 14,
					ignoreHiddenSeries: true,

					resetZoomButton: {
						theme: {
							fill: '#585858',
							stroke: 'silver',
							style: {
								color: '#fff'
							},
							r: 0,
							states: {
								hover: {
									fill: '#41739D',
									style: {
										color: 'white'
									}
								}
							}
						}
					}
				},

				series: series,

				credits: {
					enabled: false
				},

				title: {
					text: null
				},

				xAxis: {
					type: self._current_nh.data[self.type][self.currency].x.type,
					minPadding: 0.1,
					gridLineWidth: 1,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',
					// min: 100,
					title: {
						text: '<span style="margin-bottom:3px;">' + self._current_nh.data[self.type][self.currency].x.label + '</span>',
						margin: 3,
						style: {
							color: '#666'
						}
					},
					labels: {
						useHTML: true,
						overflow: 'justify',
						formatter: function formatter() {
							return Core.add_commas(this.value) + ' ft<sup>2</sup>';;
						},
						style: {
							color: '#666',
							fontWeight: 'normal'
						}
					}
				},

				yAxis: {
					type: self._current_nh.data[self.type][self.currency].y.type,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',

					showFirstLabel: true,
					showLastLabel: false,

					minPadding: 0.05,
					maxPadding: 0,

					title: {
						text: self._current_nh.data[self.type][self.currency].y.label,
						margin: 3,
						style: {
							color: '#666'
						}
					},
					labels: {
						align: 'left',
						x: 3,
						y: -4,
						formatter: function formatter() {
							if (self.currency.toLowerCase() == 'xau' || self.currency.toLowerCase() == 'rub') {
								return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol.toLowerCase();
							} else {
								return self.currency_symbol + Highcharts.numberFormat(this.value, 0);
							}
						},
						style: {
							color: '#666',
							fontWeight: 'normal',
							whiteSpace: 'nowrap'
						}
					}
				},

				tooltip: {
					formatter: function formatter() {
						if (!this.series.visible) {
							return false;
						} else {
							this.series.zIndex = 1;
						}

						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][2];

						return content;
					},
					snap: 30,
					useHTML: true
				},

				legend: {
					enabled: false
				},

				plotOptions: {
					scatter: {
						marker: {
							radius: 6,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						}
					},

					series: {
						animation: false,
						cursor: 'pointer',
						point: {
							events: {
								click: function click(e) {
									self._veil.show();

									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][3];

									if (url) {
										window.location = url;
									}

									self.fireEvent('seriesClick');
								},
								mouseOver: function mouseOver() {
									if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
										if (!this.button) {
											var index;

											if (this.dataGroup) {
												index = this.dataGroup.start;
											} else {
												index = this.index;
											}

											this.button = new Element('a', { 'class': 'button details', 'href': this.series.options.data[index][3], 'text': 'Listing Details' });
										}

										self._graph_cont.adopt(this.button);
									}
								},

								mouseOut: function mouseOut() {
									if (this.button) {
										this.button.dispose();
									}
								}
							}
						}
					}
				}
			});
		} else {
			this.display_message(true);
		}

		this._veil.hide();
	},

	reset_highchart: function reset_highchart(series, type) {
		var self = this;
		var active_chart = this.chart;

		if (type == 'graph') {
			active_chart = this.graph;
		}

		if (series.length > 0) {
			var length;
			if (Core.is_ie9()) {
				while (active_chart.series.length > 0) {
					active_chart.series[0].remove(true);
				}
			} else {
				length = active_chart.series.length;
				for (var i = 0; i < length; i++) {
					active_chart.series[0].remove(false);
				}

				series.each(function (el) {
					active_chart.addSeries(el);
				});
			}

			this.beds_status.each(function (el, i) {
				self.update_highchart_series(i + 10, el, type);
			});

			active_chart.yAxis[0].setTitle({
				text: self._current_nh.data[self.type][self.currency].y.label
			});
		} else {
			this.display_message(true);
		}
	},

	update_highchart_series: function update_highchart_series(id, turn_on, type) {
		var series;
		var active_chart = this.chart;
		this._hidden_series;

		if (type == 'graph') {
			active_chart = this.graph;
		}

		active_chart.series.each(function (el) {
			if (el.name == id) {
				series = el;
				return;
			}
		});

		if (!Core.is_ie9() && !series) {
			return;
		}

		if (turn_on && series && !series.visible) {
			series.show();
		} else if (turn_on && Core.is_ie9()) {
			var found = null;
			this.cache.each(function (s) {
				if (s.name == id) {
					found = s;
				}
			});
			active_chart.addSeries(found);
		} else if (!turn_on && series && series.visible) {
			//series.zIndex = 0;
			//console.log(series);
			//console.log(series.cursor);
			//series.cursor = null;
			//series.enableMouseTracking = false;
			if (Core.is_ie9()) {
				series.remove();
				active_chart.redraw();
			} else {
				series.hide();
			}
		}
	},

	display_areamap: function display_areamap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
				});
			}
		});

		if (!this.areamap) {
			this._veil.show();

			this.create_areamap(data);
		} else {
			this.reset_areamap(data);
		}
	},

	create_areamap: function create_areamap(data) {
		var self = this;

		if (data.length > 0) {

			var areamap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				markers_path: this._current_nh ? this._current_nh.data[this.type][this.currency].map_markers_path : this.options.map_markers_path,
				data: data
			};

			this.areamap = new NhStatsAreaMap(this._areamap_cont, {
				min_zoom: 12,
				data: areamap_data,
				// onNoData: function(){ self.display_message(true); },
				open_blimp: function open_blimp(url) {
					self._veil.show();

					var blimp;

					Blimp.instances.each(function (el) {
						if (el.options.rpc_url == url) {
							blimp = el;

							return;
						}
					});

					if (!blimp) {
						blimp = new BlimpExt(null, {
							draggable: true,
							show_veil: true,
							onPostRpc: function onPostRpc() {
								new BldBlimp(this);
								self._veil.hide();

								self.fireEvent('seriesClick');
							},
							rpc_url: url
						});
					}

					blimp._link.fireEvent('click');
				}
			});

			this.areamap.addEvent('ready', function () {
				self._veil.hide();
			});
		} else {
			this.display_message(true);
		}
	},

	reset_areamap: function reset_areamap(sorted_data) {
		if (sorted_data.length > 0) {
			var sorted_data = sorted_data || Object.clone(this.sorted_data);

			this._beds.each(function (_el) {
				sorted_data.each(function (el) {
					el.display_on_map = _el.hasClass('_selected');
				});
			});

			if (!this.areamap) {
				this.create_areamap();
				return;
			}

			var areamap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				markers_path: this._current_nh ? this._current_nh.data[this.type][this.currency].map_markers_path : this.options.map_markers_path,
				data: sorted_data
			};

			this.areamap.data = areamap_data;
			this.areamap.reset_map();

			this._veil.hide();
		} else {
			this.display_message(true);
		}
	},

	display_heatmap: function display_heatmap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
				});
			}
		});

		if (!this.heatmap) {
			this._veil.show();

			this.create_heatmap(data);
		} else {
			this.reset_heatmap(data);
		}
	},

	create_heatmap: function create_heatmap(data) {
		if (data.length > 0) {
			var self = this;

			var heatmap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				radius: 15,
				opacity: this._current_nh ? this._current_nh.data[this.type][this.currency].heatmap_opacity : this.options.map_markers_path,
				data: data
			};

			this.heatmap = new NhStatsHeatMap(self._heatmap_cont, {
				data: heatmap_data,
				// onNoData: function(){ self.show_error(_el); },
				onReady: function onReady() {
					self._veil.hide();
				}
			});
		} else {
			this.display_message(true);
		}
	},

	reset_heatmap: function reset_heatmap(sorted_data) {
		var sorted_data = sorted_data || Object.clone(this.current_sorted_data);

		this._beds.each(function (_el) {
			sorted_data.each(function (el) {
				el.display_on_map = _el.hasClass('_selected');
			});
		});

		if (!this.heatmap) {
			this.create_heatmap(sorted_data);
			return;
		}

		var heatmap_data = {
			zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
			radius: 15,
			opacity: this._current_nh ? this._current_nh.data[this.type][this.currency].heatmap_opacity : this.options.map_markers_path,
			data: sorted_data
		};

		this.heatmap.data = heatmap_data;
		this.heatmap.add_heatmap_layer();
	},

	display_listview: function display_listview() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
					e.bedroom_id = i;
				});
			}
		});

		this.create_listview(data);
	},

	create_listview: function create_listview(data) {
		var self = this;

		this._veil.show();

		self._listview_cont.empty();
		self._trs = [];

		var _divtable = new Element('div', { 'class': 'w_divtable clearfix' });
		var _thead = '<div class="thead">' + '<div class="tr">' + '<div class="th building_name">Building / Address</div>' +
		//'<div class="th size">size</div>' +
		'<div class="th closing_price">Closing Price</div>' + '<div class="th closing_date"> Closing Date</div>' + '</div>' + '</div>';

		_divtable.set('html', _thead);

		var _tbody = new Element('div', { 'class': 'tbody w_styled_scroll' }).inject(_divtable);
		var nothing_to_show = true;

		var sorted_by_date = self.sort_by_date(data);

		sorted_by_date.each(function (e, i) {
			if (!e.display) return;

			nothing_to_show = false;

			var color;

			switch (e.bedroom_id.toInt()) {
				case 10:
					color = 0;
					break;
				case 11:
					color = 1;
					break;
				case 12:
					color = 2;
					break;
				case 13:
					color = 3;
					break;
				default:
					color = 4;
			}

			var _tr = new Element('div', {
				'class': 'tr',
				'data-href': e.url_sold,
				styles: {
					'border-left': '6px solid ' + self.options.graph_colors[color]
				}
			}).inject(_tbody);

			_tr.addEvent('click', function () {
				self.fireEvent('seriesClick');
			});

			var _td_building = new Element('.td.building_name');
			var _td_closing_price = new Element('.td.closing_price');
			var _td_closing_date = new Element('.td.closing_date');

			var building_text = '<span>' + (e.name || e.street_address) + ', </span><span class="unit"> Apt ' + e.unit + '</span><br>' + (e.name != null ? e.street_address : '');

			var closing_price_text = '<span>' + e.sale_price_format + '</span><br> Approx. ' + e.ppsqft_format + ' / ft <sup>2</sup>';
			var closing_date_text = '<span>' + e.sale_date + '</span>';

			_td_building.set('html', building_text).inject(_tr);
			_td_closing_price.set('html', closing_price_text).inject(_tr);
			_td_closing_date.set('html', closing_date_text).inject(_tr);

			self._trs.push(_tr);
		});

		if (!nothing_to_show) {
			_divtable.inject(self._listview_cont);
			self._listview_cont.show();

			new Divtable(_divtable, { 'zebra_order': 'odd' });

			if (self._trs.length > 9) {
				_divtable.addClass('on_scroll');
				new StyledScroll(_tbody, { type: 'v', max_height: self.set_max_height() });
			}
		} else {
			self._listview_cont.hide();
			self.display_message(true);
		}

		self._veil.hide();
	},

	sort_by_date: function sort_by_date(data) {
		var sorted_by_date = data.sort(function (a, b) {
			return new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s") > new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s") ? -1 : 1;
		});

		return sorted_by_date;
	},

	set_max_height: function set_max_height() {
		var self = this;
		var max_height = 0;

		self._trs.each(function (_tr, i) {
			if (i < 10) {
				max_height += _tr.getComputedSize().height; //_tr.offsetHeight;//_tr.getSize().y
			}
		});

		return max_height + 20;
	},

	display_message: function display_message(show) {
		var _cont;

		this._menu_togglers.each(function (_el) {
			if (_el.hasClass('_active')) {
				_cont = _el._cont;
				return;
			}
		});

		if (show) {
			this._warning.hide();
			var message = 'No data available for ' + (this.current_nh && this.current_nh.toLowerCase() != 'all' ? this.current_nh : this._clicked_cat.get('text')) + '<br/>for the period of ' + this.date_min_formatted + ' - ' + this.date_max_formatted + '<br/>Try to increase the date range.';

			this._message.set('html', message);

			_cont.hide();
			this._veil.hide();
			this._message.show();
			this.message_displayed = true;
		} else {
			_cont.show();
			this._message.hide();
			this.message_displayed = false;
		}
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    topPosition = this.chart.plotTop - 25,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 200,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 200;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	get_rangedate: function get_rangedate() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.min_date = url.getData('date_from');
			this.max_date = url.getData('date_to');
		}
	},

	set_rangeselector: function set_rangeselector() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.chart.xAxis[0].setExtremes(new Date(url.getData('date_from')), new Date(url.getData('date_to')));
		}
	},

	sort: function sort(series) {
		series.sort(function (a, b) {
			if (a[0] < b[0]) return -1;
			if (a[0] > b[0]) return 1;
			return 0;
		});

		// return series;
	}
});
'use strict';

var NhStatsExt = new Class({
	Extends: NhStats,

	options: {
		data: null,
		_veil: null,
		map_zoom: 13,
		map_markers_path: null,
		graph_colors: {
			10: '#b19f00',
			11: '#018f9b',
			12: '#b4224a',
			13: '#484a67',
			14: '#ff5a00'
		}
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._graph_cont = this._element.getElement('.graph');
		this._areamap_cont = this._element.getElement('.areamap');
		this._heatmap_cont = this._element.getElement('.heatmap');

		this._graph_stat = this._element.getElement('.w_graph_stat');
		this._summary = this._element.getElement('.w_graph_summary');
		this._period_select = this._element.getElement('.w_styled_select._period select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');
		this.currency = this._currency_select.getElement(':selected').get('value');
		this._veil = this.options._veil;
		this.inactive_series_type = [];
	},

	display_graph: function display_graph() {
		var self = this;
		var series = [];

		this.display_message(false);

		Object.each(self.data.sales, function (el, i) {
			if (el && el.length > 0) {
				var data_series = [];

				Object.each(el, function (e) {
					data_series.push([e.x, e.y, e.name, e.tooltip, e.url_sold]);
				});

				if (data_series.length > 0) {
					series.push({
						name: el[0].bedroom.toInt() >= 4 ? '4+ Bedrooms' : el[0].bedroom,
						color: self.options.graph_colors[i],
						data: data_series,
						marker: {
							symbol: 'circle',
							radius: 8
						}
					});
				}
			}
		});

		if (!this.chart) {
			this.create_graph(series);
		} else {
			self.fireEvent('ready');
		}
	},

	create_graph: function create_graph(series) {
		var self = this;

		if (series.length > 0) {
			this.graph = new Highcharts.Chart({
				chart: {
					renderTo: self._graph_cont,
					type: 'scatter',
					zoomType: 'xy',
					plotBackgroundColor: '#666',
					backgroundColor: '#666',
					plotBorderWidth: 1,
					plotBorderColor: '#aaa',
					// marginTop: 20,
					marginBottom: 190,
					marginLeft: 35,
					resetZoomButton: {
						theme: {
							fill: '#585858',
							stroke: 'silver',
							style: {
								color: '#fff'
							},
							r: 0,
							states: {
								hover: {
									fill: '#41739D',
									style: {
										color: 'white'
									}
								}
							}
						}
					}
				},

				credits: {
					enabled: false
				},

				title: {
					text: null
				},

				xAxis: {
					// min: 0,

					minRange: 2,
					minTickInterval: 0.5,
					// minPadding: 0,
					maxPadding: 0,
					gridLineWidth: 1,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',
					tickWidth: 0,
					showEmpty: false,

					// showFirstLabel: false,
					// showLastLabel: true,

					// gridLineWidth: 1,
					// gridLineColor: '#e0e0e0',
					title: {
						useHTML: true,
						text: 'Apartment Size (In Square Feet)',
						margin: 20,
						style: {
							color: '#bbb'
						}
					},
					labels: {
						useHTML: true,
						overflow: 'justify',
						// formatter: function() {
						//	 return Highcharts.numberFormat(this.value, ((opts.xAxis_copy == 'Bathrooms')? 1 : 0));
						// },
						style: {
							color: '#ccc',
							fontWeight: 'normal'
						},
						formatter: function formatter() {
							return Core.add_commas(this.value) + ' ft<sup>2</sup>';
						}
					}
				},

				yAxis: {
					type: 'logarithmic',

					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',

					showFirstLabel: false,
					showLastLabel: false,

					minPadding: 0.05,
					maxPadding: 0,

					title: {
						useHTML: true,
						text: 'Closing Price / Ft<sup>2</sup>',
						margin: 25,
						x: 4,
						style: {
							color: '#bbb'
						}
					},
					labels: {
						//useHTML: true,
						align: 'left',
						x: 3,
						y: -4,
						formatter: function formatter() {
							var currency_code = self.currency;
							var currency_symbol = Core.get_html_text(self.data.currency_symbol);

							if (currency_code == 'RUB') {
								return Core.add_commas(this.value) + ' ' + currency_symbol;
							} else if (currency_code == 'XAU') {
								return Highcharts.numberFormat(this.value, 2) + ' ' + currency_symbol;
							}

							return currency_symbol + Core.add_commas(this.value);
						},
						style: {
							color: '#ccc',
							fontWeight: 'normal',
							whiteSpace: 'nowrap'
						}
					}
				},

				tooltip: {
					formatter: function formatter() {
						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][3];

						if (this.point.dataGroup && this.point.dataGroup.length > 1) {
							content += '<br><br><i class="note">Note: This is Average Closing Price.</i>';
						}

						return content;
					},
					snap: 30,
					useHTML: true
				},

				legend: {
					enabled: false
				},

				plotOptions: {
					scatter: {
						marker: {
							symbol: 'circle',
							radius: 8,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						},
						events: {
							legendItemClick: function legendItemClick(e) {
								var data = {};
								var counter = 0;

								(function () {
									Object.each(self.data.sales, function (el, i) {
										if (!el && !el.length > 0) return;

										if (counter != e.target._i && !self.inactive_series_type.contains(i)) {
											data[i] = el;
										} else if (counter == e.target._i && self.inactive_series_type.contains(i) && e.target.visible == true) {
											data[i] = el;
											self.inactive_series_type.erase(i);
										} else {
											if (!self.inactive_series_type.contains(i)) {
												self.inactive_series_type.push(i);
											}
										}
										counter++;
									});

									self.set_summary(data);
								}).delay(200, self);
							}
						}
					},

					series: {
						cursor: 'pointer',
						point: {
							events: {
								click: function click() {
									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][4];

									if (url) {
										window.location = url;
									}
								}
							}
						}
					}
				},

				series: series
			}, function (chart) {
				self.fireEvent('ready');
			});
		} else {
			this.display_message(true);
		}
	},

	display_areamap: function display_areamap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(self.data.sales, function (el, i) {
			if (el && el.length > 0) {
				Object.each(el, function (e) {
					e.display = true;
					data.push(e);
				});
			}
		});

		if (!this.areamap) {
			this.create_areamap(data);
		} else {
			self.fireEvent('ready');
		}
	},

	display_heatmap: function display_heatmap() {
		var self = this;
		var data = [];

		this.display_message(false);

		Object.each(self.data.sales, function (el, i) {
			if (el && el.length > 0) {
				Object.each(el, function (e) {
					e.display = true;e.display = true;
					data.push(e);
				});
			}
		});

		if (!this.heatmap) {
			this.create_heatmap(data);
		} else {
			self.fireEvent('ready');
		}
	},

	set_summary: function set_summary(data_series) {
		var self = this;
		var total_sales = 0;
		var avg_ppsqft = 0;
		var avg_price = 0;
		var median_price = 0;
		var median_prices_array = [];
		var most_expensive, least_expensive;
		var sales_data = data_series || self.data.sales;

		// var cs = (this.currency_symbol.length > 1)? '' : this.currency_symbol;
		this.currency_symbol = Core.get_html_text(self.data.currency_symbol);
		var cs = this.currency_symbol;

		//if(this.sorted_data){
		Object.each(sales_data, function (el, i) {
			if (el && el.length > 0) {

				Object.each(el, function (e) {
					var price = (e.sale_price || 0).toFloat();

					total_sales++;
					avg_ppsqft += (e.ppsqft || 0).toFloat();
					avg_price += price;
					median_prices_array.push(price);

					if (!most_expensive || price > most_expensive.sale_price.toFloat()) {
						most_expensive = e;
					}

					if (!least_expensive || price < least_expensive.sale_price.toFloat()) {
						least_expensive = e;
					}
				});
			}
		});

		if (total_sales > 0) {
			avg_ppsqft /= total_sales;
			avg_price /= total_sales;

			if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
				if (avg_ppsqft > 0) avg_ppsqft = Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				if (avg_price > 0) avg_price = Core.add_commas(avg_price.round(0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
			} else {
				if (avg_ppsqft > 0) avg_ppsqft = cs + Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0));
				if (avg_price > 0) avg_price = cs + Core.add_commas(avg_price.round(0));
			}

			if (median_prices_array.length > 0) {
				median_prices_array = median_prices_array.sort(function (a, b) {
					return a - b;
				});

				if (median_prices_array.length % 2 == 0) {
					median_price = ((median_prices_array[median_prices_array.length / 2] + median_prices_array[median_prices_array.length / 2 - 1]) / 2).round(0);
				} else {
					median_price = median_prices_array[(median_prices_array.length / 2).floor()].round(0);
				}

				if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
					median_price = Core.add_commas(median_price) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				} else {
					median_price = cs + Core.add_commas(median_price);
				}
			}

			if (total_sales > 500) {
				//self._warning.show();
			} else {
					//self._warning.hide();
				}
		}
		//}
		var period = this._period_select.getElement(':selected').get('text');
		this._summary.getElement('.period').set('text', period + ':');

		this._summary.getElement('#total_sales').set('html', total_sales);

		var _avg_price_ft = this._summary.getElement('#avg_price_ft');
		_avg_price_ft.set('html', avg_ppsqft);

		if (_avg_price_ft.get('text').length > 8) {
			_avg_price_ft.addClass('_small');
		} else {
			_avg_price_ft.removeClass('_small');
			_avg_price_ft.removeClass('_supersmall');
		}

		if (_avg_price_ft.get('text').length > 11) {
			_avg_price_ft.addClass('_supersmall');
		}

		var _avg_price = this._summary.getElement('#avg_price');
		_avg_price.set('html', avg_price);

		if (_avg_price.get('text').length > 8) {
			_avg_price.addClass('_small');
		} else {
			_avg_price.removeClass('_small');
			_avg_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_avg_price.addClass('_supersmall');
		}

		var _med_price = this._summary.getElement('#med_price');
		_med_price.set('html', median_price);

		if (_med_price.get('text').length > 8) {
			_med_price.addClass('_small');
		} else {
			_med_price.removeClass('_small');
			_med_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_med_price.addClass('_supersmall');
		}

		this._summary.removeClass('_loading');

		if (most_expensive) {
			var me = '';

			if (most_expensive.image) {
				me += '<a href="' + most_expensive.url_sold + '"  class="image" style="background-image:url(' + (most_expensive.image.t || most_expensive.image.o) + ')"></a>';
			}

			me += '<strong>Most Expensive</strong><br>' + '<a href="' + most_expensive.url_sold + '">' + (most_expensive.name || most_expensive.display_name || most_expensive.street_address) + ', <span class="unit">#' + most_expensive.unit + '</span></a><br/>' + most_expensive.bedroom.split('room').join('') + ' | ' + most_expensive.sale_price_format + '<br>' + most_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + most_expensive.sale_date + '</span>';

			this._most_expensive = this._summary.getElement('#most_exp');
			this._most_expensive.set('html', me);

			this._summary.getElement('#most_exp').show();
		} else {
			this._summary.getElement('#most_exp').hide();
		}

		if (least_expensive) {
			var le = '';

			if (least_expensive.image) {
				le += '<a href="' + least_expensive.url_sold + '" class="image" style="background-image:url(' + (least_expensive.image.t || least_expensive.image.o) + ')"></a>';
			}

			le += '<strong>Least Expensive</strong><br>' + '<a href="' + least_expensive.url_sold + '">' + (least_expensive.name || least_expensive.display_name || least_expensive.street_address) + ', <span class="unit">#' + least_expensive.unit + '</span></a><br/>' + least_expensive.bedroom.split('room').join('') + ' | ' + least_expensive.sale_price_format + '<br>' + least_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + least_expensive.sale_date + '</span>';

			this._least_expensive = this._summary.getElement('#least_exp');
			this._least_expensive.set('html', le);

			// this._least_expensive.addEvent('click',function(){
			//	 window.location = least_expensive.url_building;
			// })

			// this._summary.getElement('#least_exp').set('html', le);
			this._summary.getElement('#least_exp').show();
		} else {
			this._summary.getElement('#least_exp').hide();
		}
	},

	display_message: function display_message(show) {
		var _cont;

		if (show) {
			var nh_name = this._element.get('data-neighborhood');

			new Element('div', {
				class: 'error',
				html: 'No data available for ' + nh_name + '. <span>Please try to modified the filter.</span>'
			}).inject(this._graph_stat);

			this._graph_stat.getElement('._active').hide();

			this._veil.hide();

			this.message_displayed = true;
		} else {

			var _message = this._graph_stat.getElement('.error');
			if (!_message) return;

			this._graph_stat.getElement('._active').show();

			_message.destroy();

			this.message_displayed = false;
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var NhStatsAreaMap = new Class({
	Extends: HoodsAreaMap,
	options: {
		use_marker_path: null
	},

	get_data: function get_data() {
		var self = this;
		if (self.options.data != '') {
			self.data = self.options.data;
			self.process_rpc();
		} else {
			return;
		}
	},

	process_rpc: function process_rpc() {
		var opts = this.options,
		    data = this.data,
		    self = this;

		var new_data = {};

		data.data.each(function (el) {
			if (!new_data[el.building_id]) {
				new_data[el.building_id] = [];
			}

			if (el.display) {
				new_data[el.building_id].push(el);
			}
		});

		var num_of_markers = 0;

		Object.each(new_data, function (place) {
			if (place.length > 0) {

				if (!self.in_new_york(place[0].lat, place[0].lng)) return;

				var icon;

				if (self.options.use_marker_path) {
					icon = data.markers_path + '/bed-markers/' + (place.length > 5 ? '5' : place.length) + '_beds_12.png';
				} else {
					icon = Res_i + '/w/hoods/hood-markers/' + (place.length > 100 ? '100+' : place.length) + '.png';
				}

				self.add_marker({
					lat: place[0].lat,
					lng: place[0].lng,
					icon: icon,
					bubble: {
						content: (place[0].name || place[0].display_name || place[0].street_address || 'Unknown building') + '<span class="legend">Click on marker for more info</span>'
					},
					label: {
						content: null
					},
					base_point: 'center',
					callbacks: {
						onClick: function onClick() {
							opts.open_blimp(place[0].url_popup);
						}
					}
				});

				num_of_markers++;
			}
		});

		if (num_of_markers > 0) {
			this.fit_markers();
		} else {
			this.center_map_in_ny();
		}

		(function () {
			this.fireEvent('ready');
		}).bind(this).delay(1000);
	},

	center_map_in_ny: function center_map_in_ny() {
		var lat = 40.7646;
		var lng = -73.9777;

		var center = new google.maps.LatLng(lat, lng);

		this.map.setCenter(center);
	},

	reset_map: function reset_map() {
		this.clear_markers();
		this.process_rpc();
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var NhStatsHeatMap = new Class({
	Extends: HoodsHeatMap,

	draw_map: function draw_map() {
		var zoom = this.data.zoom || 13;

		this.map = new google.maps.Map(this._element, {

			zoom: zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		this.map.setOptions({ styles: this.options.map_styles });

		this.add_heatmap_layer();
	},

	add_heatmap_layer: function add_heatmap_layer() {
		var self = this;
		var data = this.data;
		var new_data = {};
		var data_empty = true;

		Object.each(data.data, function (el) {
			// el.each(function(e){
			if (!new_data[el.building_id]) {
				new_data[el.building_id] = [];
			}

			if (el.display) {
				new_data[el.building_id].push(el);
				data_empty = false;
			}
			// });
		});

		this.data.data = new_data;

		var heatmapData = [];

		Object.each(new_data, function (el) {

			if (el[0]) {

				if (!self.in_new_york(el[0].lat, el[0].lng)) return;

				var obj = { location: new google.maps.LatLng(el[0].lat, el[0].lng), weight: el.length };
				heatmapData.push(obj);
			}
		});

		if (this.heatmap) this.heatmap.setMap(null);

		var heatmap = this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData,
			radius: data.radius ? data.radius : 20
		});

		heatmap.setMap(this.map);

		var lat = 0,
		    lng = 0,
		    num_of_points = 0;

		Object.each(new_data, function (el) {
			if (el.length > 0) {
				if (!self.in_new_york(el[0].lat, el[0].lng)) return;

				lat += el[0].lat.toFloat();
				lng += el[0].lng.toFloat();
				num_of_points++;
			}
		});

		if (num_of_points > 0) {
			lat = lat / num_of_points;
			lng = lng / num_of_points;
		} else {
			lat = 40.7646;
			lng = -73.9777;
		}

		var center = new google.maps.LatLng(lat, lng);

		this.map.setCenter(center);
		// this.change_gradient();
		this.change_opacity();

		(function () {
			this.fireEvent('ready');
		}).bind(this).delay(1000);
	},

	change_opacity: function change_opacity() {
		this.heatmap.setOptions({ opacity: this.heatmap.get('opacity') ? null : 0.7 });
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	}
});
"use strict";

var SearchResultsMap = new Class({
	Implements: [Options, Events],

	options: {
		form: null,
		data_rpc: null,
		is_building: false,
		is_agents: false,
		label_on_marker: true,
		show_starting_price: false,
		search_type: null,
		counts_only: false, // show counts of the buildings per hood on firstload
		with_hover_icon: true,
		previous_state: null,
		page_context: null,
		icon_path: null,
		default_hood_id: null,
		is_click_style_hover: false,
		view: null,
		polygon: {
			idle: {
				strokeColor: "#bc3a5b",
				strokeWeight: 2,
				strokeOpacity: 0.4,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: true
			},
			hover: {
				fillColor: "#bc3a5b",
				fillOpacity: 0.35,
				clickable: true
			},
			active: {
				strokeColor: "#25B3E4",
				strokeWeight: 4,
				strokeOpacity: 0.8,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: false
			}
		},

		data: null
	},

	initialize: function initialize(map, options) {
		if (!map || !(map instanceof SimpleMap)) return;

		this.setOptions(options);

		this._form = this.options.form;
		this._button = this.options.button;

		this.map = map;

		this.page_id = $$('body')[0].get('id');

		this.state = new State();

		this.build();
	},

	build: function build() {
		var self = this;
		this.isFirstLoading = true;
		this.enabled = true;
		this.search_results_regions = [];
		this.rpc = this.options.data_rpc;

		if (!this.options.data) {
			self.get_data();
		} else {
			self.process_data();
		}
	},

	get_data: function get_data() {
		var self = this;
		var rpc = this.rpc;
		if (this.options.counts_only && this.options.is_building) {
			rpc += (rpc.indexOf('?') == -1 ? '?' : '&') + 'buildings=false';
		}

		if (this.options.filter_param) {
			rpc += (rpc.indexOf('?') == -1 ? '?' : '&') + this.options.filter_param;
		}

		new Remote({
			rpc: this._form != null ? this._form.getAttribute('data-rpc') + '?listings=1' : rpc,
			data: this._form != null ? '&' + this._form.toQueryString().trim() + '&ajax=1' : '',
			onSuccess: function onSuccess() {
				self.options.data = this.get_data();
				self.process_data();
			}
		});
	},

	refresh_data: function refresh_data(data, previous_region_id) {
		this.options.data = data;
		this.isFirstLoading = false;
		//don't show prev state after change criterias
		this.options.previous_state = null;
		if (this.map.current_marker) {
			this.has_opened_bubble = false;
			this.map.current_marker.marker.bubble.close();
		}
		this.process_data(previous_region_id);
	},

	process_data: function process_data(previous_region_id, changed_by_filter) {
		var self = this;
		var data = this.options.data;
		if (!data) return;

		this.map.clear_markers();
		this.fireEvent('dataLoad', data);

		this.icon_path = Res_i + '/w/simplemap/markers/';

		this.clear_regions();

		var region;
		var number_of_regions = this.number_of_regions = Object.getLength(data.listings || data.data);
		var previous_region;
		var avail_regions = [];
		var prev_state_region_id = this.options.previous_state ? this.options.previous_state.hood_id : null;
		var default_region;

		Object.each(data.listings || data.data, function (el, i) {

			var total = el.total || 0;
			var coords = el.coordinates || [];
			var has_marker;

			avail_regions.push(+i);
			//don't show marker for opened region or for restored region from previous state
			if (previous_region_id) {
				has_marker = i != previous_region_id;
			} else if (prev_state_region_id) {
				has_marker = i != prev_state_region_id;
			} else {
				has_marker = number_of_regions > 1;
			}

			region = this.set_nh(i, total, el.name, coords, has_marker);

			if (region) {
				region.url = el.url || '';
				region.name = el.name || 'Unknown';
				region.data = el.data;

				if (previous_region_id && changed_by_filter && region.region_id === previous_region_id && (data.listings || data.data)[region.region_id].data) {
					region.gross_data = (data.listings || data.data)[region.region_id].data;
				} else if (this.options.is_building && this.options.counts_only == false) {
					region.gross_data = data.data[region.region_id].data;
				} else if (!this.options.is_building && number_of_regions == 1 && data.listings[region.region_id].data) {
					region.gross_data = data.listings[region.region_id].data;
				}

				// if the region in the previous one
				if (region.region_id === prev_state_region_id || changed_by_filter && region.region_id === previous_region_id && region.gross_data) {
					previous_region = region;
				}

				if (parseInt(region.region_id, 10) === this.options.default_hood_id) {
					default_region = region;
				}
			}
		}.bind(this));

		//if thereis no data for opened region.
		if (this.current_region && avail_regions.indexOf(+this.current_region.region_id) == -1) {
			this.current_region = null;
		}

		if (number_of_regions == 1) {
			this.handle_region_click(region, this.options.previous_state);
		} else if (number_of_regions > 1) {
			if (this.isFirstLoading) {
				this.map.fit_markers();
			}
			// restore previous hood
			if (previous_region) {
				this.handle_region_click(previous_region, this.options.previous_state);
			} else if (default_region) {
				// select the default region
				this.handle_region_click(default_region);
			}
		}

		// process buildings
		if (data.buildings) {
			Object.each(data.buildings, function (el, i) {

				var building = el;
				var markerLabel = "\n\t\t\t\t\t<span class=\"arrow\"></span>\n\t\t\t\t\t<span class=\"tooltip\">\n\t\t\t\t\t\t<span class=\"tooltip-1\">" + Number(building.total).toLocaleString() + (Number(building.total) === 1 ? " Agent" : " Agents") + " in</span>\n\t\t\t\t\t\t<span class=\"tooltip-2\">" + building.name + "</span>\n\t\t\t\t\t</span>\n\t\t\t\t";
				var icon = this.icon_path + 'blg-1.png';
				var iconHover = this.icon_path + 'blg-hover-1.png';

				// var sm_marker = building.sm_marker = this.map.add_marker({
				var sm_marker = this.map.add_marker({
					lat: building.lat,
					lng: building.lng,
					icon: icon,
					// hover_icon: iconHover,
					base_point: 'center',
					// temporarily removed names from neighborhood markers
					label: {
						content: this.options.label_on_marker ? markerLabel : null,
						add_class: '_building'
					},
					scalable: true,
					callbacks: {
						onClick: function onClick() {
							self.handle_building_click(sm_marker, building);
						},

						onStopMouseover: function onStopMouseover() {
							self.handle_building_mouseover(sm_marker);
						},

						onMouseout: function onMouseout() {
							self.handle_building_mouseout(sm_marker);
						}

					}
				});

				var marker = sm_marker.marker;
			}.bind(this));
		}
	},
	clear_regions: function clear_regions() {
		if (this.search_results_regions) {
			this.search_results_regions.each(function (region) {
				region.setMap(null);
				if (region.sm_marker) {
					region.sm_marker.remove_from_map();
				}
			});
		}
		this.search_results_regions = [];
	},
	handle_region_click: function handle_region_click(region, previousState, changed_by_filter) {

		// if(!this.enabled || !region || region.is_active || !this.map.map.bubble_options.visible) return;
		if (!this.enabled || !region || !this.map.map.bubble_options.visible) return;

		var self = this;

		this.region_clicked = true;
		region.is_active = true;

		if (this.options.is_click_style_hover) {
			region.setOptions(this.options.polygon.hover);
		} else {
			region.setOptions(this.options.polygon.active);
		}

		this.fireEvent('request', region);

		if (!region.gross_data) {
			if (region.remote) {
				region.remote.cancel();
			}

			var rpc = this.rpc;
			rpc += rpc.indexOf('?') == -1 ? '?' : '&';

			if (self.options.counts_only && this.options.is_building) {
				rpc += 'hoodId=' + region.region_id;
			} else {
				rpc += 'hood=' + region.region_id;
			}

			if (this.options.filter_param) {
				rpc += '&' + this.options.filter_param;
			}

			region.remote = new Remote({
				rpc: self._form != null ? self._form.getAttribute('data-rpc') + '?listings=1&hoods[]=' + region.region_id : rpc,
				data: self._form != null ? '&' + self._form.toQueryString().trim() + '&ajax=1' : '',
				onSuccess: function onSuccess() {
					if ((this.get_data().listings || this.get_data().data)[region.region_id]) {
						region.gross_data = (this.get_data().listings || this.get_data().data)[region.region_id].data;

						// if filter has changed update the buildings of the current hood and the counts of the other hoods
						if (changed_by_filter) {
							self.options.data = this.get_data();
							self.process_data(region.region_id, changed_by_filter);
						} else {
							self.show_buildings(region, previousState);
						}
					} else if (changed_by_filter) {
						// if the current region doesnt have data pass, we still need to update the count of the other hoods
						self.options.data = this.get_data();
						self.process_data();
					}

					self.fireEvent('dataLoad', region);
				}
			});
		} else {
			this.show_buildings(region, previousState);
			this.fireEvent('dataLoad', region);
		}

		if (this.current_region && this.current_region.region_id !== region.region_id) {
			this.deactive_current_region();
		}

		if (this.current_building) {
			this.deactive_current_building();
			this.current_building = null;
		}

		if (this.current_big_bubble) {
			this.current_big_bubble.close();
		}

		if (this.isFirstLoading) {
			this.fit_region(region);
		}

		if (this.options.is_click_style_hover) {
			region.setOptions(this.options.polygon.hover);
		} else {
			region.setOptions(this.options.polygon.active);
		}

		this.current_region = region;

		_gaq.push(['_trackEvent', 'map', 'loaded', 'view_region']);
	},

	deactive_current_region: function deactive_current_region() {
		this.current_region.in_region = false;
		this.current_region.is_active = false;

		if (this.current_region.building_markers) {
			this.current_region.building_markers.each(function (el) {
				el.remove_from_map();
			});
		}
		if (this.current_region.marker) {
			this.current_region.marker.setMap(this.map.map);

			if (this.current_region.marker.label) {
				this.current_region.marker.label.open();
			}
		} else {
			this.set_marker(this.current_region);
		}
		this.handle_region_mouseout(this.current_region);
	},

	deactive_current_building: function deactive_current_building() {
		if (this.current_building) {
			this.current_building.marker.icon.url = this.icon_path + 'blg-1.png';
			this.current_building.change_icon_image(this.icon_path + 'blg-1.png');
			$(this.current_building.marker.label._bubble_content).removeClass('hover');
		}
	},

	set_marker: function set_marker(region) {
		var self = this;
		var markerLabel;
		var icon;

		// marker special for agents map
		if (this.options.is_agents) {
			markerLabel = "\n\t\t\t\t<span class=\"number\">" + Number(region.total).toLocaleString() + "</span>\n\t\t\t\t<span class=\"text\">" + (Number(region.total) === 1 ? "Agent" : "Agents") + "</span>\n\t\t\t";
			// icon =  this.icon_path + 'blg-1.png';
			icon = self.icon_path + 'region-marker.png';
		} else {
			// default markers
			markerLabel = '<span class="number">' + Number(region.total).toLocaleString() + '</span>';
			icon = self.icon_path + 'region-marker.png';
		}

		var sm_marker = region.sm_marker = this.map.add_marker({
			lat: region.center_lat,
			lng: region.center_lng,
			icon: icon,
			base_point: 'center',
			// temporarily removed names from neighborhood markers
			label: {
				content: self.options.label_on_marker ? markerLabel : null,
				add_class: '_hood'
			},
			scalable: true
		});

		var marker = region.marker = sm_marker.marker;

		this.add_events(marker, region);
	},

	set_nh: function set_nh(id, total, name, coordinates, has_marker) {
		if (!coordinates || typeOf(coordinates) != 'array' || coordinates.length < 3) return null;

		var coords = [],
		    most_top_lat,
		    most_bottom_lat,
		    most_left_lng,
		    most_right_lng,
		    center_lat,
		    center_lng,
		    center_latlng;

		var opts = this.options.polygon;

		coordinates.each(function (el) {
			if (el[0] && el[1]) {
				var latlng = new google.maps.LatLng(el[1], el[0]);
				coords.push(latlng);

				if (!most_top_lat || el[1] > most_top_lat) {
					most_top_lat = el[1];
				}

				if (!most_bottom_lat || el[1] < most_bottom_lat) {
					most_bottom_lat = el[1];
				}

				if (!most_left_lng || el[0] < most_left_lng) {
					most_left_lng = el[0];
				}

				if (!most_right_lng || el[0] > most_right_lng) {
					most_right_lng = el[0];
				}
			}
		});

		center_lat = (most_top_lat + most_bottom_lat) / 2;
		center_lng = (most_left_lng + most_right_lng) / 2;

		if (coords.length < 3) return null;

		var map = this.map.map;

		var region = new google.maps.Polygon({
			paths: coords
		});
		//keep coords to create marker later
		region.center_lat = center_lat;
		region.center_lng = center_lng;
		region.total = total;

		region.region_id = id;

		region.setOptions(opts.idle);

		this.search_results_regions.push(region);

		region.setMap(map);

		region.coordinates = coordinates;

		name = name.replace('/ ', '/');
		name = name.replace(' /', '/');
		name = name.replace(' / ', '/');
		name = name.replace('/', ' /<br/>');

		this.add_events(region, region);

		if (has_marker) {
			this.set_marker(region);
		}

		return region;
	},

	add_events: function add_events(marker, region) {
		var self = this;
		google.maps.event.addListener(marker, 'click', function () {
			self.handle_region_click(region);
		});

		google.maps.event.addListener(marker, 'mouseover', function () {
			self.handle_region_mouseover(region);
		});

		google.maps.event.addListener(marker, 'mousemove', function () {
			self.handle_region_mousemove(region);
		});

		google.maps.event.addListener(marker, 'mouseout', function () {
			self.handle_region_mouseout(region);
		});
	},

	handle_region_mouseover: function handle_region_mouseover(region) {
		if (!this.enabled || !region) return;

		if (region.is_active || region.in_region) return;

		//(function(){
		region.setOptions(this.options.polygon.hover);
		//}.bind(this)).delay(20);

		region.in_region = true;
	},

	handle_region_mousemove: function handle_region_mousemove(region) {
		if (!this.enabled || !region) return;

		if (this.map.map.bubble_options.visible) {
			this.handle_region_mouseover(region);
		} else {
			this.handle_region_mouseout(region);
		}
	},

	handle_region_mouseout: function handle_region_mouseout(region) {
		if (!this.enabled || !region || region.is_active) return;

		(function () {
			if (!region.in_region) {
				region.setOptions(this.options.polygon.idle);
			}
		}).bind(this).delay(20);

		region.in_region = false;
	},

	handle_building_click: function handle_building_click(smmarker, building) {

		this.deactive_current_region();

		this.deactive_current_building();

		this.current_building = smmarker;

		smmarker.change_icon_image(this.icon_path + 'blg-hover-1.png');
		$(smmarker.marker.label._bubble_content).addClass('hover');

		this.fireEvent('request', building);
	},

	handle_building_mouseover: function handle_building_mouseover(smmarker) {
		smmarker.change_icon_image(this.icon_path + 'blg-hover-1.png');
		$(smmarker.marker.label._bubble_content).addClass('hover');
	},

	handle_building_mouseout: function handle_building_mouseout(smmarker) {
		if (this.current_building === smmarker) return;

		smmarker.change_icon_image(this.icon_path + 'blg-1.png');
		$(smmarker.marker.label._bubble_content).removeClass('hover');
	},

	fit_region: function fit_region(region) {
		if (!region) return;
		var bounds = new google.maps.LatLngBounds();
		var points = [];

		region.coordinates.each(function (el) {
			var point = new google.maps.LatLng(el[1], el[0]);
			bounds.extend(point);
			points.push(point);
		});

		this.map.map.fitBounds(bounds);
	},

	show_buildings: function show_buildings(region, previousState) {

		var data = region.gross_data;

		if (!data || data.length == 0) return;

		var self = this;

		if (region.sm_marker) {
			region.sm_marker.remove_from_map();
		}

		if (region.building_markers) {
			region.building_markers.each(function (el) {
				el.marker.setMap(self.map.map);
				if (el.marker.label) {
					el.marker.label.open();
				}
			});

			return;
		}

		region.building_markers = [];

		Object.each(data, function (el, i) {
			if (!self.in_new_york(el.lat, el.lng)) return;

			var total = (el.total && el.total > 1 ? el.total : '') + '';

			var marker;
			var currentBuildingId = 'building-' + i;

			// set if you want to open the tooltip for this marker
			var initOpen = previousState && previousState.building_id === currentBuildingId ? true : false;

			var sm_marker = self.map.add_marker({
				id: currentBuildingId,
				init_open: initOpen,
				lat: el.lat,
				lng: el.lng,
				label: {
					content: self.options.label_on_marker ? '<span class="">' + total + '</span>' : '<span class="">' + total + '</span>', //
					add_class: '_building _' + i + (total.length > 0 ? ' _with_count _size_' + (total.length > 4 ? 4 : total.length) : '') + (el.offer_tag_id ? ' _offer_' + el.offer_tag_id : '')
				},
				icon: (self.options.icon_path || self.icon_path) + (total.length > 4 ? 4 : total.length) + '.png',
				hover_icon: self.options.with_hover_icon ? self.icon_path + (total.length > 4 ? 4 : total.length) + '-hover-red.png' : null,
				bubble: {
					content: self.get_bubble_content(el),
					add_class: self.options.is_building ? '_building' : '_big',
					offset: {
						x: 16,
						y: -45
					},
					side: 'right'
				},
				base_point: 'center',
				center_on_click: self.options.is_building ? true : false,
				current_bubble_open_on_mouseover: self.options.is_building ? true : false,
				onBubbleReady: function onBubbleReady(_el) {
					if (el.bubble_is_ready) return;

					var _ul = _el.getElement('ul');

					_el.addEvents({
						'mouseenter': function mouseenter() {
							self.in_bubble = true;
						},

						'mouseleave': function mouseleave() {
							self.in_bubble = false;

							// if(self.options.is_building){
							//	 _el.getElement('.w_googlemaps_infobox_content').set('html', self._prev_content);
							// }
						}
					});

					if (_ul && _ul.getSize().y > _el.getSize().y) {
						_ul.setStyles({
							'overflow-y': 'scroll',
							'max-height': 210
						});
					}

					var _lis = _el.getElements('li');

					_lis.each(function (_e) {
						if (_e.getAttribute('data-rpc')) {
							var tmpRpc = _e.getAttribute('data-rpc');
							if (tmpRpc.indexOf('/rpc/listing-popup') != -1) {
								_e.setAttribute('data-rpc', tmpRpc.replace('/rpc/listing-popup', '/rpc/listing-popup-v2'));
							}
							var display = 'map';
							if (_e.getAttribute('data-images-cnt') && parseInt(_e.getAttribute('data-images-cnt'), 10) > 0) {
								display = 'gallery';
							}
							_e.blimp = new BlimpExtV2(_e, {
								cache: true,
								draggable: true,
								show_veil: true,
								display: display,
								withThumbnails: true,
								fullscreen: true,

								onFetch: function onFetch() {
									// Save state : send event to mapmultipleview, because we need the criteria etc
									self.fireEvent('saveState', { building_id: currentBuildingId });

									sm_marker.marker.clicked = true;
									self.region_clicked = false;
									self.fireEvent('request');

									_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
								},

								onPostRpc: function onPostRpc() {
									this.add_extra(true);

									self.fireEvent('dataLoad');

									Core.compile_html(this._element);
								},

								onHide: function onHide() {
									// delete state
									self.state.remove(self.page_id);

									if (this.email_blimp) {
										this.email_blimp.hide();
									}

									if (this.save_blimp) {
										this.save_blimp.hide();
									}
								}
							});
						} else if (_e.getAttribute('data-url')) {
							_e.addEvent('click', function () {
								window.location = _e.getAttribute('data-url');
							});
						}
					});

					if (_ul) {
						_ul.addEvent('click:relay("li a")', function (e, i) {
							if (e && e.stop) e.stop();

							self.fireEvent('request', [e, i]);
						});
					}

					el.bubble_is_ready = true;
				},

				callbacks: {
					onClick: function onClick() {
						// open the buble when the user click the other marker and close the current open bubble.
						if (self.map.current_marker && self.map.current_marker != sm_marker) {
							self.has_opened_bubble = false;

							if (self.options.is_building) {
								if (self.map.current_marker) {
									self.map.current_marker.marker.bubble.close();
								}
							}

							if (self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
								self.map.current_marker.marker.label._bubble_content.removeClass('_active');
							}

							google.maps.event.trigger(sm_marker.marker, "mouseover");
						}

						self.has_opened_bubble = true;

						self.map.current_marker = sm_marker;

						self.current_big_bubble = sm_marker.marker.bubble;

						// add active class to the label of the current marker
						if (self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
							self.map.current_marker.marker.label._bubble_content.addClass('_active');
						}

						if (!self.options.is_building) return;

						(function () {
							var _bubble = sm_marker.marker.bubble.infobox._div;

							if (!_bubble) return;

							_bubble.addClass('_big');

							sm_marker.marker.bubble.open();

							if (_bubble.rater) return;

							var _inds = _bubble.getElements('.indicator');

							_bubble.rater = new Rater(_inds, {
								'property': 'data-value',
								'size': 'absolute',
								'animate': false,
								'type': 'horisontal',
								'max_size': 284
							});
						}).delay(10);
					},

					onMouseout: function onMouseout() {
						if (self.options.is_building && !sm_marker.marker.clicked) {
							if (sm_marker.marker.bubble && sm_marker.marker.bubble.infobox) {
								var _bubble = sm_marker.marker.bubble.infobox._div;

								if (!_bubble) return;

								sm_marker.marker.bubble.infobox._div.removeClass('_big');
							}
						}
					},

					onStopMouseover: function onStopMouseover() {
						if (!self.options.is_building && self.has_opened_bubble) {
							return true;
						}

						return false;
					},

					onBubbleClose: function onBubbleClose() {
						self.has_opened_bubble = false;

						// remove the active class to the label of the current marker when the bubble is closed.
						if (self.map.current_marker && sm_marker === self.map.current_marker && self.map.current_marker.marker.label && self.map.current_marker.marker.label._bubble_content) {
							self.map.current_marker.marker.label._bubble_content.removeClass('_active');
						}
					}
				}
			});

			region.building_markers.push(sm_marker);
		});
	},

	get_bubble_content: function get_bubble_content(data) {
		var header = '';

		if (data.name && data.name != '') {
			header += '<span>' + data.name + '</span>' + data.address + (data.type && data.type != '' ? '<br/>' : '') + '<span class="type' + (data.type.toLowerCase() == 'rental' ? ' _dark' : '') + '">' + data.type + '</span>';
		} else {
			header += '<span>' + data.address + '</span>';
		}

		var content;

		if (this.options.is_building) {
			content = this.get_building_map_bubble_content(data);
		} else {
			var self = this;
			var listings_amount = 0;
			var lis = '';

			this.bubble_images = [];

			Object.each(data.data, function (el) {
				var add_class = el.mask_id ? ' _' + el.mask_id : '';
				var url = self.options.page_context ? el.url + '&pageContext=' + self.options.page_context : el.url;
				if (typeof self.options.view != "undefined" && self.options.view) {
					url += "&view=" + self.options.view;
				}

				var image = window.Missing_img_horisontal;
				var imagesCnt = 0;
				if (el.thumbor_images && el.thumbor_images.length > 0) {
					image = Core.get_smart_image(120, 78, el.thumbor_images[0]);
					imagesCnt = el.thumbor_images.length;
				} else {
					image = el.image;
				}
				lis += '<li data-class="w_blimp_listing" class="clearfix ' + add_class + '" data-' + (el.sold ? 'url' : 'rpc') + '="' + url + '" data-images-cnt="' + imagesCnt + '">' + '<span class="image left">' + '<img src="' + image + '" onerror="this.src=\'' + Missing_img_horisontal + '\';"/>' + '</span>' + '<span class="description">' + (el.unit && el.unit != '' ? '<span class="name ' + (el.in_contract ? '' : 'mt_10') + '">Apt. ' + el.unit + '</span>' : '') + (el.display_bedrooms ? el.display_bedrooms : '') + (el.display_bathrooms ? ', ' + el.display_bathrooms : '') + (el.price ? '<span class="price">' + el.price + '</span>' : '') + (self.options.search_type == 'transactions' && el.sale_date ? '<span class="sold_date"> Sold ' + el.sale_date + '</span>' : '') + (el.in_contract ? '<span class="flag_incontract">In contract</span>' : '') + '</span>' + '</li>';

				listings_amount++;

				self.bubble_images.push(el.image);
			});

			content = '<h3>' + header + '</h3>' + '<ul>' + lis + '</ul>';
		}

		return content;
	},

	get_building_map_bubble_content: function get_building_map_bubble_content(data) {
		var bubble = '' + '<div class="clearfix">' + '<div class="photo_container">' + '<a href="' + data.url + '"><img src="' + (data.photo ? data.photo : Missing_img) + '" onerror="this.src=\'' + Missing_img + '\';"/></a>' + '</div>' + '<div class="info_container clearfix">' + '<div class="name">' + '<a href="' + data.url + '">' + (data.name ? data.name : data.address) + '</a>' + '</div>' + (data.name && data.address ? '<div class="address"><a href="' + data.url + '">' + data.address + '</a></div>' : '') + (data.type ? '<div class="type">' + data.type + '</div>' : '');

		if (this.options.show_starting_price) {
			if (data.avg_price && data.avg_price != '' || data.total && data.total != '') {
				if (data.avg_price && data.avg_price != '') {
					bubble += '<div class="starting_price">' + 'Starting from $<strong>' + Core.add_commas(data.avg_price.toFixed()) + '</strong>' + '</div>';
				}

				if (data.total && data.total != '') {
					bubble += '<div class="available_apts">' + 'Apt' + (data.total > 0 ? 's' : '') + ' Available for ' + (data.type.capitalize() != 'Rental' ? 'sale' : 'rent') + ': <strong>' + data.total + '</strong>' + '</div>';
				}
			} else {
				bubble += '<div class="no_price">No price information available</div>';
			}
		} else {
			if (data.avg_ppsqft && data.avg_ppsqft != '' && data.listings_avg_ppsqft && data.listings_avg_ppsqft != '') {
				bubble += '<div class="avg_price">' + '<div class="price">$' + Core.add_commas(data.avg_ppsqft.toFixed()) + '</div>' + 'Avg. Price / Ft<sup>2</sup> (Recent Closings)' + '<div class="indicator building" data-value="' + data.avg_ppsqft + '">&nbsp;</div>' + '<strong>$' + Core.add_commas(data.listings_avg_ppsqft.toFixed()) + '</strong>' + 'Avg. Price / Ft<sup>2</sup> (Currently Available)' + '<div class="indicator listing" data-value="' + data.listings_avg_ppsqft + '">&nbsp;</div>' + '</div>';
			} else if (data.avg_ppsqft && data.avg_ppsqft != '' || data.listings_avg_ppsqft && data.listings_avg_ppsqft != '') {
				var price = data.avg_ppsqft && data.avg_ppsqft != '' ? data.avg_ppsqft : data.listings_avg_ppsqft;
				var spec = data.avg_ppsqft && data.avg_ppsqft != '' ? 'Recent Closings' : 'Currently Available';

				price = Core.add_commas(price.toFixed());

				bubble += '<div class="avg_price no_indicator building">' + '<div class="price">$' + price + '</div>' + 'Avg. Price / Ft<sup>2</sup> (' + spec + ')' + '</div>';
			} else if (data.providers && data.url.contains('furnished')) {
				bubble += '<div class="providers"><strong>' + data.providers + (data.providers > 1 ? ' companies' : ' company') + '</strong> w/ Furnished Apartments</div>';
			} else {
				bubble += '<div class="no_price">No price information available</div>';
			}
		}

		bubble += (data.url ? '<a class="button" href="' + data.url + '">View Complete Building Info</a>' : '') + '</div>' + '</div>' + '<span class="legend">Click on marker for more info</span>';

		return bubble;
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	},

	enable: function enable() {
		this.enabled = true;
	},

	disable: function disable() {
		this.enabled = false;
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var HoodStats = new Class({
	Implements: [Options, Events],

	options: {
		with_message: true,
		hood_id: null,
		store_data: true
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.build();
	},

	build: function build() {
		var self = this;
		this.first_load = true;

		this._charts = this._element.getElements('.chart');

		this._charts.each(function (_el) {
			_el.addEvent('show', function () {
				self.show_chart(_el);
			});
		});

		this._current_chart = this._charts[0];
		this._current_chart.show().fireEvent('show');

		if (this.options.with_message) {
			this.set_message();
		}

		var _main_select = this._element.getElement('.w_styled_select');

		new StyledSelect(_main_select, {
			onChange: function onChange(_el) {
				if (self._current_chart) {
					self._current_chart.hide();
				}

				self._current_chart = self._element.getElement('#' + _el.getAttribute('data-id'));

				if (self._current_chart) {
					self._current_chart.show().fireEvent('show');
				}

				if (self._message) self._message.fade('out');
			}
		});

		if (Cookie.read('rc_back_here') && Cookie.read('rc_back_here') == 'true') {
			//to select the Most Recent Sale chart (CRTWO-1923)
			_main_select.getElements('.option').each(function (_el) {
				if (_el.get('text') == 'Most Recent Closings') {
					_el.fireEvent('click');
				}
			});
		}
	},

	show_chart: function show_chart(_chart) {
		if (_chart.rpc_data) return;

		var self = this;
		var params = '&';
		var is_recent_sales = _chart.get('id') == 'most_recent_closings' ? true : false;
		this.types = '';
		this.beds = '';

		_chart.getElements('.w_multiselect').each(function (_el) {
			_el.multiselect = _el.multiselect || new Multiselect(_el, {
				text_input: false,
				close_button: false,
				suspension_points: true,
				equality: true,
				add_tiles: false,
				onChange: function onChange() {
					self.rebuild_chart(_chart);
				}
			});

			_el.getElements('li._selected').each(function (_e) {
				params += _el.getAttribute('data-param') + '=' + _e.getAttribute('data-param-id') + '&';

				if (is_recent_sales) {
					switch (_el.get('data-param')) {
						case 'type[]':
							self.types += ' ' + _e.getAttribute('data-param-id');
							break;
						case 'bedrooms[]':
							self.beds += ' ' + _e.getAttribute('data-param-id');
							break;
					}
				}
			});
		});

		_chart.getElements('.w_styled_select').each(function (_el) {
			_el.styledselect = _el.styledselect || new StyledSelect(_el, {
				onChange: function onChange() {
					self.rebuild_chart(_chart);
				}
			});

			_el.getElements(':selected').each(function (_e) {
				params += _el.getAttribute('data-param') + '=' + _e.getAttribute('data-param-id') + '&';

				if (is_recent_sales) {
					switch (_el.get('data-param')) {
						case 'type':
							self.types += ' ' + _e.getAttribute('data-param-id');
							break;
						case 'start_date':
							self.period = _e.getAttribute('data-param-id');
							break;
						case 'currency':
							self.currency = _e.getAttribute('data-param-id');
							break;
					}
				}
			});
		});

		(function () {
			if (is_recent_sales && Cookie.read('rc_previous_filter') && Cookie.read('rc_back_here') && Cookie.read('rc_back_here') == 'true') {
				self.apply_recent_sales_previous_filter(_chart, Cookie.read('rc_previous_filter'));
				Cookie.dispose('rc_back_here');
			}

			if (is_recent_sales) {
				self.set_recent_sales_cookie_filter();
			}
		}).delay(100);

		this._veil = _chart.getElement('.veil');

		if (this._veil) {
			this._veil.show();
		}

		var rpc = _chart.getAttribute('data-rpc') + params;
		var data_container = 'data-nhsalesdata-' + this.options.hood_id; // holds the first rpc result and use it when the user comes back to this hood instead of the new rpc request

		if (this.first_load && Core.get_session_data(data_container)) {
			if (this._veil) {
				this._veil.hide();
			}

			_chart.rpc_data = Core.get_session_data(data_container);
			_chart.chart = this['create_' + _chart.get('id')](_chart);
			this.first_load = false;
		} else if (rpc && rpc != '') {
			if (this.remote) {
				this.remote.cancel();
			}

			this.remote = new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					if (self._veil) {
						self._veil.hide();
					}

					if (self.options.store_data && !Core.get_session_data(data_container)) {
						Core.set_session_data(data_container, self.remote.get_data());
					}

					_chart.rpc_data = self.remote.get_data();
					_chart.chart = self['create_' + _chart.get('id')](_chart);
					self.first_load = false;
				}
			});
		} else {
			_chart.rpc_data = true;
			this._veil.hide();
		}
	},

	rebuild_chart: function rebuild_chart(_chart) {
		_chart.rpc_data = null;

		if (_chart.chart) {
			delete _chart.chart;
			//_chart.chart.destroy();// may be need to do something more/else, since it could be not only highchart here
		}

		this.show_chart(_chart);
	},

	create_sales_price_chart: function create_sales_price_chart(_box) {
		var self = this;
		var series = [];
		var _container = _box.getElement('.w_graph_stat') || _box.getElement('.w_divtable');

		this._currency_select = _box.getElement('.w_styled_select._currencies select');
		this.currency_symbol = _box.getElement('.w_styled_select._currencies .selected').getElement('.symbol').get('text');
		this.type = _box.getElement('.w_styled_select._apt_types .selected').get('text').toLowerCase();

		this._price_type_select = _box.getElement('.w_styled_select._price_types select');
		this.price_type = this._price_type_select.getElement(':selected').get('value');

		var graph_colors = {
			'regular': {
				'borough': {
					0: '#0baff4',
					10: '#b19f00',
					11: '#018f9b',
					12: '#b4224a',
					13: '#383b66',
					14: '#ff5a00'
				},
				'hood': {
					0: '#73cff6',
					10: '#ad9d34',
					11: '#2f929c',
					12: '#b53658',
					13: '#484a67',
					14: '#fe6b1b'
				}
			},
			'darker': {
				'hood': {
					0: '#58c9f9',
					10: '#b4a333',
					11: '#2d9aa5',
					12: '#c2395e',
					13: '#4c4f70',
					14: '#f36416'
				}
			}
		};

		Object.each(_box.rpc_data, function (el, key) {
			Object.each(el, function (e, i) {
				Object.each(e, function (ee, ind) {
					var new_data = [];

					Object.each(ee, function (eee, x) {
						//to elimate "0" from the data
						if (eee[1] > 0) {
							new_data.push(eee);
						}
					});

					var colors = graph_colors['regular'];

					var data_series = {
						name: key == 'borough' ? _box.getAttribute('data-borough') : _box.getAttribute('data-hoodname'),
						//color: (ind == 0)? '#73cff6' : graph_colors[ind],
						color: key == 'borough' ? colors['borough'][ind] : colors['hood'][ind],
						dashStyle: key == 'borough' ? 'ShortDot' : '',
						data: new_data,
						lineWidth: key == 'borough' ? 2.5 : 5,
						data_type: key,
						data_index: ind
					};

					series.push(data_series);
				});
			});
		});

		var chart_options = {
			chart: {
				renderTo: _container,
				type: 'spline',
				backgroundColor: '#666',
				marginLeft: 35,
				marginTop: 40
			},

			series: series,

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				enabled: false
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#ccc'
					}
				}
			},

			yAxis: {
				//type: 'logarithmic',
				plotLines: [{
					// value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					useHTML: true,
					text: 'Price per ft<sup>2</sup>',
					margin: 20,
					style: {
						color: '#ccc'
					}
				},

				labels: {
					align: 'left',
					style: {
						color: '#ccc'
					},
					y: -4,
					x: 0,
					formatter: function formatter() {
						var currency_code = self._currency_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol;
						}

						return self.currency_symbol + Core.add_commas(this.value);
					}
				},

				gridLineDashStyle: 'dash',
				endOnTick: false,
				showLastLabel: true,
				minPadding: 0,
				opposite: false
			},

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#999',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true,
					cursor: 'pointer',
					events: {
						mouseOver: function mouseOver(e) {
							var opts = this.options;
							var colors = graph_colors['darker'];
							var bed_index = opts.data_index.toInt();

							if (opts.data_type == 'hood') {
								opts.states.hover.lineWidth = 5;
								this.graph.attr('stroke', colors.hood[bed_index]);
							}
						},
						mouseOut: function mouseOut() {
							var opts = this.options;
							var colors = graph_colors['regular'];

							if (this.options.data_type == 'hood') {
								this.graph.attr('stroke', colors.hood[opts.data_index]);
							}
						}
					}
				},

				spline: {
					dataGrouping: {
						groupPixelWidth: 5,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					},
					// lineWidth: 5,

					// states: {
					// 	hover: {
					// 		halo:{
					// 			opacity: 0
					// 		}
					// 		//lineWidth: 5
					// 	}
					// },

					marker: {
						enabled: false,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},

			tooltip: {
				formatter: function formatter() {
					var details, c_price;
					var current = this.y;
					var currency_code = self._currency_select.getElement(':selected').get('value');
					var title = (this.series.options.data_type == 'borough' ? 'All ' : '') + this.series.name;

					if (currency_code == 'XAU') {
						c_price = Core.add_commas(current.toFixed(1)) + ' ' + self.currency_symbol;
					} else if (currency_code == 'RUB') {
						c_price = Core.add_commas(current.toFixed()) + ' ' + self.currency_symbol;
					} else {
						c_price = self.currency_symbol + Core.add_commas(current.toFixed());
					}

					details = '<b><span style="color:' + this.series.color + '">' + title + '</span></b><br>' + '<b><span>' + Highcharts.dateFormat('%b %e, %Y', this.x) + ': ' + self.price_type.capitalize() + ' ' + Core.capitalize(self.type) + ' price (per sq ft): </span>' + c_price + '</b>';

					return details;
				},
				useHTML: true,
				valueDecimals: 0,
				shared: false,
				crosshairs: false,
				borderWidth: 2,
				style: {
					width: '300px'
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#999',
				rifleColor: '#fff',
				buttonBackgroundColor: '#999',
				buttonArrowColor: '#fff',
				trackBackgroundColor: '#aaa'
			},

			legend: {
				enabled: false,
				align: 'right',
				verticalAlign: 'bottom',
				title: {
					enabled: true,
					text: 'KEY',
					style: {
						color: '#000',
						fontWeight: 'bold'
					}
				},
				x: 25,
				y: 65,
				floating: true,
				borderWidth: 0,
				symbolPadding: 10,
				symbolWidth: 25,
				itemWidth: 100,
				itemDistance: 10,
				style: {
					align: 'right'
				}
			}
		};

		var __chart_callback = function __chart_callback(chart) {
			var _graph_legends = document.getElement('.w_graph_legends');
			var series_names = [];
			if (!_graph_legends) return;

			_graph_legends.show();

			chart.series.each(function (series) {
				series_names.push(series.name);
			});

			series_names.combine(series_names); // to remove duplicates

			var _legend_lis = _graph_legends.getElements('li');

			_legend_lis.each(function (_legend, i) {

				if (!series_names.contains(_legend.get('data-name'))) {
					_legend.removeClass('_active');
				}

				_legend.addEvent('click', function () {

					if (_legend.hasClass('_active') && chart.series) {
						chart.series.each(function (el) {
							if (el.name == _legend.get('data-name')) {
								_legend.removeClass('_active');
								el.hide();
							}
						});
					} else {
						if (chart.series) {
							chart.series.each(function (el) {
								if (el.name == _legend.get('data-name')) {
									_legend.addClass('_active');
									el.show();
								}
							});
						}
					}
				});

				if (!_legend.hasClass('_active')) {
					_legend.addClass('_active');
					_legend.fireEvent('click');
				}
			});
		};

		return new Highcharts.StockChart(chart_options, __chart_callback);
	},

	create_sales_summary: function create_sales_summary(_box) {
		var self = this;
		var _container;
		var _tools = _box.getElements('.w_graph_tools a');
		var first_click = true;

		var nh = new NhStatsExt(_box, {
			_veil: _box.getElement('.w_graph_stat .stat_veil'),
			map_markers_path: _box.rpc_data.map_markers_path,
			'onReady': function onReady() {
				if (this._veil) {
					this._veil.hide();
				}
			}
		});

		this._legend = _box.getElement('.w_graph_stat .legend');
		this._beds = _box.getElement('.w_graph_header .w_multiselect._beds');

		if (this._legend && this._beds) this.set_legend();

		var container_list = [nh._graph_cont, nh._areamap_cont, nh._heatmap_cont];

		_tools.each(function (_a, i) {
			_a.removeEvents().addEvents({
				'click': function (e) {
					if (e && e.stop) e.stop();

					if (nh._veil && !first_click) {
						nh._veil.show();
					}

					if (_container) {
						_container.removeClass('_active');
						_container.hide();
					}

					_tools.removeClass('_active');
					_a.addClass('_active');
					container_list[i].addClass('_active');
					container_list[i].show();
					_container = container_list[i];

					nh.data = _box.rpc_data;

					switch (i) {
						case 0:
							nh.display_graph();
							self.graph_mode = true;
							break;
						case 1:
							self.graph_mode = false;
							nh.display_areamap();
							break;
						case 2:
							self.graph_mode = false;
							nh.display_heatmap();
							break;
					}
					self.adjust_legend();
					nh.set_summary();
					self.active_sales_summary_nav = i;
					first_click = false;
				}.bind(this)
			});
		}.bind(this));

		if (self.active_sales_summary_nav) {
			_tools[self.active_sales_summary_nav].fireEvent('click');
		} else {
			_tools[0].fireEvent('click');
		}

		return nh;
	},
	set_legend: function set_legend() {
		var self = this;
		this._legend.getElements('li').each(function (_el) {
			_el.removeEvents().addEvent('click', function () {
				var param = _el.get('data-param-id');
				var _bed = self._beds.getElement('li[data-param-id=' + param + ']');

				if (_bed) _bed.fireEvent('click');
			});
		});
	},
	adjust_legend: function adjust_legend() {

		if (this._legend && this._beds) {
			var _error = this._element.getElement('.w_graph_stat .error');

			if (_error || !this.graph_mode) {
				this._legend.hide();
				return;
			}

			var self = this;
			var no_selected = true;
			this._beds.getElements('li').each(function (_bed) {
				var param = _bed.get('data-param-id');
				var _leg = self._legend.getElement('li[data-param-id=' + param + ']');

				if (_bed.hasClass('_selected')) {
					_leg.removeClass('_inactive').addClass('_selected');
					no_selected = false;
				} else {
					_leg.removeClass('_selected').addClass('_inactive');;
				}
			});

			if (no_selected) this._legend.getElements('li').removeClass('_inactive');

			this._legend.show();
		}
	},
	create_most_recent_closings: function create_most_recent_closings(_box) {
		var rs = new HoodStats.MostRecentClosings(_box, {
			data: _box.rpc_data
		});

		return rs;
	},

	create_building_comparisons: function create_building_comparisons(_box) {
		var mibc = new MIBCExt(_box, {
			data: _box.rpc_data,
			move_on_mousewheel: false,
			_veil: this._veil
		});

		return mibc;
	},

	create_same_unit_comparison: function create_same_unit_comparison(_box) {
		var self = this;
		var series = [];
		var _container = _box.getElement('.w_graph_stat') || _box.getElement('.w_divtable');
		var data = _box.rpc_data;
		var graph_colors = ['#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00'];

		self.sales = [];

		Object.each(data, function (el, i) {
			var data_series = [];
			Object.each(el.data, function (e) {
				data_series.push([e[0], e[1], e[2]]);
			});

			Object.each(el.sales, function (e, i) {
				self.sales[i] = e;
			});

			if (data_series.length > 0) {
				series.push({
					name: i,
					color: graph_colors[i],
					data: data_series
				});
			}
		});

		var chart = new Highcharts.StockChart({
			chart: {
				renderTo: _container,
				type: 'line',
				backgroundColor: '#666',
				marginLeft: 35
			},

			series: series,

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				enabled: false
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#ccc'
					}
				}
			},

			yAxis: {
				// type: 'logarithmic',
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					useHTML: true,
					text: 'CLOSING PRICE',
					margin: 25,
					style: {
						color: '#ccc'
					}
				},

				labels: {
					style: {
						color: '#ccc'
					},
					y: -5,
					formatter: function formatter() {
						return Core.add_commas(this.value);
					}
				},

				gridLineDashStyle: 'dash',
				endOnTick: false,
				showLastLabel: true,
				minPadding: 0
			},

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#999',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true,
					cursor: 'pointer'
				},

				line: {
					dataGrouping: {
						// smoothed: true,
						groupPixelWidth: 5,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					},
					lineWidth: 5,

					states: {
						hover: {
							lineWidth: 5
						}
					},

					marker: {
						enabled: true,
						symbol: 'circle',
						radius: 6,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},

			tooltip: {
				useHTML: true,
				valueDecimals: 0,
				shared: false,
				crosshairs: false,
				borderWidth: 2,
				style: {
					width: '300px'
				},
				formatter: function formatter(e) {
					var data = self.sales[this.x];
					var content = data;

					return content;
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#999',
				rifleColor: '#fff',
				buttonBackgroundColor: '#999',
				buttonArrowColor: '#fff',
				trackBackgroundColor: '#aaa'
			}
		});

		return chart;
	},

	set_message: function set_message() {
		this._message = this._element.getElement('.message');
		this._message.fade('in');
	},

	set_recent_sales_cookie_filter: function set_recent_sales_cookie_filter() {
		this.filter = [];
		this.filter.push(this.types, this.beds, this.period, this.currency);

		Cookie.write('rc_previous_filter', JSONMOO.encode(this.filter));
	},

	apply_recent_sales_previous_filter: function apply_recent_sales_previous_filter(_chart, filter) {
		filter = JSONMOO.decode(filter, false);
		var types = filter[0] != '' ? filter[0].trim().split(' ').join(',') : '';
		var beds = filter[1] != '' ? filter[1].trim().split(' ').join(',') : '';
		var period = filter[2];
		var currency = filter[3];

		_chart.getElements('.w_multiselect').each(function (_el) {
			_el.getElements('li').each(function (_e) {
				if (_el.hasClass('_apt_types') && types && types.contains(_e.getAttribute('data-param-id'))) {
					_e.fireEvent('click');
				} else if (_el.hasClass('_beds') && beds && beds.contains(_e.getAttribute('data-param-id'))) {
					_e.fireEvent('click');
				}
			});
		});

		_chart.getElements('.w_styled_select').each(function (_el) {
			var _options = _el.getElements('.option');

			_el.getElements('option').each(function (_e, i) {
				if (_el.hasClass('_period') && period == _e.getAttribute('data-param-id')) {
					_options[i].fireEvent('click');
				} else if (_el.hasClass('_currencies') && currency == _e.getAttribute('data-param-id')) {
					_options[i].fireEvent('click');
				}
			});
		});
	}
});
HoodStats.MostRecentClosings = new Class({
	Implements: [Options, Events],

	options: {
		data: null,
		_veil: null,
		colors: {
			10: '#b19f00',
			11: '#018f9b',
			12: '#b4224a',
			13: '#484a67',
			14: '#ff5a00'
		}
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element;;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._container = this._element.getElement('.table');
		this._title = this._element.getElement('.title');
		this._info = this._element.getElement('.reg_info');
		this._period_select = this._element.getElement('.w_styled_select._period select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');
		this.currency_id = this._currency_select.getElement(':selected').get('value');
		this.currency = 'currency=' + this.currency_id + '&';
		this.data = this.options.data;

		this.create_list_view();

		this._title.set('text', this._period_select.getElement(':selected').get('text') + ':');

		this._info.set('html', this.get_info());
	},

	set_beds: function set_beds() {
		var data = this.data.list;
		var beds = [[], [], [], [], []];

		data.each(function (el) {
			var b = el.bedroom.toLowerCase();

			if (b == 'studio' || b == 0) {
				beds[0].push(el);
			} else if (b == '1 bedroom' || b == 'one bedroom' || b == 'one' || b == 1) {
				beds[1].push(el);
			} else if (b == '2 bedrooms' || b == 'two bedrooms' || b == 'two' || b == 2) {
				beds[2].push(el);
			} else if (b == '3 bedrooms' || b == 'three bedrooms' || b == 'three' || b == 3) {
				beds[3].push(el);
			} else if (b.contains('bedrooms')) {
				beds[4].push(el);
			}
		});

		this.sorted_by_beds_data = {
			'studio': beds[0],
			'one': beds[1],
			'two': beds[2],
			'three': beds[3],
			'four': beds[4]
		};

		this.sorted_data = this.sorted_by_beds_data;
	},

	get_info: function get_info() {
		var data = this.data;
		var sales = 0;
		var median_sales_count = 0;
		var ppsqft = 0;
		var med_price;
		var med_prices_array = [];

		Object.each(data.list, function (el) {
			if (el.ppsqft) {
				median_sales_count++;
			}
			sales++;
			ppsqft += (el.ppsqft || 0).toFloat();
			med_prices_array.push(el.sale_price.toFloat());
		});

		if (sales == 0) return '<div class="err">There are no recent sales that match the criteria</div>';

		med_prices_array = med_prices_array.sort(function (a, b) {
			return a - b;
		});

		if (med_prices_array.length % 2 == 0) {
			med_price = ((med_prices_array[med_prices_array.length / 2] + med_prices_array[med_prices_array.length / 2 - 1]) / 2).round(0);
		} else {
			med_price = med_prices_array[(med_prices_array.length / 2).floor()].round(0);
		}

		if (this.currency_id.toLowerCase() == 'xau' || this.currency_id.toLowerCase() == 'rub') {
			ppsqft = ppsqft == 0 ? 'N/A' : Core.add_commas((ppsqft / median_sales_count).round(this.currency_id.toLowerCase() == 'xau' ? 2 : 0)) + ' <span class="cs">' + this.data.currency_symbol + '</span>';
			med_price = Core.add_commas(med_price) + ' <span class="cs">' + this.data.currency_symbol + '</span>';
		} else {
			ppsqft = ppsqft == 0 ? 'N/A' : '<span class="cs">' + this.data.currency_symbol + '</span>' + Core.add_commas((ppsqft / median_sales_count).round(ppsqft / median_sales_count > 100 ? 0 : 2));
			med_price = '<span class="cs">' + this.data.currency_symbol + '</span>' + Core.add_commas(med_price);
		}

		var info = '<ul class="clearfix ' + (Core.get_html_text(this.data.currency_symbol).length > 1 ? '_letters' : '') + '">' + '<li class="_first"><span class="big">' + sales + '</span>Total Sales</li>' + '<li><span class="big">' + ppsqft + '</span>Median Price / Ft<sup>2</sup></li>' + '<li><span class="big">' + med_price + '</span>Median Price</li>' + '</ul>';

		return info;
	},

	create_list_view: function create_list_view() {
		var self = this;
		var _divtable = self._element.getElement('.w_divtable');
		self._trs = [];

		if (_divtable) {
			_divtable.empty();
		} else {
			_divtable = new Element('.w_divtable');
		}

		var _thead = '<div class="thead">' + '<div class="tr">' + '<div class="th building_name">Building / Address</div>' + '<div class="th size">Type</div>' + '<div class="th size">size</div>' + '<div class="th closing_price">Closing Price</div>' + '<div class="th closing_date"> Closing Date</div>' + '</div>' + '</div>';

		_divtable.set('html', _thead);

		var _tbody = new Element('.tbody.w_styled_scroll').inject(_divtable);
		var nothing_to_show = true;

		var sorted_by_date = self.sort_by_date();

		sorted_by_date.each(function (e, i) {

			nothing_to_show = false;

			var color = e.bedroom_id.toInt();

			color = color > 14 ? 14 : color;

			var _tr = new Element('div', {
				'class': 'tr',
				'data-href': e.url_sold,
				styles: {
					'border-left': '6px solid ' + self.options.colors[color]
				}
			}).inject(_tbody);

			var _td_building = new Element('div', { 'class': 'td building_name' });
			var _td_type = new Element('div', { 'class': 'td type' });
			var _td_size = new Element('div', { 'class': 'td size' });
			var _td_closing_price = new Element('div', { 'class': 'td closing_price' });
			var _td_closing_date = new Element('div', { 'class': 'td closing_date' });

			var building_text = '<span>' + (e.name || e.street_address) + ', </span><span class="unit"> Apt ' + e.unit + '</span><br>' + (e.name != null ? e.street_address : '');

			var type_text = '<span>' + e.building_type + '</span>';

			var size_text = '<span>' + (Number.from(e.bedroom) != null ? Number.from(e.bedroom) : e.bedroom) + (Number.from(e.bedroom) != null ? Number.from(e.bedroom) > 1 ? ' beds' : ' bed' : '') + '</span><br>' + Number.from(e.bathroom) + (Number.from(e.bathroom) > 1 ? ' baths' : ' bath') + (e.sqft_format != 0 ? ' | ' + e.sqft_format + ' ft<sup>2</sup>' : '');

			var closing_price_text = '<span>' + e.sale_price_format + '</span>' + (e.ppsqft.toInt() != 0 ? '<br> Approx. ' + e.ppsqft_format + ' / ft<sup>2</sup>' : '');
			var closing_date_text = '<span>' + e.sale_date + '</span>';

			_td_building.set('html', building_text).inject(_tr);
			_td_type.set('html', type_text).inject(_tr);
			_td_size.set('html', size_text).inject(_tr);
			_td_closing_price.set('html', closing_price_text).inject(_tr);
			_td_closing_date.set('html', closing_date_text).inject(_tr);

			_tr.addEvent('click', function () {
				Cookie.write('rc_back_here', true);
			});

			self._trs.push(_tr);
		});

		if (nothing_to_show) return;

		_divtable.inject(self._container);

		new Divtable(_divtable, { 'zebra_order': 'odd' });

		if (self._trs.length > 9) {
			_divtable.addClass('on_scroll');
			new StyledScroll(_tbody, { type: 'v', max_height: self.set_max_height() });
		}
	},

	sort_by_date: function sort_by_date() {
		var sorted_by_date = this.data.list.sort(function (a, b) {
			return new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s") > new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s") ? -1 : 1;
		});
		return sorted_by_date;
	},

	set_max_height: function set_max_height() {
		var self = this;
		var max_height = 0;

		self._trs.each(function (_tr, i) {
			if (i < 10) {
				max_height += _tr.getComputedSize().height;
			}
		});

		return max_height + 20;
	}
});
'use strict';

var BlimpExtMap = new Class({
	Extends: BlimpExt,

	post_process: function post_process() {
		var title = this._link.getAttribute('data-title');
		if (this._element.getElement('.map_title')) this._element.getElement('.map_title').set('html', title);

		if (!this.map) {
			this.create_map();
		}

		//this.addEvent('hide', this.self_destruct.bind(this));

		this.parent();
	},

	create_map: function create_map() {
		var self = this;
		var rpc = this._link.getAttribute('data-rpc-map');
		var _map_container = this._element.getElement('.map_container');

		_map_container.empty();

		var _map = new Element('div', {
			'class': 'map'
		}).inject(_map_container);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function onSuccess() {
				var data = this.get_data();
				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	},

	self_destruct: function self_destruct() {
		Core.destruct(this.remote, this);
		Core.destruct(this.map, this);
	}
});
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MapMultipleView = new Class({
	Implements: [Options, Events],

	options: {
		with_message: true,
		with_listing: false,
		with_expand: false,
		hood_id: null,
		store_data: true,
		page_id: '',
		previous_state: null,
		view: null
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;

		this.typesLabel = {
			"condo": "2",
			"co-op": "3",
			"Rental": "8"
		};
		this.datesLabel = {
			"24_hours": '1',
			"week": '7',
			"2_weeks": '14',
			"14_days": '14',
			"month": '30',
			"45_days": '45',
			"3_months": '90',
			"6_months": '180',
			"12_months": '365',
			"12_more_months": '365+'
		};

		this.page_id = $$('body')[0].get('id');

		this.state = new State();

		this.build();
	},

	build: function build() {
		this.expanded = false;
		this.page_number = 1;

		this._map = this._element.getElement('#shared_map');

		this._type = this._map.get('data-type');

		var defaultMinPrice;
		var defaultMaxPrice;

		// if we have a previous state set, use it
		if (this.options.previous_state && this.options.previous_state.criteria) {
			this._type = this.options.previous_state.criteria.sale_rent === 1 ? 'sale' : 'rent';
			this._map.set('data-type', this._type);
			defaultMinPrice = this.options.previous_state.criteria.min_price;
			defaultMaxPrice = this.options.previous_state.criteria.max_price;
		}

		this._nr = this._map.getElement('.w_map_body .no_results');

		// init map
		if (this._map) {
			// show map to be able to build it
			this._map.show();
			// build map
			this.build_map();

			var selectedIndexes = this.get_default_form();
			this.build_form(selectedIndexes, defaultMinPrice, defaultMaxPrice);

			// get header
			this._current_header = this._map.getElement('.w_map .w_map_header');

			// build main select
			var selectedIndex = this.get_default_main_select();
			this.build_main_select(this._current_header, selectedIndex);

			// build date switchers and date pickers
			var _date_from_li = this._map.getElement('li.date_from_li');
			var _date_to_li = this._map.getElement('li.date_to_li');

			if (_date_from_li || _date_to_li) {
				this.build_date_switchers(this._map, this.options.previous_state);
				this.build_date_pickers(this._map, this.options.previous_state);
			}

			// show map
			this.show_map();
		}

		// expand
		if (this.options.with_expand) {
			this._expand = this._element.getElement('.expand');
			if (this._expand) {
				this.set_expand();
			}
		}

		if (this.options.with_message) {
			this.set_message();
		}
	},

	/**
  * Get the default index based on the value of the type for the main select
  * @return {Number} The index
  */
	get_default_main_select: function get_default_main_select() {
		var self = this;
		var select = this._element.getElement('.w_styled_select._main_select select');
		var index;

		select.getElements('option').each(function (_el, i) {
			if (_el.get('data-type-map') === self._type) {
				index = i;
			}
		});

		return index;
	},

	build_main_select: function build_main_select(header, selectedIndex) {
		var self = this;
		var _main_select = this._element.getElement('.w_styled_select._main_select');
		new StyledSelect(_main_select, {
			selectedIndex: selectedIndex,
			onClick: function onClick(_el) {
				if (self._message) {
					self._message.fade('out');
				}
			},
			onChange: function onChange(_el) {
				// set new map type
				var newMapType = $$(_el).get('data-type-map')[0];
				self._map.set('data-type', newMapType);
				self._type = newMapType;
				// build form
				self.build_form();
				self.page_number = 1;
				self.rebuild_map();
			}
		});

		_main_select.inject(header, 'top');
	},

	build_map: function build_map() {
		var self = this;

		// add event show map
		this._map.addEvent('show', function () {
			self.show_map();
		});
	},

	/**
  * Get the default indexes based on the previous state for every multi select and styled select in the form
  * @return {Object} The list of indexes
  */
	get_default_form: function get_default_form() {
		var self = this;

		var multiselectIndexes = {};
		var styledselectIndexes = {};

		if (this.options.previous_state && this.options.previous_state.criteria) {
			// get default indexes for all multiselect
			this._map.getElements('.w_multiselect.param_' + this._type).each(function (_el) {
				var options = _el.getElements('li');
				var type = _el.get('data-param');
				var defaultValues = self.options.previous_state.criteria[type];
				if (defaultValues) {
					for (var i = 0; i < options.length; i++) {
						if (defaultValues.indexOf(options[i].get('data-param-id')) >= 0) {
							if (!multiselectIndexes[type]) {
								multiselectIndexes[type] = [];
							}
							multiselectIndexes[type].push(i);
						}
					}
				}
			});

			// get default indexes for all styled select except the main one
			this._map.getElements('.w_styled_select.param_' + this._type).each(function (_el) {
				if (_el.hasClass('_main_select')) {
					return;
				}
				var type = _el.get('data-param');

				_el.getElements('option').each(function (option, i) {
					if (option.get('data-param-id') === self.options.previous_state.criteria[type]) {
						if (!styledselectIndexes[type]) {
							styledselectIndexes[type] = [];
						}
						styledselectIndexes[type].push(i);
					}
				});
			});
		}

		return {
			multiselect: multiselectIndexes,
			styledselect: styledselectIndexes
		};
	},

	build_form: function build_form(selectedIndexes, defaultMinPrice, defaultMaxPrice) {
		var self = this;

		this._map.getElements('.w_multiselect.param_' + this._type).each(function (_el) {
			var type = _el.get('data-param');
			var indexes = selectedIndexes ? selectedIndexes.multiselect[type] : undefined;
			// skipFirstChange to true seems to update the number of options selected by default
			var skipFirstChange = false;
			if (indexes && indexes.length > 0) {
				skipFirstChange = true;
			}
			_el.multiselect = _el.multiselect || new Multiselect(_el, {
				text_input: false,
				close_button: false,
				suspension_points: true,
				equality: true,
				add_tiles: false,
				selectedIndexes: indexes,
				skip_first_change: skipFirstChange,
				onChange: function onChange() {
					self.page_number = 1;

					self.rebuild_map();
				}
			});
		});

		this._map.getElements('.w_styled_select.param_' + this._type).each(function (_el) {
			if (_el.hasClass('_main_select')) {
				return;
			}
			var type = _el.get('data-param');
			var index = selectedIndexes ? selectedIndexes.styledselect[type] : undefined;
			_el.styledselect = _el.styledselect || new StyledSelect(_el, {
				selectedIndex: index,
				onChange: function onChange() {
					self.page_number = 1;
					self.rebuild_map();
				}
			});
		});

		this._map.getElements('._price_slider.param_' + this._type).each(function (_el) {
			var rangeSlider = _el.getElement('.w_rangeslider');
			rangeSlider.range = rangeSlider.range || new Rangeslider(rangeSlider, {
				title: 'Price Range:',
				type: 'horisontal',
				min: defaultMinPrice,
				max: defaultMaxPrice,
				onComplete: function onComplete() {
					self.page_number = 1;
					self.rebuild_map();
				}
			});
			window.addEvents({
				'resize': function resize() {
					rangeSlider.range.resize();
				}
			});
		});
	},

	build_date_switchers: function build_date_switchers(_map, previousState) {
		var _self = _map; //this._element;

		if (!_self.date_switcher) {
			_self.date_switcher = true;
		} else {
			return;
		}

		var _switch_to_date_range = _self.getElement('.switch_to_date_range'),
		    _switch_to_date_updated = _self.getElement('.switch_to_date_updated'),
		    _date_listed = _self.getElement('.w_styled_select._date_listed'),
		    _date_from_li = _self.getElement('li.date_from_li'),
		    _date_to_li = _self.getElement('li.date_to_li');

		var _date_range = _date_from_li.getParent('div'),
		    _dummy_input = new Element('input'),
		    _date_updated_input = _date_listed.getElement('select') || _dummy_input,
		    _date_from_input = _date_from_li.getElement('input') || _dummy_input,
		    _date_to_input = _date_to_li.getElement('input') || _dummy_input;

		_date_updated_input.set('data-name', _date_updated_input.get('name'));
		_date_from_input.set('data-name', _date_from_input.get('name'));
		_date_to_input.set('data-name', _date_to_input.get('name'));

		if (_date_listed && _switch_to_date_updated && _switch_to_date_range && _date_from_li && _date_to_li) {

			var _select = _date_listed.getElement('ul');

			if (_select) {
				_select.adopt(new Element('li').adopt(_switch_to_date_range));
			}

			_switch_to_date_updated.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				_date_listed.removeClass('_inactive');
				_date_range.addClass('_inactive');

				// Cookie.write('cr_date', 'date_listed');
			}.bind(this));

			_switch_to_date_range.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				_date_listed.addClass('_inactive');
				_date_range.removeClass('_inactive');

				// Cookie.write('cr_date', 'date_range');
			}.bind(this));

			// if we have a previous state with date range
			if (previousState && previousState.criteria && previousState.criteria.date_from && previousState.criteria.date_to) {
				// select default date picker
				_switch_to_date_range.fireEvent('click');
			} else {
				// select default date picker
				_switch_to_date_updated.fireEvent('click');
			}
		}
	},

	build_date_pickers: function build_date_pickers(_map, previousState) {
		var _self = _map;
		_self._date_from = _self.getElement(".date_from");
		_self._date_to = _self.getElement(".date_to");

		var min = Core.get_daterange_min_date();
		var max = Core.get_daterange_max_date();

		if (_self._date_from && !_self.date_from_picker) {
			_self.date_from_picker = new Picker.Date(_self._date_from, {
				timePicker: true,
				draggable: false,
				minDate: min,
				maxDate: max,
				pickOnly: 'days',
				pickerClass: 'datepicker_vista',
				format: _self._date_from.get('data-format') || "%m/%d/%Y",
				useFadeInOut: true,
				onSelect: function onSelect(dateText, input) {
					_self.date_to_picker.options.minDate = dateText.increment('day', 1);
				}
			});

			// if we have a previous state with a date from set
			if (previousState && previousState.criteria && previousState.criteria.date_from) {
				_self.date_from_picker.select(new Date(previousState.criteria.date_from));
			}

			_self._date_from.addEvent('change', function () {
				this.rebuild_map();
			}.bind(this));
		}

		if (_self._date_to && !_self.date_to_picker) {
			_self.date_to_picker = new Picker.Date(_self._date_to, {
				timePicker: true,
				draggable: false,
				minDate: min,
				maxDate: max,
				pickOnly: 'days',
				pickerClass: 'datepicker_vista',
				format: _self._date_from.get('data-format') || "%m/%d/%Y",
				useFadeInOut: true,
				onSelect: function onSelect(dateText, input) {
					_self.date_from_picker.options.maxDate = dateText.decrement('day', 1);
				}
			});

			// if we have a previous state with a date to set
			if (previousState && previousState.criteria && previousState.criteria.date_to) {
				_self.date_to_picker.select(new Date(previousState.criteria.date_to));
			}

			_self._date_to.addEvent('change', function () {
				this.rebuild_map();
			}.bind(this));
		}
	},

	get_rpc: function get_rpc(type, params) {
		// default value
		var rpc = this._map.getAttribute('data-rpc');

		switch (type) {
			case 'poi':
				{
					rpc = this._map.getAttribute('data-rpc-poi');
					break;
				}
			case 'building':
				{
					rpc = this._map.getAttribute('data-rpc-building');
					break;
				}
			case 'transportation':
				{
					rpc = this._map.getAttribute('data-rpc-transportation');
					break;
				}
			default:
				break;
		}

		var paramsRpc = crUtils.param(params);
		rpc += paramsRpc;

		return rpc;
	},

	get_params: function get_params() {
		var self = this;
		var params = {};
		params.page = this.page_number;

		// main select
		if (this._type === "sale") {
			params.sale_rent = 1;
		}
		if (this._type === "rent") {
			params.sale_rent = 2;
		}

		// get multiselect param
		this._map.getElements('.w_multiselect.param_' + this._type).each(function (_el) {
			_el.getElements('li._selected').each(function (_e) {
				if (!params[_el.getAttribute('data-param')]) {
					params[_el.getAttribute('data-param')] = [];
				}
				params[_el.getAttribute('data-param')].push(_e.getAttribute('data-param-id'));
			});
		});
		// get styled select param
		this._map.getElements('.w_styled_select.param_' + this._type).each(function (_el) {
			if (_el.hasClass('_main_select')) {
				return;
			}
			// particular case "date_listed"
			if (_el.hasClass('_date_listed') && _el.getStyle('display') == 'none' && self._map._date_from && self._map._date_to) {
				params.date_from = self._map._date_from.get('value');
				params.date_to = self._map._date_to.get('value');
			} else {
				// default case
				_el.getElements(':selected').each(function (_e) {
					if (_e.getAttribute('data-param-id')) {
						params[_el.getAttribute('data-param')] = _e.getAttribute('data-param-id');
					}
				});
			}
		});

		// slider
		this._map.getElements('._price_slider.param_' + this._type).each(function (_el) {
			var inputs = _el.getElements('input');
			inputs.each(function (_e, i) {
				params[_e.getAttribute('name')] = parseInt(_e.getAttribute('value'));
			});
		});

		return params;
	},

	set_expand: function set_expand() {
		var self = this;
		this._expand.addEvent('click', function () {
			self.toggle_expand();
		});
	},

	set_size: function set_size() {
		var _map = this._map.getElement('.w_map .w_map_body');
		var _listing = _map.getElement('.listing');

		if (this.expanded) {
			if (this.options.with_expand) {
				this._expand.addClass('_on');
				_map.addClass('_expanded');
			}
			if (this.options.with_listing) {
				_listing.addClass('_expanded');
			}
		} else {
			if (this.options.with_expand) {
				this._expand.removeClass('_on');
				_map.removeClass('_expanded');
			}
			if (this.options.with_listing) {
				_listing.removeClass('_expanded');
			}
		}

		this._map.expanded = this.expanded;
	},

	toggle_expand: function toggle_expand() {
		this.expanded = !this.expanded;
		this.adjust_map();
	},

	adjust_map: function adjust_map() {
		this.set_size();
		this.reset_map_center();
		if (this.options.with_listing) {
			this.set_scroll();
		}
	},

	show_map: function show_map() {
		if (this._map.rpc_data) {
			if (this._map.expanded != this.expanded) {
				this.adjust_map();
			}
			return;
		}
		var self = this;

		// holds the first rpc result and use it when the user comes back to this hood instead of the new rpc request
		var data_container = 'data-' + this.options.page_id + '-' + this._type + '-' + this.options.hood_id;

		// see build map
		this._map._veil = this._map.getElement('.w_map_body .veil');
		this._map._veil.show();

		// build rpc
		var paramsRpc = this.get_params();
		var rpc = this.get_rpc(this._type, paramsRpc);

		this._map.rpc = rpc;

		// Get local storage
		if (this.isCachable(this.options.page_id, this._type) && Core.get_session_data(data_container)) {
			// console.debug('CACHE');
			if (this._map._veil) {
				this._map._veil.hide();
			}
			// get data
			var dataCache = Core.get_session_data(data_container);
			// filters data
			this._map.rpc_data = this.filters_data(dataCache, paramsRpc);
			// map will not be updated when the user click on pagination unless the criteria has been changed.
			this.create_map();
		} else if (rpc && rpc != '') {

			if (this.remote) {
				this.remote.cancel();
			}

			this.remote = new Remote({
				rpc: rpc,
				method: 'get',
				onSuccess: function onSuccess() {
					// console.debug('NO CACHE');
					if (self._map._veil) {
						self._map._veil.hide();
					}

					// save on cache only sale on default criteria
					if (self.isDefaultRpc(self.options.page_id, self._type, paramsRpc)) {
						if (self.options.store_data && !Core.get_session_data(data_container)) {
							Core.set_session_data(data_container, self.remote.get_data());
						}
					}

					self._map.rpc_data = self.remote.get_data();

					// map will not be updated when the user click on pagination unless the criteria has been changed.
					self.create_map();
				}
			});
		} else {
			this._map.rpc_data = true;
			this._map._veil.hide();
		}
	},

	isCachable: function isCachable(pageId, type) {
		if (pageId === 'npr') {
			if (type === 'sale' || type === 'rent') {
				return true;
			}
		}
		return false;
	},

	isDefaultRpc: function isDefaultRpc(pageId, type, params) {
		// cache only neighborhood and type sale for now
		if (!this.isCachable(pageId, type)) {
			return false;
		}
		// dont cache if there are specific criteria
		for (var key in params) {
			if (params.hasOwnProperty(key)) {
				if (key !== 'sale_rent' && key !== 'page' && key !== 'zoneId' && key !== 'hood') {
					return false;
				}
			}
		}
		return true;
	},

	/**
  * Function which filters data using different criteria
  * (This is working for now only on the neighborhood page)
  * @param  {Object} data   json object on the neighborhood page
  * @param  {Object} params the different criteria
  * @return {Object} data filtered and number of results updated
  */
	filters_data: function filters_data(data, params) {

		if (!this.isDefaultRpc(this.options.page_id, this._type, params)) {
			var nbResults = 0;

			for (var hood in data.listings) {
				if (data.listings.hasOwnProperty(hood)) {
					var clusterList = data.listings[hood].data;
					// list the cluster
					for (var cluster in clusterList) {
						if (clusterList.hasOwnProperty(cluster)) {
							var apartmentsList = clusterList[cluster].data;
							// filter apartments
							for (var i = apartmentsList.length - 1; i >= 0; i--) {
								var toRemove = false;
								// if the number of bedroom of the apartment does not match the params
								if (params["bedrooms[]"]) {
									// check if the apartment bedroom match one of the bedroom param
									if (params["bedrooms[]"].indexOf(apartmentsList[i].bedroom_id) === -1) {
										toRemove = true;
									}
								}
								if (params["types[]"]) {
									// check if the apartment building type match one of the type param
									var type = this.typesLabel[apartmentsList[i].building_type];
									if (params["types[]"].indexOf(type) === -1) {
										toRemove = true;
									}
								}
								var dateListedApt = apartmentsList[i].listed_date_timestamp * 1000;
								if (params.date_listed) {
									// current Date
									var dateMax = new Date().getTime();
									var days = this.datesLabel[params.date_listed];
									var dateMin = window.moment().subtract(days, 'days').toDate().getTime();

									if (!(dateListedApt >= dateMin && dateListedApt <= dateMax)) {
										toRemove = true;
									}
								}

								if (params.date_from && params.date_to) {
									var dateFrom = new Date(params.date_from).getTime();
									var dateTo = new Date(params.date_to).getTime();
									if (!(dateListedApt >= dateFrom && dateListedApt <= dateTo)) {
										toRemove = true;
									}
								}

								// if the apartement need to be removed
								if (toRemove) {
									apartmentsList.splice(i, 1);
								}
								// if there is no apartment left for this cluster, we delete it
								if (apartmentsList.length === 0) {
									delete clusterList[cluster];
								}
							} // end apartmentsList
							nbResults += apartmentsList.length;
						}
					} // end clusterList
				}
			}

			// update data results
			data.results = nbResults;
		}
		return data;
	},

	rebuild_map: function rebuild_map() {
		this._map.rpc_data = null;
		// show map
		this.show_map();
	},

	create_apts_list: function create_apts_list(_el) {
		var _listing = _el.getElement('.w_map_body .listing');

		this.sort_data(_el);

		_listing.empty();

		var self = this;
		var _ul = new Element('ul');
		var starting_index = this.max_page * (this.page_number - 1);
		var counter = 1;

		if (this.max_page > this.total_listings) {
			this.with_pagination = false;
			_listing.addClass('_full_height');
		} else {
			this.with_pagination = true;
			_listing.removeClass('_full_height');
		}

		_el.sorted_region_data.each(function (apt, i) {
			if (i >= starting_index && counter <= self.max_page) {
				var _li = new Element('li.apt', {
					'data-building-id': apt.building_id,
					'data-mask-id': apt.mask_id,
					'data-hood-id': apt.hood_id
				});

				var myimage = apt.thumbor_images && apt.thumbor_images.length > 0 ? Core.get_smart_image(110, 85, apt.thumbor_images[0], 'smart') : window.Missing_img_horisontal;

				var content = '<div class="image">' + '<img src="' + myimage + '" />' + '</div>' + '<div class="info">' + '<a class="name" href="' + apt.url_listing + '">' + apt.building_address + ', #' + apt.unit + '</a>' + '<ul class="clearfix">' + '<li class="type left">' + Core.capitalize(apt.building_type) + ' </li>' + '<li class="beds left">' + apt.display_bedrooms + '</li>' + '<li class="price left">' + apt.price + '</li>' + '</ul>';

				if (apt.sqft || apt.ppsqft) {
					content += '<ul class="clearfix">' + (apt.sqft ? '<li class="sqft left">Approx. ' + apt.sqft + ' ft<sup>2</sup></li>' : '') + (apt.ppsqft ? '<li class="ppsqft left"> ' + apt.ppsqft + ' per ft<sup>2</sup></li>' : '') + '</ul>';
				}

				content += apt.days_on_market == 0 ? '<span class="listed">Listed Today at ' + apt.time_added + '</span>' : '<span class="listed">Listed: ' + apt.date_added + '</span>';
				content += '</div>';
				content += '<div class="_hover"></div>';
				_li.set('html', content);

				self.set_li_events(_li);
				_li.inject(_ul);
				counter++;
			}
		});

		_ul.inject(_listing);
		_el._listing_container.removeClass('_loading');
	},
	sort_data: function sort_data(_el) {
		var self = this;
		var data = [];
		this.total_listings = 0;

		Object.each(_el.region_data, function (building) {
			Object.each(building.data, function (apt) {
				data.push(apt);
				self.total_listings++;
			});
		});

		// sort data by date. if the listings have same dates, sort it by price.
		var sorted_data = data.sort(function (a, b) {
			if (a.listed_date_timestamp == b.listed_date_timestamp) {
				return a.price_raw > b.price_raw ? -1 : 1;
			} else {
				return a.listed_date_timestamp > b.listed_date_timestamp ? -1 : 1;
			}
		});

		_el.sorted_region_data = sorted_data;
	},
	create_pagination: function create_pagination(_el, previousPage) {
		var self = this;
		var _pagination = _el.getElement('.w_map_body .w_pagination');
		var pages_amount = _el.rpc_data.links_per_page;
		var total = this.total_listings;
		var listing_amount = this.max_page;
		var maxPage = Math.ceil(total / listing_amount);
		var pages = [];
		var index_previous = null;
		var index_next = null;

		if (!this.with_pagination) {
			_pagination.hide();
			return;
		}

		_pagination.hide().empty();

		if (total <= listing_amount) {
			return;
		}

		this.page_number = this.page_number || 1;

		if (maxPage <= pages_amount) {
			for (var i = 1; i <= maxPage; i++) {
				pages.push(i);
			}
		} else {
			var first, last;

			if (this.page_number <= Math.ceil(pages_amount / 2)) {
				//very beginning
				first = 1;
				last = pages_amount;
			} else if (this.page_number >= maxPage - Math.floor(pages_amount / 2)) {
				//very end
				first = maxPage - pages_amount + 1;
				last = maxPage;
			} else {
				//middle
				first = this.page_number - Math.floor(pages_amount / 2);
				first += pages_amount % 2 == 0 ? 1 : 0;
				last = this.page_number + Math.floor(pages_amount / 2);
			}

			for (var i = first; i <= last; i++) {
				pages.push(i);
			}
		}

		if (this.page_number > 1) {
			index_previous = this.page_number - 1;
		}

		if (this.page_number < maxPage) {
			index_next = this.page_number + 1;
		}

		var _ul = new Element('ul');

		if (index_previous) {
			var _li = new Element('li.previous');
			var _i = new Element('i.fa.fa-angle-left');
			_i.inject(_li);
			this.set_pagination_event(_li, index_previous, _el);
			_li.inject(_ul);
		}

		pages.each(function (page_number, i) {
			var _li = new Element('li.page');
			_li.set('html', page_number);

			if (page_number == self.page_number) _li.addClass('_current');

			if (i == 0) _li.addClass('_bl');

			if (page_number != self.page_number) self.set_pagination_event(_li, page_number, _el);

			_li.inject(_ul);
		});

		if (index_next) {
			var _li = new Element('li.next');
			var _i = new Element('i.fa.fa-angle-right');
			_i.inject(_li);
			this.set_pagination_event(_li, index_next, _el);
			_li.inject(_ul);
		}

		_ul.inject(_pagination);
		_pagination.show();

		// restore previous page
		if (previousPage) {
			this.page_number = previousPage;
			this.pagination_changed = true;
			this.load_data_by_page(this._map);
		}
	},
	set_pagination_event: function set_pagination_event(_el, page, map) {
		var self = this;
		_el.addEvent('click', function () {
			self.page_number = page;
			self.pagination_changed = true;
			self.load_data_by_page(map);
		});
	},
	load_data_by_page: function load_data_by_page(_map) {
		var self = this;
		_map._listing_container.addClass('_loading');

		if (this.options.with_listing) {
			(function () {
				self.create_apts_list(_map);
				self.create_pagination(_map);
				self.set_scroll();
			}).delay(300);
		}
	},
	set_li_events: function set_li_events(_li) {
		var self = this;
		var building_id = _li.getAttribute('data-building-id');

		_li.addEvents({
			'mouseenter': function mouseenter(e) {
				//get the label of the marker so we can access the marker object
				_li.marker_label = document.getElement('.w_googlemaps_label._building._' + building_id);

				if (_li.marker_label) {
					self.set_active_marker(_li);
				} else {
					if (!_li.region_marker) {
						_li.region_marker = self.get_region_marker(_li);
					}

					if (_li.region_marker && _li.region_marker.sm_marker) {
						self.set_active_region(_li);
					}
				}
			},
			'mouseleave': function mouseleave(e) {
				if (_li.marker_label) {
					self.deactivate_marker(_li);
				}

				if (_li.region_marker && _li.region_marker.sm_marker) {
					self.deactivate_region(_li);
				}
			},
			'click': function click(e) {
				if (_li.marker_label) {
					google.maps.event.trigger(_li.marker_label.marker.marker, "mouseover");
					google.maps.event.trigger(_li.marker_label.marker.marker, "click");

					(function () {
						var _li_blimp = document.getElement('.w_googlemaps_infobox li._' + _li.get('data-mask-id'));
						var _close_btn = document.getElement('.w_googlemaps_infobox_close');

						if (_li_blimp) {
							_li_blimp.fireEvent('click');
							_close_btn.fireEvent('click'); // close the marke bubble
							self._map._listing_container.removeClass('_loading');
						}
					}).delay(10);
				}
			}
		});
	},

	create_map: function create_map() {
		switch (this._type) {
			case 'sale':
			case 'rent':
				{
					if (this._map.rpc_data.results > 0) {
						this._nr.hide();
						if (this.options.page_id === 'nrp') {
							this.create_map_region();
						} else {
							this.create_currently_available();
						}
					} else {
						this._nr.show();
					}
					break;
				}
			case 'poi':
				{
					if (this._map.rpc_data.content && Object.keys(this._map.rpc_data.content).length > 0) {
						this._nr.hide();
						this.create_key_points_of_interest();
					} else {
						this._nr.show();
					}
					break;
				}
			case 'building':
				{
					if (this._map.rpc_data.results > 0) {
						this._nr.hide();
						this.create_building_map();
					} else {
						this._nr.show();
					}
					break;
				}
			case 'transportation':
				{
					if (this._map.rpc_data.subway.length > 0) {
						this._nr.hide();
						this.create_transportation_map();
					} else {
						this._nr.show();
					}
					break;
				}
		}
	},

	create_currently_available: function create_currently_available() {
		var self = this;
		var data = this._map.rpc_data;
		if (!this._map.map || this._map.mapType != 'available') {
			var _container = this._map.getElement('.w_map_stat');
			var firstTilesLoaded = true;
			this._map.map = new GeneralMap(_container, {
				zoom: 13,
				data: data,
				scrollwheel: false,
				zoom_control_style: 'small',
				previous_state: this.options.previous_state,
				page_context: this.options.page_context,
				view: this.options.view || this._map.getAttribute("data-view"),

				onTilesLoaded: function onTilesLoaded() {
					if (firstTilesLoaded) {
						// restore previous map state
						if (self.options.previous_state) {
							self.restore_map_state();
						}
						firstTilesLoaded = false;
					}
				},
				onSaveState: function onSaveState(data) {
					self.save_state_npr(data.building_id);
				}
			});

			this._map.mapType = 'available';
		} else {
			this._map.map.refresh_data(data);
		}
	},

	create_map_region: function create_map_region() {
		var self = this;
		var data = this._map.rpc_data;
		var _container = this._map.getElement('.w_map_stat');

		// if there is a listing container (region page)
		this._map._listing_container = this._map.getElement('.listing_container');

		if (this.options.with_listing && this._map.sr_map && this._map.sr_map.number_of_regions > 1) {
			this._map._listing_container.removeClass('_show');
		}

		if (!this._map.map || this._map.mapType != 'region') {
			this._map.map = new SimpleMap(_container, {
				zoom_control_style: 'small',
				zoom_control_position: 'right',
				max_zoom: 17,
				min_zoom: 10,
				scrollwheel: false,
				onMapReady: function onMapReady() {
					self._map.sr_map = new SearchResultsMap(this, {
						data: data,
						data_rpc: self._map.rpc,
						is_building: false,
						previous_state: self.options.previous_state,
						page_context: self.options.page_context,
						view: self.options.view,

						onRequest: function onRequest() {
							if (this.region_clicked) {
								self._map._veil.show();
							}
						},
						onDataLoad: function onDataLoad(region) {
							if (region && region.region_id) {
								self.previous_region_id = region.region_id;
								self.show_region(region, self._map);
							}
						},
						onSaveState: function onSaveState(data) {
							// get params from map multiple view
							var params = self.get_params();
							// get expanded from map multiple view
							var expanded = self.expanded;
							// save
							self.state.save(self.page_id, {
								criteria: params,
								hood_id: self._map.sr_map.current_region.region_id,
								building_id: data.building_id,
								zoom: self._map.sr_map.map.map.zoom,
								expanded: expanded,
								page: self.page_number,
								center: {
									lat: self._map.sr_map.map.map.getCenter().lat(),
									lng: self._map.sr_map.map.map.getCenter().lng()
								}
							});
						}
					});

					self.region_markers = self._map.sr_map.search_results_regions;
				}
			});
			this._map.mapType = 'region';
		} else {
			var result_map = this._map.sr_map;
			result_map.refresh_data(data, this.previous_region_id);
			result_map.rpc = this._map.rpc;

			if (result_map.search_results_regions.length > 0) {
				result_map.search_results_regions.each(function (region) {
					if (region.region_id == self.previous_region_id) {
						result_map.handle_region_click(region);
						return false;
					}
				});
			}
		}
	},

	show_region: function show_region(region, _el) {
		this.max_page = _el.rpc_data.page_size;
		this.page_number = 1;

		_el.region_data = region.gross_data;

		// if there is a listing container (region page)
		if (this.options.with_listing) {
			_el._listing_container.addClass('_show');
		}
		if (this.options.with_listing) {
			this.create_apts_list(_el);
			var previousPage = this.options.previous_state ? this.options.previous_state.page : null;
			this.create_pagination(_el, previousPage);
			this.set_scroll();
		}
		if (this.options.with_expand) {
			this._expand.removeClass('none');
			if (this.options.previous_state && this.options.previous_state.expanded) {
				this.toggle_expand();
			}
		}

		_el._veil.hide();

		// restore previous map state
		if (this.options.previous_state || this.hood_state) {
			this.restore_map_state();
		}
	},

	/**
  * Restore the map center
  */
	restore_position: function restore_position() {
		// if previous state with a position
		if (this.options.previous_state && this.options.previous_state.center) {
			// restore position
			var center = new google.maps.LatLng(this.options.previous_state.center.lat, this.options.previous_state.center.lng);
			this._map.map.map.setCenter(center);
		}
	},

	/**
  * Restore the zoom level
  */
	restore_zoom: function restore_zoom() {
		// if previous state with a zoon level
		if (this.options.previous_state && this.options.previous_state.zoom) {
			// restore zoom level
			this._map.map.set_zoom(this.options.previous_state.zoom);
		}
	},

	/**
  * Delete the previous state object to not reuse it after the first load
  */
	delete_previous_state: function delete_previous_state() {
		// clean previous state
		this.options.previous_state = null;
	},

	/**
  * Restore the map state : zoom level, center position then delete the previous state object
  */
	restore_map_state: function restore_map_state() {
		// restore previous position
		this.restore_position();
		// restore zoom level
		this.restore_zoom();
		// clean previous state
		this.delete_previous_state();
	},

	save_state_npr: function save_state_npr(buildingId) {
		// get params from map multiple view
		var params = this.get_params();
		// save
		this.state.save(this.page_id, {
			criteria: params,
			building_id: buildingId,
			zoom: this._map.map.get_zoom(),
			center: {
				lat: this._map.map.map.getCenter().lat(),
				lng: this._map.map.map.getCenter().lng()
			}
		});
	},

	create_key_points_of_interest: function create_key_points_of_interest() {
		var self = this;
		var data = this._map.rpc_data;

		if (!this._map.map || this._map.mapType != 'poi') {
			var _container = this._map.getElement('.w_map_stat');
			this._map.map = new Page.Npr.POIMap(_container, {
				data: data,
				zoom: self._map.rpc_data.ini.zoom,
				opened_bubble_width: 320,
				scrollwheel: false,
				zoom_control_style: 'small'
			});
			this._map.mapType = 'poi';
		} else {
			this._map.map.refresh_data(data);
		}
	},

	create_building_map: function create_building_map() {
		var self = this;
		var data = this._map.rpc_data;

		if (!this._map.map || this._map.mapType != 'building') {
			var _ref;

			var _container = this._map.getElement('.w_map_stat');
			this._map.map = new SimpleMap(_container, (_ref = {
				zoom_control_style: 'small',
				max_zoom: 17,
				min_zoom: 10,
				scrollwheel: false
			}, _defineProperty(_ref, "zoom_control_style", 'small'), _defineProperty(_ref, "onMapReady", function onMapReady() {
				self._map.sr_map = new SearchResultsMap(this, {
					data: self._map.rpc_data,
					is_building: true,
					label_on_marker: false,
					show_starting_price: true
				});
			}), _ref));
			this._map.mapType = 'building';
		} else {
			this._map.sr_map.refresh_data(data);
		}
	},

	create_transportation_map: function create_transportation_map() {
		var self = this;
		var data = this._map.rpc_data;

		if (!this._map.map || this._map.mapType != 'transport') {
			var _container = this._map.getElement('.w_map_stat');
			var _coords = this._map.getElement('.hood_coords');
			var polygon;

			if (_coords) {
				polygon = {
					points: JSONMOO.decode(_coords.get('html'), false),
					config: {
						strokeColor: "#C03E62",
						strokeWeight: 0,
						fillColor: "#C03E62",
						fillOpacity: 0.4
					}
				};
			}
			this._map.map = new TransportationMap(_container, {
				max_zoom: 20,
				min_zoom: 13,
				scrollwheel: false,
				pan_control: false,
				scale_control: false,
				zoom_control: true,
				type_control: false,
				zoom_control_style: 'small',
				data: self._map.rpc_data,
				custom_polygons: polygon ? [polygon] : []
			});
			this._map.mapType = 'transport';
		} else {
			this._map.map.refresh_data(data);
		}
	},

	set_message: function set_message() {
		this._message = this._element.getElement('.message');
		this._message.fade('in');
	},

	set_scroll: function set_scroll() {
		var _ul = this._map.getElement('.w_map_body .listing ul');
		if (_ul) {
			var _listing = this._map.getElement('.w_map_body .listing');
			_listing.empty();
			_ul.erase('style').inject(_listing);
			new StyledScroll(_ul);
		}
	},

	set_active_region: function set_active_region(_li) {
		var hover_icon = Res_i + '/w/simplemap/markers/region-marker-hover-blue.png';
		_li.region_marker.sm_marker.change_icon_image(hover_icon);
	},

	deactivate_region: function deactivate_region(_li) {
		var icon = _li.region_marker.sm_marker.options.icon;
		_li.region_marker.sm_marker.change_icon_image(icon);
	},

	set_active_marker: function set_active_marker(_li) {
		var icon = _li.marker_label.marker.options.hover_icon;
		_li.marker_label.marker.change_icon_image(icon);
	},

	deactivate_marker: function deactivate_marker(_li) {
		var icon = _li.marker_label.marker.options.icon;
		_li.marker_label.marker.change_icon_image(icon);
	},

	get_region_marker: function get_region_marker(_li) {
		var region;
		this.region_markers.each(function (el) {
			if (el.region_id == _li.get('data-hood-id')) {
				region = el;
			}
		});

		return region;
	},

	reset_map_center: function reset_map_center() {
		google.maps.event.trigger(this._map.map.map, 'resize');
		this._map.map.fit_markers();
	}
});
'use strict';

var Tabscroll = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_tabscroll'
	},

	initialize: function initialize(_element, options) {
		this._element = document.id(_element);

		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var fcls = '.' + this.options.cls;
		var _element = document.id(this);

		this._tabs = _element.getElements(fcls + '_tabs li');
		this._content = _element.getElement(fcls + '_content');
		this._strip = _element.getElement(fcls + '_strip');
		this._items = _element.getElements(fcls + '_item');
		this.fx_items = [];

		this.active_index = 0;

		if (!this._items || this._items.length == 0) {
			this._element.dispose();
			return;
		}

		this.fx_scroll = new Fx.Scroll(this._content, {
			duration: 500,
			link: 'cancel'
		});

		this._tabs.each(function (_el, i) {
			_el.addEvent('click', this.select.bind(this, _el, i));

			if (this._tabs.length == 1) {
				_el.addClass('_full_width');
			} else if (i == 0) {
				_el.addClass('_first');
			} else if (i == this._items.length - 1) {
				_el.addClass('_last');
			}

			this.fx_items.push(new Fx.Morph(this._items[i], {
				duration: 1000,
				link: 'cancel'
			}));

			if (_el.hasClass('active') && i > 0 && this._items.length > 1) {
				this.select(_el, i);
			}
		}.bind(this));
	},

	select: function select(_tab, i, e) {
		if (e && e.stop) e.stop();

		if (this.active_index == i) return;

		this._tabs[this.active_index].removeClass('active');
		this.active_index = i;

		this._tabs[i].addClass('active');
		this.fx_scroll.toElement(this._items[i]);

		this.fx_items[i].start({
			opacity: [0, 1]
		});

		this.fireEvent('tabchange', i);
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var Schools = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_schools',
		customId: 'schools'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) this.build();
	},

	build: function build() {
		var self = this;
		var rpc = this._element.get('data-rpc');

		if (rpc) {
			var remote = new Request.HTML({
				url: rpc,
				onSuccess: function onSuccess(a, b, c, d) {
					if (c === "") {
						self._element.getParent().dispose();
						return;
					}

					this.data = c;
					self._element.set('html', this.data);

					new Tabscroll(self.options.customId);

					var _shrinkers = self._element.getElements('.w_shrinker');

					_shrinkers.each(function (_shrinker) {
						var min_height = 270;

						new Shrinker(_shrinker, {
							min_height: min_height,
							toggler: _shrinker.getParent('.w_tabscroll_item').getElement('.w_shrinker_head'),
							single_opened: false,

							onShrink: function onShrink() {
								this._toggler.removeClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show more</span>');
							},

							onUnshrink: function onUnshrink() {
								this._toggler.addClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show less</span>');
							}
						});
					});
				},

				onFailure: function onFailure() {
					self._element.getParent().dispose();
				}
			});

			remote.get();
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var ColumnChart = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_columnchart',
		max_value: 0,
		increment: 100, //increment of the scale
		height: 500, //it's not a total height of the chart, it's height of it's scale
		disp_col: 5, //amount of displayed columns
		scroll_speed: 300,
		animate_values: true,
		scroll_at_a_time: 3, //how many items scroll at a time
		y_axis: '', //displayed name of y axis
		hscroll: true,
		zebra: true, //zebra background
		has_images: true,
		main_item_indicator: false, //horisontal dashed line
		scale_px_increment: 30,
		data: null,
		isBuilding: false,
		missingImage: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);
		this._element.addClass('_loading');

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (Core.is_ie8()) {
			this._element.addClass('ie');
		}

		this.max_value = opts.max_value;

		if (opts.y_axis != '') {
			this._y_axis = new Element('.y_axis', { 'html': '<div class="vertical_text">' + opts.y_axis + '</div>' }).inject(this._element);
		}

		this._chart = new Element('.chart').inject(this._element);

		if (opts.zebra) {
			this._zebra = new Element('.zebra').inject(this._chart);
		}

		this._scroller = new Element('.scroller').inject(this._chart);

		this._col_container = new Element('.col_container').inject(this._scroller);

		this.property = this._element.getProperty('data-property');
		this.y_axis_text = this._element.getProperty('data-yaxis-name');

		if (opts.data) {
			this.data = opts.data;
			this.process_rpc();
		} else {
			this.rpc_request();
		}

		this.add_functionalities();
	},

	add_hscroll: function add_hscroll() {
		var self = this;
		var opts = this.options;
		var _hscroll = this._hscroll = new Element('.hscroller', { 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._chart);

		this._element.addClass('_has_dragger');

		var _ar_l = this._ar_l = _hscroll.getElement('.ar_l');
		var _ar_r = this._ar_r = _hscroll.getElement('.ar_r');

		_ar_l.addEvent('click', function () {
			self._arr_prev.fireEvent('click');
		});

		_ar_r.addEvent('click', function () {
			self._arr_next.fireEvent('click');
		});

		var _dragger = this._dragger = _hscroll.getElement('.dragger'),
		    size_coefficient = this._items.length - opts.disp_col;

		this.dragger_fx = new Fx.Morph(_dragger, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.linear
		});

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = self.dragger_max_left = _hscroll.getSize().x - dr_size,
		    dragger_left = max_left / (this._items.length - opts.disp_col) * this.current_col;

		if (this.current_col == 0) {
			_ar_l.addClass('inactive');
		} else if (this.current_col == this.last) {
			_ar_r.addClass('inactive');
		}

		(function () {
			self.dragger_fx.start({ 'left': dragger_left });
			self.dragger_fx.setOptions({ duration: self.options.scroll_speed });
		}).bind(this).delay(2000);

		_hscroll.addEvents({
			'mouseenter': function mouseenter() {
				if (self.dragging != true) self._element.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) self._element.removeClass('dragging');
			}
		});

		_dragger.addEvent('mousedown', function (e) {
			self.dragging = true;
			self._element.addClass('dragging');
			dragger_left = _dragger.getStyle('left').toInt();
			self.init_pos = e.page.x;
			return false;
		});

		$(document.body).addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - self.init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var area = self.drag_area = (left / (max_left / (self._items.length - opts.disp_col))).round();

					self.animate.set(left * ((self._col_container.getSize().x - self.scr_width) / max_left), 0);

					if (self.current_col != area) {
						self.current_col = area;

						if (area == 0) {
							self._arr_prev.addClass('inactive');
							_ar_l.addClass('inactive');
						} else {
							self._arr_prev.removeClass('inactive');
							_ar_l.removeClass('inactive');
						}

						if (area == self._items.length - opts.disp_col) {
							self._arr_next.addClass('inactive');
							_ar_r.addClass('inactive');
						} else {
							self._arr_next.removeClass('inactive');
							_ar_r.removeClass('inactive');
						}
					}

					self.hide_locked_item();
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
				self._element.removeClass('dragging');
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				self._element.removeClass('dragging');
			}
		});
	},

	create_scale: function create_scale() {
		this._scale = new Element('.scale');

		if (this._y_axis) {
			this._scale.inject(this._y_axis, 'after');
		} else {
			this._scale.inject(this._element, 'top');
		}

		var increment = this.options.increment;

		// Force the max_value to be rounded to the nearest increment
		this.max_value = Math.ceil(this.max_value / increment) * increment;

		// Calculate the number of increments that can fit into the chart height
		var numIncrements = Math.floor(this.options.height / this.options.scale_px_increment);
		increment = Math.ceil(this.max_value / numIncrements);

		var value = 0,
		    _el;

		this._values = [];

		// Adjust grid height based on the new increment value
		var grid_height = this.options.height / numIncrements;

		while (value <= this.max_value) {
			var grid_char = this.options.zebra ? '&bull;' : '-';
			var formattedValue = '$' + Core.add_commas(value);
			_el = new Element('.value', {
				'html': formattedValue + '<div class="grid">' + grid_char + '</div>',
				'styles': {
					'height': grid_height + 'px'
				}
			}).inject(this._scale, 'top');
			value += increment;

			this._values.push(_el);
		}

		this.options.height = grid_height * this._values.length;

		if (this._zebra) {
			var cls = '';
			this._values.each(function (_el, i) {
				var zebra_height = grid_height;

				if (cls == '') {
					cls = 'x';
					zebra_height -= 2; //dashed border of the zebra
				} else {
					cls = '';
				}

				var _strip = new Element('div', { 'class': cls });
				_strip.inject(this._zebra);
				_strip.setStyle('height', zebra_height);
			}.bind(this));

			var margin = this._scale.getElement('.grid').getCoordinates().top - this._chart.getCoordinates().top - this._scale.getElement('.grid').getStyle('margin-top').toInt();
			this._zebra.getElement('div').setStyle('margin-top', margin);
		} else {
			this._values.each(function (_el) {
				_el.setStyle('height', grid_height);
			});
		}

		var scale_height = this._scale.getSize().y - this._scale.getStyle('padding-top').toInt() + this._scale.getElement('.grid').getStyle('top').toInt();
		this._scale.setStyle('height', scale_height);

		var grid_width = this._chart.getComputedSize().computedBottom;
		this._scroller.setStyle('height', this._scale.getSize().y - grid_width);

		if (this._y_axis) {
			this._y_axis.setStyle('height', this._scale.getSize().y - grid_width);
		}

		this.set_prices();
	},

	set_prices: function set_prices() {
		var height;
		var price;

		this._items.each(function (e) {
			price = e.getAttribute('data-price').toInt();
			height = (price * this.options.height / this.max_value).round() - 1;

			if (this.options.animate_values == true) {
				e.setAttribute('data-height', height);
			} else {
				e.setStyle('height', height);
			}

			if (e.hasClass('main') && this._indicator) {
				this._indicator.setStyle('bottom', height).addClass('visible');
			}
		}.bind(this));
	},

	rpc_request: function rpc_request() {
		var self = this;

		if (!self.options.data) {
			new Remote({
				rpc: this._element.getAttribute('data-rpc'),
				method: 'get',
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.process_rpc();

					document.fireEvent('columnChartLoaded');
				},
				onError: function onError() {
					this._element.set('html', 'Server connection error. Please try later');
				}
			});
		} else {
			self.process_rpc();
		}
	},

	process_rpc: function process_rpc() {
		this._items = [];
		var col_container_width = 0;

		if (this.data && this.data != '') {
			this.change_y_label();

			var notFoundImageUrls = ['/l/not-found-grey-gallery-1.png', '/l/not-found-grey-gallery-2.png', '/l/not-found-grey-gallery-3.png', '/l/not-found-grey-gallery-4.png', '/l/not-found-grey-gallery-5.png', '/l/not-found-grey-gallery-6.png', '/l/not-found-grey-gallery-7.png', '/l/not-found-grey-gallery-8.png'];
			var notFoundImageCnt = 0;

			this.data.each(function (e, i) {

				if (!e.thumbor_images || !!e.thumbor_images && e.thumbor_images.length == 0) {
					var _index = notFoundImageCnt % 8;
					e.notFoundImageUrl = Res_i + notFoundImageUrls[_index];
					notFoundImageCnt++;
				}

				var price = e[this.property];

				price = price.toInt();

				if (this.max_value < price) {
					this.max_value = price;
				}

				var img_path,
				    name = (e.name || e.address || e.building_name || e.building_address) + (e.unit ? ', #' + e.unit : ''),
				    cls = 'bld_item' + (e.current == true ? ' main' : ''),
				    html = '';

				if (e.current == true && this.options.main_item_indicator) {
					this._indicator = new Element('.indicator', { 'html': '<div class="pointer">&nbsp;</div>' }).inject(this._chart).fade('hide');
				}

				if (this.options.has_images) {
					img_path = this.options.tmp_img || e.image;

					html = '<img src="' + img_path + '"' + 'onerror="' + this.options.err_img + '"' + '/>';
				}
				var vt_html = '<div class="vt_container">' + '<div class="vertical_text">' + name + '</div>' + '</div>';

				var add_cls = this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page' ? '' : ' w_blimp_bld';

				var _bld_item = new Element('div', {
					'class': cls + add_cls,
					'html': html,
					'data-price': e[this.property],
					'data-class': 'w_blimp_bld'
				});

				this._items.push(_bld_item);

				_bld_item.addEvents({
					'mouseenter': function () {
						if (this.locked_item) {
							this.locked_item.removeClass('_active');
						}

						this.locked_item = _bld_item;
						this.locked_item.addClass('_active');
						this.bulb_show(e, _bld_item);
					}.bind(this)
				});

				// if(e.url_listing || e.url && e.url != ''){
				// 	_bld_item.set('data-rpc', e.url_listing || e.url);

				// 	if (this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page'){
				// 		_bld_item.addEvent('click', function(){ window.location = e.url_listing || e.url; });
				// 	}else{
				// 		new BlimpExt(_bld_item, {
				// 			draggable: true,
				// 			show_veil: true,
				// 			onPostRpc: function(){
				// 				new BldBlimp(this);
				// 			}
				// 		});
				// 	}
				// }

				var _column = new Element('div', {
					'class': 'column' + (i == this.data.length - 1 ? ' last' : ''),
					'html': vt_html
				}).adopt(_bld_item).inject(this._col_container);

				var col_w = _column.getComputedSize().width,
				    col_m = _column.getStyle('margin-right').toInt();

				col_container_width += col_w + col_m;

				if (!this.scroll_w_is_set) {
					this.set_scroll_width(col_w, col_m);
					this.scroll_w_is_set = true;
				}
			}.bind(this));

			(function () {
				this._col_container.setStyle('width', col_container_width);
			}).delay(500, this);

			this._main_col = this._scroller.getElement('.main');

			if (this._main_col) {
				this._init_scroll = this._main_col.getParent('.column');
			} else {
				//this.fireEvent('notEnoughData');
			}

			this.create_scale();

			if (this._scroller.getStyle('width').toInt() < col_container_width) {
				this.add_scrolling();
			}

			if (this.options.animate_values == true) {
				this.animate_prices();
			} else {
				if (this._indicator && this._indicator.hasClass('visible')) {
					this._indicator.fade('show');
				}
			}

			this._bulb = new Element('.' + this.options.cls + '_bulb', {
				'html': '<div class="pointer">&nbsp;</div>'
			}).inject(this._element);

			this._bulb.addClass('clearfix');

			if (!this.options.isBuilding) {
				this._bulb.addClass('_listings');
			} else {
				this._bulb.addClass('_buildings');
				this._info = new Element('div.info').inject(this._bulb, 'top');

				var content = this._info;
				this._bulb_name = new Element('a.name').inject(content);
				this._bulb_address = new Element('a.address').inject(content);
				this._bulb_details = new Element('span.details').inject(content);
				this._bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
				this._bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
				this._bulb_size = new Element('span.size').inject(content);
				this._bulb_created = new Element('span.created').inject(content);
				this._bulb_updated = new Element('span.updated').inject(content);
				var grey_box = new Element('div.grey-box').inject(content);
				this._bulb_price = new Element('span.price').inject(grey_box);
				this._bulb_sales = new Element('span.sales').inject(grey_box);
			}

			this._chart.setStyle('visibility', 'visible');

			if (this._y_axis) {
				this._y_axis.setStyle('visibility', 'visible');
			}
		} else {
			this.fireEvent('noData');
		}

		this._element.removeClass('_loading');
	},

	change_y_label: function change_y_label() {
		if (!this._y_axis) return;

		this._y_axis.getElement('.vertical_text').set('html', this.y_axis_text);
	},

	set_scroll_width: function set_scroll_width(w, m) {
		var dc = this.options.disp_col,
		    width = this.scr_width = w * dc + m * (dc - 1) - 100;

		this._scroller.setStyle('width', width);
	},

	bulb_show: function bulb_show(data, _el) {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		if (this.bubble_is_ready && this.dragging != true) {
			if (!this.options.isBuilding) {
				this.add_listing_tile(data);
			} else {

				var add_text = this.property == 'ppsqft' || this.property == 'sqft' ? ' /ft<sup>2</sup>' : '';
				var price = data[this.property];

				var transactions = data.transactions || 0;
				var str_sales = transactions > 1 ? 'sales' : 'sale';

				this._bulb_sales.set('html', 'Based on ' + transactions + ' ' + str_sales + '<br/>in past 12 months');

				if (data.sale && data.sale.available > 0) {
					var apts = data.sale.available > 1 ? ' Apartments' : ' Apartment';
					if (data.sale.min == data.sale.max) {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> for $' + Core.short_number(data.sale.min));
					} else {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> ($' + Core.short_number(data.sale.min) + ' - $' + Core.short_number(data.sale.max) + ')');
					}
					this._bulb_available_for_sale.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'sale');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_sale.set('html', '');
				}

				if (data.rent && data.rent.available > 0) {
					var apts = data.rent.available > 1 ? ' Apartments' : ' Apartment';
					if (data.rent.min == data.rent.max) {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> for $' + Core.add_commas(data.rent.min));
					} else {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> ($' + Core.add_commas(data.rent.min) + ' - $' + Core.add_commas(data.rent.max) + ')');
					}
					this._bulb_available_for_rent.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'rent');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_rent.set('html', '');
				}

				this._bulb_price.set('html', '$' + Core.add_commas(price) + add_text);
				this._bulb_name.set('text', (data.name || data.address || data.building_name || data.building_address) + (data.unit ? ', #' + data.unit : ''));
				this._bulb_name.set('href', data.url_listing || data.url || data.building_url);

				if (data.sqft) {
					this._bulb_size.set('html', 'Approx. ' + data.sqft + ' ft<sup>2</sup>');
				}
				// if (data.listing_added) {
				// 	this._bulb_created.set('text', 'Listed ' + data.listing_added);
				// }
				// if (data.listing_updated) {
				// 	this._bulb_updated.set('text', 'Updated ' + data.listing_updated);
				// }

				if (data.name || data.building_name) {
					if (data.address || data.building_address) {
						this._bulb_address.set('text', data.address || data.building_address);
					}
					if (data.url || data.building_url) {
						this._bulb_address.set('href', data.url_listing || data.url || data.building_url);
					}
					this._bulb_address.show();
				} else {
					this._bulb_address.hide();
				}

				if (this.options.isBuilding) {
					this._bulb.set('data-class', 'w_blimp_bld');
					this._bulb.set('href', data.url);

					new BlimpExt(this._bulb, {
						draggable: true,
						show_veil: true,
						onPostRpc: function onPostRpc() {
							new BldBlimp(this);
						}
					});
				}

				if (this._bulb_ppsqft && data["ppsqft"] != null) {
					this._bulb_ppsqft.set('html', '$' + Core.add_commas(data["ppsqft"]) + ' /ft<sup>2</sup>');
				} else {
					if (this._bulb_ppsqft) {
						this._bulb_ppsqft.setStyle('display', 'none');
					}
				}

				this._bulb_details.set('text', data.beds_baths);
				this.add_save_support(data);
			}

			var v_pos = _el.getStyle('height').toInt() + this._bulb.getElement('.pointer').getStyle('height').toInt() + this._element.getComputedSize().computedBottom + 1 /*border*/
			,
			    h_pos = _el.getCoordinates().left - this._element.getCoordinates().left - this._bulb.getStyle('width').toInt() / 2 - this._bulb.getStyle('padding-left').toInt() + _el.getCoordinates().width / 2;

			this._bulb.setStyles({
				'bottom': v_pos,
				'left': h_pos > 400 ? h_pos - 160 : h_pos + 160
			});
			if (h_pos > 400) {
				this._bulb.addClass('right-bulb');
			} else {
				this._bulb.removeClass('right-bulb');
			}

			this._bulb.show();
		}
	},

	add_listing_tile: function add_listing_tile(data) {
		// for listings
		if (!this.options.isBuilding) {
			if (this.listingTile) {
				// dont do anything if the user mouseover to the last active listing again
				if (this.listingTile.hasClass('_' + data.mask_id)) {
					return;
				}

				// remove the current save button
				this.listingTile.dispose();
			}

			if (data.listingTile) {
				data.listingTile.inject(this._bulb);
			} else {
				data.contact = '';
				data.listingTile = new Element('<cr-listing-tile', {
					'class': 'cr-listing-tile' + ' _' + data.mask_id,
					'data-rpc': data.url_v2,
					'data-open-blimp-on-click': true,
					'data-missing-image': this.options.missingImage,
					'data-rpc-save-to-profile': this.options.rpcSaveToProfile,
					'html': '<div class="hidden none obj-wrapper">' + JSONMOO.encode(data) + '</div>'
				}).inject(this._bulb);

				Core.compile_html(data.listingTile);
			}

			this.listingTile = data.listingTile;
		}
	},

	add_save_support: function add_save_support(data) {
		if (this.currentSaveButton) {
			var id = this.options.isBuilding ? data.building_id : data.mask_id;
			// dont do anything if the user mouseover to the last active listing again
			if (this.currentSaveButton.hasClass('_' + id)) {
				return;
			}
			// remove the current save button
			this.currentSaveButton.dispose();
		}

		this.currentSaveButton = data.crSaveToProfile;
	},

	bulb_hide: function bulb_hide() {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		this._bulb.hide();
	},

	add_scrolling: function add_scrolling() {
		this._arr_prev = new Element('.arr_prev');
		this._arr_next = new Element('.arr_next');

		this._columns = this._scroller.getElements('.column');
		this.current_col = 0;

		this._arr_prev.inject(this._chart);
		this._arr_next.inject(this._chart);

		this.animate = new Fx.Scroll(this._scroller, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.Quad.easeOut,
			onStart: function () {
				this.hide_locked_item();
			}.bind(this)
		});

		if (this._init_scroll) {
			this._columns.each(function (_el, i) {
				if (_el === this._init_scroll) {
					var half = Math.ceil(this.options.disp_col / 2);

					if (i < half) {
						this.current_col = 0;
						this._arr_prev.addClass('inactive');
					} else if (this._columns.length - i <= half) {
						this.current_col = this._columns.length - this.options.disp_col;
						this._arr_next.addClass('inactive');
					} else {
						this.current_col = i - half + 1;
					}
				}
			}.bind(this));
		} else {
			this._arr_prev.addClass('inactive');
			this.current_col = 0;
		}

		(function () {
			this.animate.toElement(this._columns[this.current_col]).chain(function () {
				this._arr_prev.addEvent('click', this.scroll_prev.bind(this));
				this._arr_next.addEvent('click', this.scroll_next.bind(this));
			}.bind(this));
			this.animate.setOptions({ duration: this.options.scroll_speed });
		}).bind(this).delay(2000);

		this.last = this._columns.length - this.options.disp_col;

		if (this.options.hscroll == true) {
			this.add_hscroll();
		}
	},

	animate_prices: function animate_prices() {
		if (!this.current_col) this.current_col = 0;

		var last_visible = Math.min(this.current_col + this.options.disp_col - 1, this._items.length - 1);
		var speed = 2000;

		this._items.each(function (_el, i) {
			var height = _el.getAttribute('data-height');

			if (i >= this.current_col && i <= last_visible) {
				var sc = speed * _el.getAttribute('data-price').toInt() / this.max_value,
				    //speed coefficient
				delay = (i >= this.current_col ? i - this.current_col : 0) * 100 + 100;

				(function () {
					var tween = new Fx.Morph(_el, { duration: sc, transition: Fx.Transitions.Bounce.easeOut });
					tween.start({ 'height': [0, height] });
				}).delay(delay);
			} else {
				(function () {
					_el.setStyle('height', height.toInt());
				}).delay(500);
			}
		}.bind(this));

		(function () {
			this.bubble_is_ready = true;

			if (this._indicator && this._indicator.hasClass('visible')) {
				this._indicator.fade('in');
			}
		}).bind(this).delay(speed);
	},

	scroll_prev: function scroll_prev() {
		var prev = this.current_col - this.options.scroll_at_a_time;

		if (prev > 0) {
			this.animate.toElement(this._columns[prev]);
			this.current_col -= this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[0]);
			this._arr_prev.addClass('inactive');
			this._ar_l.addClass('inactive');
			this.current_col = 0;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_next.removeClass('inactive');
		if (this._ar_r) {
			this._ar_r.removeClass('inactive');
		}
	},

	scroll_next: function scroll_next() {
		var next = this.current_col + this.options.scroll_at_a_time;

		if (next < this.last) {
			this.animate.toElement(this._columns[next]);
			this.current_col += this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[this.last]);
			this._arr_next.addClass('inactive');
			this._ar_r.addClass('inactive');
			this.current_col = this.last;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_prev.removeClass('inactive');
		if (this._ar_l) {
			this._ar_l.removeClass('inactive');
		}
	},

	add_functionalities: function add_functionalities() {
		var self = this;
		this._element.addEvents({
			'mouseenter': function mouseenter() {
				self._element.addClass('_hover');
			},
			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');
				self.hide_locked_item();
			}
		});
	},

	hide_locked_item: function hide_locked_item() {
		if (this.locked_item) {
			this.bulb_hide();
			this.locked_item.removeClass('_active');
		}
	}
});
'use strict';

Page.Nrp = new Class({
	Extends: Page,
	options: {
		imagestrip_options: {
			auto_move: false,
			stick_arrows: false
		}
	},

	build: function build() {

		this.parent();

		var _page_title = document.getElement('.page_title');
		if (_page_title) {
			this.hood_id = _page_title.get('data-region-id');
			this.nh_ids = [];

			if (Cookie.read('visited_region')) {
				this.nh_ids = Cookie.read('visited_region').split(',');
				this.nh_ids.include(this.nh_hood_idid);
			} else {
				this.nh_ids.push(this.hood_id);
			}

			Cookie.write('visited_region', this.nh_ids);
		}
		this.set_hero();
		this.set_hood_stats();
		this.set_maps();
		this.add_hoods_section_support();
		this.set_sponsor();
	},
	set_sponsor: function set_sponsor() {
		var _imagestrip = document.getElement('.sponsor_pub .w_imagestrip');

		if (!_imagestrip) return;

		new Imagestrip(_imagestrip, this.options.imagestrip_options);
	},
	set_hero: function set_hero() {
		var _hero = document.getElement('.hero');
		if (_hero) {
			var _card = _hero.getElement('.w_card');
			new Card(_card);
		}
	},

	set_hood_stats: function set_hood_stats() {

		var _hood_stats = document.getElement('.sales_data .section_content');
		if (!_hood_stats) return;

		var rpc = _hood_stats.get('data-rpc');

		var remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function () {
				var data = remote.get_data();

				if (data.content) {
					_hood_stats.set('html', data.content);

					new HoodStats(_hood_stats, {
						with_message: this.nh_ids.length <= 2,
						hood_id: this.hood_id
					});
				}
			}.bind(this)
		});
	},

	set_maps: function set_maps() {

		var _maps = document.getElement('.maps .section_content');

		if (!_maps) return;

		var rpc = _maps.get('data-rpc');

		// get previous state
		var pageId = $$('body')[0].getAttribute('id');
		var statesObj = new State();
		var previousState;
		// if the previous page is the lst page (listing page) then we check the cookie and restore the previous state
		if (this.previous_page_id === 'lst' && statesObj.states && statesObj.states[pageId]) {
			previousState = Object.clone(statesObj.states[pageId]);
		}
		// remove state from cookie
		statesObj.remove(pageId);

		var remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function () {
				var data = remote.get_data();

				if (data.content) {
					_maps.set('html', data.content);

					new MapMultipleView(_maps, {
						with_message: this.nh_ids.length <= 2 ? true : false,
						with_listing: true,
						with_expand: true,
						hood_id: this.hood_id,
						page_id: pageId,
						previous_state: previousState,
						page_context: 'regionMap',
						view: "fullscreen"
					});
				}
			}.bind(this)
		});
	},

	add_hoods_section_support: function add_hoods_section_support() {
		//NCR-3268
		var hood_row = document.getElement('.explore_hoods .row');
		var hood_items = hood_row.getElements('.item');

		if (hood_items.length === 0) {
			return;
		}

		var item_width = hood_items[0].getSize().x + 1;
		var _setSize = function _setSize() {
			var width = window.getSize().x;
			var min_width = hood_row.getStyle('min-width');

			//To stop setting the size when its less than the min-width
			if (min_width && width < min_width.toInt()) {
				return;
			}

			var valid_count = (width / item_width).toInt();
			var row_width = valid_count * item_width;

			// to make it center if we have less item to fill the full width of the window.
			if (row_width > item_width * hood_items.length) {
				row_width = item_width * hood_items.length;
			}

			hood_row.setStyle('width', row_width);

			var starting_point = valid_count;
			for (var i = 0; i < hood_items.length; i++) {
				if (i === starting_point) {
					hood_items[i].addClass('_no_border');
					starting_point += valid_count;
				} else {
					hood_items[i].removeClass('_no_border');
				}
			}
		};

		window.addEvents({
			resize: function resize() {
				_setSize();
			}
		});

		_setSize();
	}
});
//# sourceMappingURL=nrp.js.map
